(() => {
/**
 * Swiper 14.0.1
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2026 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: June 29, 2026
 */ function $3e0e2b092da8f124$export$db3b6bfb95261072(classes = '') {
    return classes.trim().split(' ').filter((c)=>!!c.trim());
}
function $3e0e2b092da8f124$export$4368d992c4eafac0(obj) {
    Object.keys(obj).forEach((key)=>{
        try {
            obj[key] = null;
        } catch  {
        // no getter for object
        }
        try {
            delete obj[key];
        } catch  {
        // something got wrong
        }
    });
}
function $3e0e2b092da8f124$export$625550452a3fa3ec(callback, delay = 0) {
    return setTimeout(callback, delay);
}
function $3e0e2b092da8f124$export$3b14a55fb2447963() {
    return Date.now();
}
function $3e0e2b092da8f124$var$getComputedStyle(el) {
    return window.getComputedStyle(el, null);
}
function $3e0e2b092da8f124$export$9e5f44173e64f162(el, axis = 'x') {
    const style = $3e0e2b092da8f124$var$getComputedStyle(el);
    const transform = style.transform || style.webkitTransform;
    if (!transform || transform === 'none') return 0;
    const matrix = new DOMMatrixReadOnly(transform);
    return axis === 'x' ? matrix.m41 : matrix.m42;
}
function $3e0e2b092da8f124$export$43caf9889c228507(o) {
    return typeof o === 'object' && o !== null && o.constructor === Object && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}
function $3e0e2b092da8f124$var$isNode(node) {
    if (typeof HTMLElement !== 'undefined' && node instanceof HTMLElement) return true;
    return !!node && typeof node === 'object' && (node.nodeType === 1 || node.nodeType === 11);
}
function $3e0e2b092da8f124$export$7ccc53e8f1e7dfc5(target, ...sources) {
    const to = Object(target);
    for(let i = 0; i < sources.length; i += 1){
        const nextSource = sources[i];
        if (nextSource === undefined || nextSource === null || $3e0e2b092da8f124$var$isNode(nextSource)) continue;
        const sourceObj = nextSource;
        const keysArray = Object.keys(Object(sourceObj)).filter((key)=>key !== '__proto__' && key !== 'constructor' && key !== 'prototype');
        for (const nextKey of keysArray){
            const desc = Object.getOwnPropertyDescriptor(sourceObj, nextKey);
            if (!desc || !desc.enumerable) continue;
            const sourceVal = sourceObj[nextKey];
            if ($3e0e2b092da8f124$export$43caf9889c228507(to[nextKey]) && $3e0e2b092da8f124$export$43caf9889c228507(sourceVal)) {
                if (sourceVal.__swiper__) to[nextKey] = sourceVal;
                else $3e0e2b092da8f124$export$7ccc53e8f1e7dfc5(to[nextKey], sourceVal);
            } else if (!$3e0e2b092da8f124$export$43caf9889c228507(to[nextKey]) && $3e0e2b092da8f124$export$43caf9889c228507(sourceVal)) {
                to[nextKey] = {};
                if (sourceVal.__swiper__) to[nextKey] = sourceVal;
                else $3e0e2b092da8f124$export$7ccc53e8f1e7dfc5(to[nextKey], sourceVal);
            } else to[nextKey] = sourceVal;
        }
    }
    return to;
}
function $3e0e2b092da8f124$export$90a7f3efeed30595(el, varName, varValue) {
    el.style.setProperty(varName, varValue);
}
function $3e0e2b092da8f124$export$ffb5f4729a158638(slideEl) {
    const direct = slideEl.querySelector('.swiper-slide-transform');
    if (direct) return direct;
    if (slideEl.shadowRoot) {
        const shadowed = slideEl.shadowRoot.querySelector('.swiper-slide-transform');
        if (shadowed) return shadowed;
    }
    return slideEl;
}
function $3e0e2b092da8f124$export$f1e1789686576879(element, selector = '') {
    const children = [
        ...element.children
    ];
    if (element instanceof HTMLSlotElement) children.push(...element.assignedElements());
    return selector ? children.filter((el)=>el.matches(selector)) : children;
}
function $3e0e2b092da8f124$var$elementIsChildOfSlot(el, slot) {
    const queue = [
        slot
    ];
    while(queue.length > 0){
        const cur = queue.shift();
        if (el === cur) return true;
        queue.push(...cur.children, ...cur.shadowRoot ? cur.shadowRoot.children : [], ...cur.assignedElements ? cur.assignedElements() : []);
    }
    return false;
}
function $3e0e2b092da8f124$export$2d1720544b23b823(el, parent) {
    let isChild = parent.contains(el);
    if (!isChild && parent instanceof HTMLSlotElement) {
        const children = [
            ...parent.assignedElements()
        ];
        isChild = children.includes(el);
        if (!isChild) isChild = $3e0e2b092da8f124$var$elementIsChildOfSlot(el, parent);
    }
    return isChild;
}
function $3e0e2b092da8f124$export$d141bba7fdc215a3(text) {
    try {
        console.warn(text);
    } catch  {
    // err
    }
}
function $3e0e2b092da8f124$export$407448d2b89b1813(tag, classes = []) {
    const el = document.createElement(tag);
    el.classList.add(...Array.isArray(classes) ? classes : $3e0e2b092da8f124$export$db3b6bfb95261072(classes));
    return el;
}
function $3e0e2b092da8f124$export$dda1d9f60106f0e9(el) {
    const box = el.getBoundingClientRect();
    return {
        top: box.top + window.scrollY - (el.clientTop || 0),
        left: box.left + window.scrollX - (el.clientLeft || 0)
    };
}
function $3e0e2b092da8f124$export$342063e11d6c3cad(el, selector) {
    const prevEls = [];
    let prev = el.previousElementSibling;
    while(prev){
        if (!selector || prev.matches(selector)) prevEls.push(prev);
        prev = prev.previousElementSibling;
    }
    return prevEls;
}
function $3e0e2b092da8f124$export$39b482c5e57630a8(el, selector) {
    const nextEls = [];
    let next = el.nextElementSibling;
    while(next){
        if (!selector || next.matches(selector)) nextEls.push(next);
        next = next.nextElementSibling;
    }
    return nextEls;
}
function $3e0e2b092da8f124$export$882b5998b3b9117c(el, prop) {
    return window.getComputedStyle(el, null).getPropertyValue(prop);
}
function $3e0e2b092da8f124$export$8b22cf2602fb60ce(el) {
    if (!el || !el.parentNode) return undefined;
    return [
        ...el.parentNode.children
    ].indexOf(el);
}
function $3e0e2b092da8f124$export$35e795649ee09318(el, selector) {
    const parents = [];
    let parent = el.parentElement;
    while(parent){
        if (!selector || parent.matches(selector)) parents.push(parent);
        parent = parent.parentElement;
    }
    return parents;
}
function $3e0e2b092da8f124$export$953cecd6e717a553(el, callback) {
    if (!callback) return;
    el.addEventListener('transitionend', function fireCallBack(e) {
        if (e.target !== el) return;
        callback.call(el, e);
    }, {
        once: true
    });
}
function $3e0e2b092da8f124$export$23f2a1d2818174ef(el, size, includeMargins) {
    {
        const style = window.getComputedStyle(el, null);
        return el[size === 'width' ? 'offsetWidth' : 'offsetHeight'] + parseFloat(style.getPropertyValue(size === 'width' ? 'margin-right' : 'margin-top')) + parseFloat(style.getPropertyValue(size === 'width' ? 'margin-left' : 'margin-bottom'));
    }
}
function $3e0e2b092da8f124$export$2408f22a0fab9ae5(el) {
    return (Array.isArray(el) ? el : [
        el
    ]).filter((e)=>!!e);
}
function $3e0e2b092da8f124$export$ae1af26003f05816(swiper) {
    return (v)=>{
        if (Math.abs(v) > 0 && swiper.browser && swiper.browser.need3dFix && Math.abs(v) % 90 === 0) return v + 0.001;
        return v;
    };
}
function $3e0e2b092da8f124$export$efccba1c4a2ef57b(el, html = '') {
    const tt = globalThis.trustedTypes;
    if (typeof tt !== 'undefined') el.innerHTML = tt.createPolicy('html', {
        createHTML: (s)=>s
    }).createHTML(html);
    else el.innerHTML = html;
}


let $6946bfb4689eabba$var$supportCached;
function $6946bfb4689eabba$var$calcSupport() {
    if (typeof window === 'undefined') return {
        touch: false
    };
    return {
        touch: 'ontouchstart' in window || navigator.maxTouchPoints > 0
    };
}
function $6946bfb4689eabba$var$getSupport() {
    if (!$6946bfb4689eabba$var$supportCached) $6946bfb4689eabba$var$supportCached = $6946bfb4689eabba$var$calcSupport();
    return $6946bfb4689eabba$var$supportCached;
}
let $6946bfb4689eabba$var$deviceCached;
function $6946bfb4689eabba$var$calcDevice({ userAgent: userAgent } = {}) {
    if (typeof window === 'undefined') return {
        ios: false,
        android: false
    };
    const support = $6946bfb4689eabba$var$getSupport();
    const platform = navigator.platform;
    const ua = userAgent || navigator.userAgent;
    const device = {
        ios: false,
        android: false
    };
    const isAndroid = /(Android);?[\s/]+([\d.]+)?/.test(ua);
    const isIPhoneOrIPod = /(iPhone\sOS|iOS|iPod)/.test(ua);
    const isIPadDirect = /iPad/.test(ua);
    // iPad on iPadOS 13+ reports as MacIntel; distinguish from a real Mac by touch capability.
    const isIPadMasquerade = platform === 'MacIntel' && support.touch && navigator.maxTouchPoints > 1;
    const isIPad = isIPadDirect || isIPadMasquerade;
    const isWindows = platform === 'Win32';
    if (isAndroid && !isWindows) {
        device.os = 'android';
        device.android = true;
    }
    if (isIPad || isIPhoneOrIPod) {
        device.os = 'ios';
        device.ios = true;
    }
    return device;
}
function $6946bfb4689eabba$var$getDevice(overrides = {}) {
    if (!$6946bfb4689eabba$var$deviceCached) $6946bfb4689eabba$var$deviceCached = $6946bfb4689eabba$var$calcDevice(overrides);
    return $6946bfb4689eabba$var$deviceCached;
}
let $6946bfb4689eabba$var$browserCached;
function $6946bfb4689eabba$var$calcBrowser() {
    if (typeof window === 'undefined') return {
        isSafari: false,
        isWebView: false,
        need3dFix: false
    };
    const device = $6946bfb4689eabba$var$getDevice();
    const ua = navigator.userAgent;
    const uaLower = ua.toLowerCase();
    const isSafari = uaLower.includes('safari') && !uaLower.includes('chrome') && !uaLower.includes('android');
    const isWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(ua);
    // 3D transform glitches still affect iOS WebView and Safari at the baseline (16.4+).
    const need3dFix = isSafari || isWebView && device.ios;
    return {
        isSafari: isSafari,
        isWebView: isWebView,
        need3dFix: need3dFix
    };
}
function $6946bfb4689eabba$var$getBrowser() {
    if (!$6946bfb4689eabba$var$browserCached) $6946bfb4689eabba$var$browserCached = $6946bfb4689eabba$var$calcBrowser();
    return $6946bfb4689eabba$var$browserCached;
}
const $6946bfb4689eabba$var$processLazyPreloader = (swiper, imageEl)=>{
    if (!swiper || swiper.destroyed || !swiper.params) return;
    const slideSelector = ()=>swiper.isElement ? 'swiper-slide' : `.${swiper.params.slideClass}`;
    const slideEl = imageEl.closest(slideSelector());
    if (slideEl) {
        let lazyEl = slideEl.querySelector(`.${swiper.params.lazyPreloaderClass}`);
        if (!lazyEl && swiper.isElement) {
            if (slideEl.shadowRoot) lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
            else requestAnimationFrame(()=>{
                if (slideEl.shadowRoot) {
                    const innerLazy = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
                    if (innerLazy && !innerLazy.lazyPreloaderManaged) innerLazy.remove();
                }
            });
        }
        if (lazyEl && !lazyEl.lazyPreloaderManaged) lazyEl.remove();
    }
};
const $6946bfb4689eabba$var$unlazy = (swiper, index)=>{
    if (!swiper.slides[index]) return;
    const imageEl = swiper.slides[index].querySelector('[loading="lazy"]');
    if (imageEl) imageEl.removeAttribute('loading');
};
const $6946bfb4689eabba$var$preload = (swiper)=>{
    if (!swiper || swiper.destroyed || !swiper.params) return;
    let amount = swiper.params.lazyPreloadPrevNext;
    const len = swiper.slides.length;
    if (!len || !amount || amount < 0) return;
    amount = Math.min(amount, len);
    const slidesPerView = swiper.params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : Math.ceil(swiper.params.slidesPerView);
    const activeIndex = swiper.activeIndex;
    if (swiper.params.grid && (swiper.params.grid.rows ?? 1) > 1) {
        const activeColumn = activeIndex;
        const preloadColumns = [
            activeColumn - amount
        ];
        preloadColumns.push(...Array.from({
            length: amount
        }).map((_, i)=>activeColumn + slidesPerView + i));
        swiper.slides.forEach((slideEl, i)=>{
            if (slideEl.column !== undefined && preloadColumns.includes(slideEl.column)) $6946bfb4689eabba$var$unlazy(swiper, i);
        });
        return;
    }
    const slideIndexLastInView = activeIndex + slidesPerView - 1;
    if (swiper.params.rewind || swiper.params.loop) for(let i = activeIndex - amount; i <= slideIndexLastInView + amount; i += 1){
        const realIndex = (i % len + len) % len;
        if (realIndex < activeIndex || realIndex > slideIndexLastInView) $6946bfb4689eabba$var$unlazy(swiper, realIndex);
    }
    else {
        for(let i = Math.max(activeIndex - amount, 0); i <= Math.min(slideIndexLastInView + amount, len - 1); i += 1)if (i !== activeIndex && (i > slideIndexLastInView || i < activeIndex)) $6946bfb4689eabba$var$unlazy(swiper, i);
    }
};
function $6946bfb4689eabba$var$getBreakpoint(breakpoints, base = 'window', containerEl) {
    if (!breakpoints || base === 'container' && !containerEl) return undefined;
    let breakpoint = false;
    const currentHeight = base === 'window' ? window.innerHeight : containerEl.clientHeight;
    const points = Object.keys(breakpoints).map((point)=>{
        if (typeof point === 'string' && point.indexOf('@') === 0) {
            const minRatio = parseFloat(point.substr(1));
            const value = currentHeight * minRatio;
            return {
                value: value,
                point: point
            };
        }
        return {
            value: point,
            point: point
        };
    });
    points.sort((a, b)=>parseInt(String(a.value), 10) - parseInt(String(b.value), 10));
    for(let i = 0; i < points.length; i += 1){
        const { point: point, value: value } = points[i];
        if (base === 'window') {
            if (window.matchMedia(`(min-width: ${value}px)`).matches) breakpoint = point;
        } else if (value <= containerEl.clientWidth) breakpoint = point;
    }
    return breakpoint || 'max';
}
const $6946bfb4689eabba$var$isGridEnabled = (swiper, params)=>{
    return !!(swiper.grid && params.grid && params.grid.rows > 1);
};
function $6946bfb4689eabba$var$setBreakpoint() {
    const swiper = this;
    const { realIndex: realIndex, initialized: initialized, params: params, el: el } = swiper;
    const breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return;
    // Get breakpoint for window/container width and update parameters
    const breakpointsBase = params.breakpointsBase === 'window' || !params.breakpointsBase ? params.breakpointsBase : 'container';
    const breakpointContainer = [
        'window',
        'container'
    ].includes(params.breakpointsBase) || !params.breakpointsBase ? swiper.el : document.querySelector(params.breakpointsBase);
    const breakpoint = swiper.getBreakpoint(breakpoints, breakpointsBase, breakpointContainer);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
    const breakpointsRecord = breakpoints;
    const breakpointOnlyParams = breakpoint in breakpointsRecord ? breakpointsRecord[breakpoint] : undefined;
    const breakpointParams = breakpointOnlyParams || swiper.originalParams;
    const wasMultiRow = $6946bfb4689eabba$var$isGridEnabled(swiper, params);
    const isMultiRow = $6946bfb4689eabba$var$isGridEnabled(swiper, breakpointParams);
    const wasGrabCursor = swiper.params.grabCursor;
    const isGrabCursor = breakpointParams.grabCursor;
    const wasEnabled = params.enabled;
    if (wasMultiRow && !isMultiRow) {
        el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
        el.classList.add(`${params.containerModifierClass}grid`);
        if (breakpointParams.grid.fill && breakpointParams.grid.fill === 'column' || !breakpointParams.grid.fill && params.grid.fill === 'column') el.classList.add(`${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    }
    if (wasGrabCursor && !isGrabCursor) swiper.unsetGrabCursor();
    else if (!wasGrabCursor && isGrabCursor) swiper.setGrabCursor();
    const moduleOpt = (opts, prop)=>opts[prop];
    [
        'navigation',
        'pagination',
        'scrollbar'
    ].forEach((prop)=>{
        const bpOpts = moduleOpt(breakpointParams, prop);
        if (typeof bpOpts === 'undefined') return;
        const paramsOpts = moduleOpt(params, prop);
        const wasModuleEnabled = typeof paramsOpts === 'object' && paramsOpts !== null && paramsOpts.enabled;
        const isModuleEnabled = typeof bpOpts === 'object' && bpOpts !== null && bpOpts.enabled;
        const moduleApi = swiper[prop];
        if (wasModuleEnabled && !isModuleEnabled) moduleApi?.disable?.();
        if (!wasModuleEnabled && isModuleEnabled) moduleApi?.enable?.();
    });
    const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
    const wasLoop = params.loop;
    if (directionChanged && initialized) swiper.changeDirection();
    (0, $3e0e2b092da8f124$export$7ccc53e8f1e7dfc5)(swiper.params, breakpointParams);
    const isEnabled = swiper.params.enabled;
    const hasLoop = swiper.params.loop;
    Object.assign(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev
    });
    if (wasEnabled && !isEnabled) swiper.disable();
    else if (!wasEnabled && isEnabled) swiper.enable();
    swiper.currentBreakpoint = breakpoint;
    swiper.emit('_beforeBreakpoint', breakpointParams);
    if (initialized) {
        if (needsReLoop) {
            swiper.loopDestroy();
            swiper.loopCreate(realIndex);
            swiper.updateSlides();
        } else if (!wasLoop && hasLoop) {
            swiper.loopCreate(realIndex);
            swiper.updateSlides();
        } else if (wasLoop && !hasLoop) swiper.loopDestroy();
    }
    swiper.emit('breakpoint', breakpointParams);
}
var $6946bfb4689eabba$var$breakpoints = {
    setBreakpoint: $6946bfb4689eabba$var$setBreakpoint,
    getBreakpoint: $6946bfb4689eabba$var$getBreakpoint
};
function $6946bfb4689eabba$var$checkOverflow() {
    const swiper = this;
    const { isLocked: wasLocked, params: params } = swiper;
    const { slidesOffsetBefore: slidesOffsetBefore } = params;
    if (slidesOffsetBefore) {
        const lastSlideIndex = swiper.slides.length - 1;
        const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
        swiper.isLocked = swiper.size > lastSlideRightEdge;
    } else swiper.isLocked = swiper.snapGrid.length === 1;
    if (params.allowSlideNext === true) swiper.allowSlideNext = !swiper.isLocked;
    if (params.allowSlidePrev === true) swiper.allowSlidePrev = !swiper.isLocked;
    if (wasLocked && wasLocked !== swiper.isLocked) swiper.isEnd = false;
    if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
}
var $6946bfb4689eabba$var$checkOverflow$1 = {
    checkOverflow: $6946bfb4689eabba$var$checkOverflow
};
function $6946bfb4689eabba$var$prepareClasses(entries, prefix) {
    const resultClasses = [];
    entries.forEach((item)=>{
        if (typeof item === 'object') Object.keys(item).forEach((classNames)=>{
            if (item[classNames]) resultClasses.push(prefix + classNames);
        });
        else if (typeof item === 'string') resultClasses.push(prefix + item);
    });
    return resultClasses;
}
function $6946bfb4689eabba$var$addClasses() {
    const swiper = this;
    const { classNames: classNames, params: params, rtl: rtl, el: el, device: device } = swiper;
    // oxfmt-ignore
    const suffixes = $6946bfb4689eabba$var$prepareClasses([
        'initialized',
        params.direction,
        {
            'free-mode': swiper.params.freeMode && params.freeMode.enabled
        },
        {
            'autoheight': params.autoHeight
        },
        {
            'rtl': rtl
        },
        {
            'grid': params.grid && params.grid.rows > 1
        },
        {
            'grid-column': params.grid && params.grid.rows > 1 && params.grid.fill === 'column'
        },
        {
            'android': device.android
        },
        {
            'ios': device.ios
        },
        {
            'css-mode': params.cssMode
        },
        {
            'centered': params.cssMode && params.centeredSlides
        },
        {
            'watch-progress': params.watchSlidesProgress
        }
    ], params.containerModifierClass);
    classNames.push(...suffixes);
    el.classList.add(...classNames);
    swiper.emitContainerClasses();
}
function $6946bfb4689eabba$var$removeClasses() {
    const swiper = this;
    const { el: el, classNames: classNames } = swiper;
    if (!el || typeof el === 'string') return;
    el.classList.remove(...classNames);
    swiper.emitContainerClasses();
}
var $6946bfb4689eabba$var$classes = {
    addClasses: $6946bfb4689eabba$var$addClasses,
    removeClasses: $6946bfb4689eabba$var$removeClasses
};
const $6946bfb4689eabba$export$4368d992c4eafac0 = {
    init: true,
    direction: 'horizontal',
    oneWayMovement: false,
    swiperElementNodeName: 'SWIPER-CONTAINER',
    touchEventsTarget: 'wrapper',
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: true,
    nested: false,
    createElements: false,
    eventsPrefix: 'swiper',
    enabled: true,
    focusableElements: 'input, select, option, textarea, button, video, label',
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: 'slide',
    // Breakpoints
    breakpoints: undefined,
    breakpointsBase: 'window',
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 0,
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    snapToSlideEdge: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: true,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 5,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // loop
    loop: false,
    loopAddBlankSlides: true,
    loopAdditionalSlides: 0,
    loopPreventsSliding: true,
    // rewind
    rewind: false,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    noSwiping: true,
    noSwipingClass: 'swiper-no-swiping',
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    maxBackfaceHiddenSlides: 10,
    // NS
    containerModifierClass: 'swiper-',
    slideClass: 'swiper-slide',
    slideBlankClass: 'swiper-slide-blank',
    slideActiveClass: 'swiper-slide-active',
    slideVisibleClass: 'swiper-slide-visible',
    slideFullyVisibleClass: 'swiper-slide-fully-visible',
    slideNextClass: 'swiper-slide-next',
    slidePrevClass: 'swiper-slide-prev',
    wrapperClass: 'swiper-wrapper',
    lazyPreloaderClass: 'swiper-lazy-preloader',
    lazyPreloadPrevNext: 0,
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false
};
var $6946bfb4689eabba$var$eventsEmitter = {
    on (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        const method = priority ? 'unshift' : 'push';
        events.split(' ').forEach((event)=>{
            if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
            self.eventsListeners[event][method](handler);
        });
        return self;
    },
    once (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        const onceHandler = function onceHandlerFn(...args) {
            self.off(events, onceHandler);
            if (onceHandler.__emitterProxy) delete onceHandler.__emitterProxy;
            handler.apply(self, args);
        };
        onceHandler.__emitterProxy = handler;
        return self.on(events, onceHandler, priority);
    },
    onAny (handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        const method = priority ? 'unshift' : 'push';
        if (self.eventsAnyListeners.indexOf(handler) < 0) self.eventsAnyListeners[method](handler);
        return self;
    },
    offAny (handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsAnyListeners) return self;
        const index = self.eventsAnyListeners.indexOf(handler);
        if (index >= 0) self.eventsAnyListeners.splice(index, 1);
        return self;
    },
    off (events, handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        events.split(' ').forEach((event)=>{
            if (typeof handler === 'undefined') self.eventsListeners[event] = [];
            else if (self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler, index)=>{
                if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) self.eventsListeners[event].splice(index, 1);
            });
        });
        return self;
    },
    emit (...args) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        let events;
        let data;
        let context;
        if (typeof args[0] === 'string' || Array.isArray(args[0])) {
            events = args[0];
            data = args.slice(1, args.length);
            context = self;
        } else {
            const opts = args[0];
            events = opts.events;
            data = opts.data ?? [];
            context = opts.context || self;
        }
        data.unshift(context);
        const eventsArray = Array.isArray(events) ? events : events.split(' ');
        eventsArray.forEach((event)=>{
            if (self.eventsAnyListeners && self.eventsAnyListeners.length) self.eventsAnyListeners.forEach((eventHandler)=>{
                eventHandler.apply(context, [
                    event,
                    ...data
                ]);
            });
            if (self.eventsListeners && self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler)=>{
                eventHandler.apply(context, data);
            });
        });
        return self;
    }
};
function $6946bfb4689eabba$var$onClick(e) {
    const swiper = this;
    if (swiper.destroyed) return;
    if (!swiper.enabled) return;
    if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }
}
function $6946bfb4689eabba$var$onDocumentTouchStart() {
    const swiper = this;
    if (swiper.destroyed) return;
    if (swiper.documentTouchHandlerProceeded) return;
    swiper.documentTouchHandlerProceeded = true;
    if (swiper.params.touchReleaseOnEdges) swiper.el.style.touchAction = 'auto';
}
function $6946bfb4689eabba$var$onLoad(e) {
    const swiper = this;
    if (swiper.destroyed) return;
    $6946bfb4689eabba$var$processLazyPreloader(swiper, e.target);
    if (swiper.params.cssMode || swiper.params.slidesPerView !== 'auto' && !swiper.params.autoHeight) return;
    swiper.update();
}
function $6946bfb4689eabba$var$onResize() {
    const swiper = this;
    const { params: params, el: el } = swiper;
    if (el && el.offsetWidth === 0) return;
    // Breakpoints
    if (params.breakpoints) swiper.setBreakpoint();
    // Save locks
    const { allowSlideNext: allowSlideNext, allowSlidePrev: allowSlidePrev, snapGrid: snapGrid } = swiper;
    const isVirtual = swiper.virtual && swiper.params.virtual?.enabled;
    // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    const isVirtualLoop = isVirtual && params.loop;
    if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides && !isVirtualLoop) {
        const slidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
        swiper.slideTo(slidesLength - 1, 0, false, true);
    } else if (swiper.params.loop && !isVirtual) swiper.slideToLoop(swiper.realIndex, 0, false, true);
    else swiper.slideTo(swiper.activeIndex, 0, false, true);
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
        const autoplay = swiper.autoplay;
        clearTimeout(autoplay.resizeTimeout);
        autoplay.resizeTimeout = setTimeout(()=>{
            if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) swiper.autoplay.resume();
        }, 500);
    }
    // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
}
function $6946bfb4689eabba$var$onScroll() {
    const swiper = this;
    if (swiper.destroyed) return;
    const { wrapperEl: wrapperEl, rtlTranslate: rtlTranslate, enabled: enabled } = swiper;
    if (!enabled) return;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) swiper.translate = -wrapperEl.scrollLeft;
    else swiper.translate = -wrapperEl.scrollTop;
    if (swiper.translate === 0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== swiper.progress) swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    swiper.emit('setTranslate', swiper.translate, false);
}
function $6946bfb4689eabba$var$onTouchEnd(event) {
    const swiper = this;
    if (swiper.destroyed) return;
    const data = swiper.touchEventsData;
    let e = event.originalEvent ?? event;
    const isTouchEvent = e.type === 'touchend' || e.type === 'touchcancel';
    if (!isTouchEvent) {
        if (data.touchId !== null) return; // return from pointer if we use touch
        const pe = e;
        if (pe.pointerId !== data.pointerId) return;
    } else {
        const te = e;
        const found = [
            ...te.changedTouches
        ].find((t)=>t.identifier === data.touchId);
        if (!found || found.identifier !== data.touchId) return;
    }
    if ([
        'pointercancel',
        'pointerout',
        'pointerleave',
        'contextmenu'
    ].includes(e.type)) {
        const proceed = [
            'pointercancel',
            'contextmenu'
        ].includes(e.type) && (swiper.browser.isSafari || swiper.browser.isWebView);
        if (!proceed) return;
    }
    data.pointerId = null;
    data.touchId = null;
    const { params: params, touches: touches, rtlTranslate: rtl, slidesGrid: slidesGrid, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && e.pointerType === 'mouse') return;
    if (data.allowTouchCallbacks) swiper.emit('touchEnd', e);
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) swiper.setGrabCursor(false);
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(false);
    // Time diff
    const touchEndTime = (0, $3e0e2b092da8f124$export$3b14a55fb2447963)();
    const timeDiff = touchEndTime - data.touchStartTime;
    // Tap, doubleTap, Click
    if (swiper.allowClick) {
        // Legacy `e.path` was a non-standard Chrome extension; `composedPath()` is the modern API.
        const pathTree = e.path ?? (e.composedPath && e.composedPath());
        swiper.updateClickedSlide(pathTree && pathTree[0], pathTree);
        swiper.emit('tap click', e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) swiper.emit('doubleTap doubleClick', e);
    }
    data.lastClickTime = (0, $3e0e2b092da8f124$export$3b14a55fb2447963)();
    (0, $3e0e2b092da8f124$export$625550452a3fa3ec)(()=>{
        if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 && !data.loopSwapReset || data.currentTranslate === data.startTranslate && !data.loopSwapReset) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    let currentPos;
    if (params.followFinger) currentPos = rtl ? swiper.translate : -swiper.translate;
    else currentPos = -(data.currentTranslate ?? 0);
    if (params.cssMode) return;
    if (params.freeMode && params.freeMode.enabled) {
        swiper.freeMode.onTouchEnd({
            currentPos: currentPos
        });
        return;
    }
    // Find current slide
    const swipeToLast = currentPos >= -swiper.maxTranslate() && !swiper.params.loop;
    let stopIndex = 0;
    let groupSize = swiper.slidesSizesGrid[0];
    for(let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup){
        const increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + increment] !== 'undefined') {
            if (swipeToLast || currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
                stopIndex = i;
                groupSize = slidesGrid[i + increment] - slidesGrid[i];
            }
        } else if (swipeToLast || currentPos >= slidesGrid[i]) {
            stopIndex = i;
            groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
    }
    let rewindFirstIndex = null;
    let rewindLastIndex = null;
    if (params.rewind) {
        if (swiper.isBeginning) rewindLastIndex = params.virtual?.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        else if (swiper.isEnd) rewindFirstIndex = 0;
    }
    // Find current slide size
    const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (swiper.swipeDirection === 'next') {
            if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);
            else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === 'prev') {
            if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);
            else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) swiper.slideTo(rewindLastIndex);
            else swiper.slideTo(stopIndex);
        }
    } else {
        // Short swipes
        if (!params.shortSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
            if (swiper.swipeDirection === 'next') swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
            if (swiper.swipeDirection === 'prev') swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
        } else if (e.target === swiper.navigation.nextEl) swiper.slideTo(stopIndex + increment);
        else swiper.slideTo(stopIndex);
    }
}
function $6946bfb4689eabba$var$onTouchMove(event) {
    const swiper = this;
    if (swiper.destroyed) return;
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, rtlTranslate: rtl, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && event.pointerType === 'mouse') return;
    // Legacy event wrappers nest the native event under .originalEvent.
    const wrapped = event;
    const e = wrapped.originalEvent ?? wrapped;
    if (e.type === 'pointermove') {
        if (data.touchId !== null) return; // return from pointer if we use touch
        const pe = e;
        if (pe.pointerId !== data.pointerId) return;
    }
    let targetTouch;
    if (e.type === 'touchmove') {
        const te = e;
        const found = [
            ...te.changedTouches
        ].find((t)=>t.identifier === data.touchId);
        if (!found || found.identifier !== data.touchId) return;
        targetTouch = found;
    } else targetTouch = e;
    if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) swiper.emit('touchMoveOpposite', e);
        return;
    }
    const pageX = targetTouch.pageX;
    const pageY = targetTouch.pageY;
    if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
    }
    if (!swiper.allowTouchMove) {
        if (!e.target.matches(data.focusableElements)) swiper.allowClick = false;
        if (data.isTouched) {
            Object.assign(touches, {
                startX: pageX,
                startY: pageY,
                currentX: pageX,
                currentY: pageY
            });
            data.touchStartTime = (0, $3e0e2b092da8f124$export$3b14a55fb2447963)();
        }
        return;
    }
    if (params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) // Vertical
        {
            if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
                data.isTouched = false;
                data.isMoved = false;
                return;
            }
        } else if (rtl && (pageX > touches.startX && -swiper.translate <= swiper.maxTranslate() || pageX < touches.startX && -swiper.translate >= swiper.minTranslate())) return;
        else if (!rtl && (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate())) return;
    }
    if (document.activeElement && document.activeElement.matches(data.focusableElements) && document.activeElement !== e.target && e.pointerType !== 'mouse') document.activeElement.blur();
    if (document.activeElement) {
        if (e.target === document.activeElement && e.target.matches(data.focusableElements)) {
            data.isMoved = true;
            swiper.allowClick = false;
            return;
        }
    }
    if (data.allowTouchCallbacks) swiper.emit('touchMove', e);
    touches.previousX = touches.currentX;
    touches.previousY = touches.currentY;
    touches.currentX = pageX;
    touches.currentY = pageY;
    const diffX = touches.currentX - touches.startX;
    const diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;
    if (typeof data.isScrolling === 'undefined') {
        let touchAngle;
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) data.isScrolling = false;
        else if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
    }
    if (data.isScrolling) swiper.emit('touchMoveOpposite', e);
    if (typeof data.startMoving === 'undefined') {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) data.startMoving = true;
    }
    if (data.isScrolling || e.type === 'touchmove' && data.preventTouchMoveFromPointerMove) {
        data.isTouched = false;
        return;
    }
    if (!data.startMoving) return;
    swiper.allowClick = false;
    if (!params.cssMode && e.cancelable) e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) e.stopPropagation();
    let diff = swiper.isHorizontal() ? diffX : diffY;
    let touchesDiff = swiper.isHorizontal() ? touches.currentX - touches.previousX : touches.currentY - touches.previousY;
    if (params.oneWayMovement) {
        diff = Math.abs(diff) * (rtl ? 1 : -1);
        touchesDiff = Math.abs(touchesDiff) * (rtl ? 1 : -1);
    }
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) {
        diff = -diff;
        touchesDiff = -touchesDiff;
    }
    const prevTouchesDirection = swiper.touchesDirection;
    swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
    swiper.touchesDirection = touchesDiff > 0 ? 'prev' : 'next';
    const isLoop = swiper.params.loop && !params.cssMode;
    const allowLoopFix = swiper.touchesDirection === 'next' && swiper.allowSlideNext || swiper.touchesDirection === 'prev' && swiper.allowSlidePrev;
    if (!data.isMoved) {
        if (isLoop && allowLoopFix) swiper.loopFix({
            direction: swiper.swipeDirection
        });
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) {
            const evt = new window.CustomEvent('transitionend', {
                bubbles: true,
                cancelable: true,
                detail: {
                    bySwiperTouchMove: true
                }
            });
            swiper.wrapperEl.dispatchEvent(evt);
        }
        data.allowMomentumBounce = false;
        // Grab Cursor
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(true);
        swiper.emit('sliderFirstMove', e);
    }
    new Date().getTime();
    if (params._loopSwapReset !== false && data.isMoved && data.allowThresholdMove && prevTouchesDirection !== swiper.touchesDirection && isLoop && allowLoopFix && Math.abs(diff) >= 1) {
        Object.assign(touches, {
            startX: pageX,
            startY: pageY,
            currentX: pageX,
            currentY: pageY,
            startTranslate: data.currentTranslate
        });
        data.loopSwapReset = true;
        data.startTranslate = data.currentTranslate;
        return;
    }
    swiper.emit('sliderMove', e);
    data.isMoved = true;
    // startTranslate is guaranteed to be set by this point (set in onTouchStart-side init).
    const startTranslate = data.startTranslate ?? 0;
    data.currentTranslate = diff + startTranslate;
    let disableParentSwiper = true;
    let resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) resistanceRatio = 0;
    if (diff > 0) {
        if (isLoop && allowLoopFix && true && data.allowThresholdMove && data.currentTranslate > (params.centeredSlides ? swiper.minTranslate() - swiper.slidesSizesGrid[swiper.activeIndex + 1] - (params.slidesPerView !== 'auto' && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.activeIndex + 1] + swiper.params.spaceBetween : 0) - swiper.params.spaceBetween : swiper.minTranslate())) swiper.loopFix({
            direction: 'prev',
            setTranslate: true,
            activeSlideIndex: 0
        });
        if (data.currentTranslate > swiper.minTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + startTranslate + diff) ** resistanceRatio;
        }
    } else if (diff < 0) {
        if (isLoop && allowLoopFix && true && data.allowThresholdMove && data.currentTranslate < (params.centeredSlides ? swiper.maxTranslate() + swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween + (params.slidesPerView !== 'auto' && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween : 0) : swiper.maxTranslate())) swiper.loopFix({
            direction: 'next',
            setTranslate: true,
            activeSlideIndex: swiper.slides.length - (params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(String(params.slidesPerView))))
        });
        if (data.currentTranslate < swiper.maxTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - startTranslate - diff) ** resistanceRatio;
        }
    }
    if (disableParentSwiper) e.preventedByNestedSwiper = true;
    // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && (data.currentTranslate ?? 0) < startTranslate) data.currentTranslate = startTranslate;
    if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && (data.currentTranslate ?? 0) > startTranslate) data.currentTranslate = startTranslate;
    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) data.currentTranslate = startTranslate;
    // Threshold
    if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
            if (!data.allowThresholdMove) {
                data.allowThresholdMove = true;
                touches.startX = touches.currentX;
                touches.startY = touches.currentY;
                data.currentTranslate = data.startTranslate;
                touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
                return;
            }
        } else {
            data.currentTranslate = data.startTranslate;
            return;
        }
    }
    if (!params.followFinger || params.cssMode) return;
    // Update active index in free mode
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode) swiper.freeMode.onTouchMove();
    // Update progress
    swiper.updateProgress(data.currentTranslate);
    // Update translate
    swiper.setTranslate(data.currentTranslate ?? 0);
}
// Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd
function $6946bfb4689eabba$var$closestElement(selector, base) {
    function __closestFrom(el) {
        if (!el || el === document || el === window) return null;
        let cur = el;
        if (cur.assignedSlot) cur = cur.assignedSlot;
        const found = cur.closest(selector);
        if (!found && !cur.getRootNode) return null;
        const root = cur.getRootNode();
        return found || __closestFrom(root.host);
    }
    return __closestFrom(base);
}
function $6946bfb4689eabba$var$preventEdgeSwipe(swiper, event, startX) {
    const { params: params } = swiper;
    const edgeSwipeDetection = params.edgeSwipeDetection;
    const edgeSwipeThreshold = params.edgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
        if (edgeSwipeDetection === 'prevent') {
            event.preventDefault();
            return true;
        }
        return false;
    }
    return true;
}
function $6946bfb4689eabba$var$onTouchStart(event) {
    const swiper = this;
    if (swiper.destroyed) return;
    const e = event.originalEvent ?? event;
    const data = swiper.touchEventsData;
    if (e.type === 'pointerdown') {
        const pe = e;
        if (data.pointerId !== null && data.pointerId !== pe.pointerId) return;
        data.pointerId = pe.pointerId;
    } else if (e.type === 'touchstart' && e.targetTouches.length === 1) data.touchId = e.targetTouches[0].identifier;
    if (e.type === 'touchstart') {
        // don't proceed touch event
        $6946bfb4689eabba$var$preventEdgeSwipe(swiper, e, e.targetTouches[0].pageX);
        return;
    }
    const { params: params, touches: touches, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && e.pointerType === 'mouse') return;
    if (swiper.animating && params.preventInteractionOnTransition) return;
    if (!swiper.animating && params.cssMode && params.loop) swiper.loopFix();
    let targetEl = e.target;
    if (params.touchEventsTarget === 'wrapper') {
        if (!(0, $3e0e2b092da8f124$export$2d1720544b23b823)(targetEl, swiper.wrapperEl)) return;
    }
    // Secondary mouse buttons (right-click / middle-click) shouldn't start a swipe.
    const mouseLike = e;
    if (typeof mouseLike.which === 'number' && mouseLike.which === 3) return;
    if (typeof mouseLike.button === 'number' && mouseLike.button > 0) return;
    if (data.isTouched && data.isMoved) return;
    // change target el for shadow root component
    const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== '';
    // `path` is a non-standard Chrome extension; `composedPath()` is the modern API.
    const eventPath = e.composedPath ? e.composedPath() : e.path;
    if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) targetEl = eventPath[0];
    const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
    const isTargetShadow = !!(e.target && e.target.shadowRoot);
    // use closestElement for shadow root element to get the actual closest for nested shadow root element
    if (params.noSwiping && (isTargetShadow ? $6946bfb4689eabba$var$closestElement(noSwipingSelector, targetEl) : targetEl.closest(noSwipingSelector))) {
        swiper.allowClick = true;
        return;
    }
    if (params.swipeHandler) {
        if (typeof params.swipeHandler === 'string' && !targetEl.closest(params.swipeHandler)) return;
    }
    // At this point `e` is a PointerEvent or MouseEvent (touchstart returned earlier).
    const pe = e;
    touches.currentX = pe.pageX;
    touches.currentY = pe.pageY;
    const startX = touches.currentX;
    const startY = touches.currentY;
    // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
    if (!$6946bfb4689eabba$var$preventEdgeSwipe(swiper, e, startX)) return;
    Object.assign(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = (0, $3e0e2b092da8f124$export$3b14a55fb2447963)();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) data.allowThresholdMove = false;
    let preventDefault = true;
    if (targetEl.matches(data.focusableElements)) {
        preventDefault = false;
        if (targetEl.nodeName === 'SELECT') data.isTouched = false;
    }
    if (document.activeElement && document.activeElement.matches(data.focusableElements) && document.activeElement !== targetEl && (pe.pointerType === 'mouse' || pe.pointerType !== 'mouse' && !targetEl.matches(data.focusableElements))) document.activeElement.blur();
    const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !targetEl.isContentEditable) e.preventDefault();
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) swiper.freeMode.onTouchStart();
    swiper.emit('touchStart', e);
}
const $6946bfb4689eabba$var$events = (swiper, method)=>{
    const { params: params, el: el, wrapperEl: wrapperEl, device: device } = swiper;
    const capture = !!params.nested;
    const domMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
    const swiperMethod = method;
    if (!el || typeof el === 'string') return;
    // Touch Events
    document[domMethod]('touchstart', swiper.onDocumentTouchStart, {
        passive: false,
        capture: capture
    });
    el[domMethod]('touchstart', swiper.onTouchStart, {
        passive: false
    });
    el[domMethod]('pointerdown', swiper.onTouchStart, {
        passive: false
    });
    document[domMethod]('touchmove', swiper.onTouchMove, {
        passive: false,
        capture: capture
    });
    document[domMethod]('pointermove', swiper.onTouchMove, {
        passive: false,
        capture: capture
    });
    document[domMethod]('touchend', swiper.onTouchEnd, {
        passive: true
    });
    document[domMethod]('pointerup', swiper.onTouchEnd, {
        passive: true
    });
    document[domMethod]('pointercancel', swiper.onTouchEnd, {
        passive: true
    });
    document[domMethod]('touchcancel', swiper.onTouchEnd, {
        passive: true
    });
    document[domMethod]('pointerout', swiper.onTouchEnd, {
        passive: true
    });
    document[domMethod]('pointerleave', swiper.onTouchEnd, {
        passive: true
    });
    document[domMethod]('contextmenu', swiper.onTouchEnd, {
        passive: true
    });
    // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) el[domMethod]('click', swiper.onClick, true);
    if (params.cssMode) wrapperEl[domMethod]('scroll', swiper.onScroll);
    // Resize handler
    const subscribe = (events)=>{
        swiper[swiperMethod](events, $6946bfb4689eabba$var$onResize, true);
    };
    if (params.updateOnWindowResize) subscribe(device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate');
    else subscribe('observerUpdate');
    // Images loader
    el[domMethod]('load', swiper.onLoad, {
        capture: true
    });
};
function $6946bfb4689eabba$var$attachEvents() {
    const swiper = this;
    const { params: params } = swiper;
    swiper.onTouchStart = $6946bfb4689eabba$var$onTouchStart.bind(swiper);
    swiper.onTouchMove = $6946bfb4689eabba$var$onTouchMove.bind(swiper);
    swiper.onTouchEnd = $6946bfb4689eabba$var$onTouchEnd.bind(swiper);
    swiper.onDocumentTouchStart = $6946bfb4689eabba$var$onDocumentTouchStart.bind(swiper);
    if (params.cssMode) swiper.onScroll = $6946bfb4689eabba$var$onScroll.bind(swiper);
    swiper.onClick = $6946bfb4689eabba$var$onClick.bind(swiper);
    swiper.onLoad = $6946bfb4689eabba$var$onLoad.bind(swiper);
    $6946bfb4689eabba$var$events(swiper, 'on');
}
function $6946bfb4689eabba$var$detachEvents() {
    const swiper = this;
    $6946bfb4689eabba$var$events(swiper, 'off');
}
var $6946bfb4689eabba$var$events$1 = {
    attachEvents: $6946bfb4689eabba$var$attachEvents,
    detachEvents: $6946bfb4689eabba$var$detachEvents
};
function $6946bfb4689eabba$var$setGrabCursor(moving) {
    const swiper = this;
    if (!swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    const el = swiper.params.touchEventsTarget === 'container' ? swiper.el : swiper.wrapperEl;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    el.style.cursor = 'move';
    el.style.cursor = moving ? 'grabbing' : 'grab';
    if (swiper.isElement) requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
}
function $6946bfb4689eabba$var$unsetGrabCursor() {
    const swiper = this;
    if (swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    swiper[swiper.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'].style.cursor = '';
    if (swiper.isElement) requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
}
var $6946bfb4689eabba$var$grabCursor = {
    setGrabCursor: $6946bfb4689eabba$var$setGrabCursor,
    unsetGrabCursor: $6946bfb4689eabba$var$unsetGrabCursor
};
function $6946bfb4689eabba$var$loopCreate(slideRealIndex, initial) {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (!params.loop || swiper.virtual && swiper.params.virtual?.enabled) return;
    const initSlides = ()=>{
        const slides = (0, $3e0e2b092da8f124$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
        slides.forEach((el, index)=>{
            el.setAttribute('data-swiper-slide-index', String(index));
        });
    };
    const clearBlankSlides = ()=>{
        const slides = (0, $3e0e2b092da8f124$export$f1e1789686576879)(slidesEl, `.${params.slideBlankClass}`);
        slides.forEach((el)=>{
            el.remove();
        });
        if (slides.length > 0) {
            swiper.recalcSlides();
            swiper.updateSlides();
        }
    };
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    if (params.loopAddBlankSlides && (params.slidesPerGroup > 1 || gridEnabled)) clearBlankSlides();
    const slidesPerGroup = params.slidesPerGroup * (gridEnabled ? params.grid.rows : 1);
    const shouldFillGroup = swiper.slides.length % slidesPerGroup !== 0;
    const shouldFillGrid = gridEnabled && swiper.slides.length % params.grid.rows !== 0;
    const addBlankSlides = (amountOfSlides)=>{
        for(let i = 0; i < amountOfSlides; i += 1){
            const slideEl = swiper.isElement ? (0, $3e0e2b092da8f124$export$407448d2b89b1813)('swiper-slide', [
                params.slideBlankClass
            ]) : (0, $3e0e2b092da8f124$export$407448d2b89b1813)('div', [
                params.slideClass,
                params.slideBlankClass
            ]);
            swiper.slidesEl.append(slideEl);
        }
    };
    if (shouldFillGroup) {
        if (params.loopAddBlankSlides) {
            const slidesToAdd = slidesPerGroup - swiper.slides.length % slidesPerGroup;
            addBlankSlides(slidesToAdd);
            swiper.recalcSlides();
            swiper.updateSlides();
        } else (0, $3e0e2b092da8f124$export$d141bba7fdc215a3)('Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)');
        initSlides();
    } else if (shouldFillGrid) {
        if (params.loopAddBlankSlides) {
            const slidesToAdd = params.grid.rows - swiper.slides.length % params.grid.rows;
            addBlankSlides(slidesToAdd);
            swiper.recalcSlides();
            swiper.updateSlides();
        } else (0, $3e0e2b092da8f124$export$d141bba7fdc215a3)('Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)');
        initSlides();
    } else initSlides();
    const bothDirections = params.centeredSlides || !!params.slidesOffsetBefore || !!params.slidesOffsetAfter;
    swiper.loopFix({
        slideRealIndex: slideRealIndex,
        direction: bothDirections ? undefined : 'next',
        initial: initial
    });
}
function $6946bfb4689eabba$var$loopDestroy() {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (!params.loop || !slidesEl || swiper.virtual && swiper.params.virtual?.enabled) return;
    swiper.recalcSlides();
    const newSlidesOrder = [];
    swiper.slides.forEach((slideEl)=>{
        const loopSlideEl = slideEl;
        const index = typeof loopSlideEl.swiperSlideIndex === 'undefined' ? Number(slideEl.getAttribute('data-swiper-slide-index')) : loopSlideEl.swiperSlideIndex;
        newSlidesOrder[index] = slideEl;
    });
    swiper.slides.forEach((slideEl)=>{
        slideEl.removeAttribute('data-swiper-slide-index');
    });
    newSlidesOrder.forEach((slideEl)=>{
        slidesEl.append(slideEl);
    });
    swiper.recalcSlides();
    swiper.slideTo(swiper.realIndex, 0);
}
function $6946bfb4689eabba$var$loopFix(options = {}) {
    const { slideRealIndex: slideRealIndex, slideTo: slideTo = true, direction: direction, setTranslate: setTranslate, activeSlideIndex: activeSlideIndexParam, initial: initial, byController: byController, byMousewheel: byMousewheel } = options;
    let activeSlideIndex = activeSlideIndexParam;
    const swiper = this;
    if (!swiper.params.loop) return;
    swiper.emit('beforeLoopFix');
    const { slides: slides, allowSlidePrev: allowSlidePrev, allowSlideNext: allowSlideNext, slidesEl: slidesEl, params: params } = swiper;
    const { centeredSlides: centeredSlides, slidesOffsetBefore: slidesOffsetBefore, slidesOffsetAfter: slidesOffsetAfter, initialSlide: initialSlide } = params;
    const bothDirections = centeredSlides || !!slidesOffsetBefore || !!slidesOffsetAfter;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    if (swiper.virtual && params.virtual?.enabled) {
        if (slideTo) {
            const virtualSlidesLength = swiper.virtual.slides.length;
            const virtualSlidesBefore = swiper.virtual.slidesBefore ?? 0;
            if (!bothDirections && swiper.snapIndex === 0) swiper.slideTo(virtualSlidesLength, 0, false, true);
            else if (bothDirections && swiper.snapIndex < params.slidesPerView) swiper.slideTo(virtualSlidesLength + swiper.snapIndex, 0, false, true);
            else if (swiper.snapIndex === swiper.snapGrid.length - 1) swiper.slideTo(virtualSlidesBefore, 0, false, true);
        }
        swiper.allowSlidePrev = allowSlidePrev;
        swiper.allowSlideNext = allowSlideNext;
        swiper.emit('loopFix');
        return;
    }
    let slidesPerView = params.slidesPerView;
    if (slidesPerView === 'auto') slidesPerView = swiper.slidesPerViewDynamic();
    else {
        slidesPerView = Math.ceil(parseFloat(String(params.slidesPerView)));
        if (bothDirections && slidesPerView % 2 === 0) slidesPerView = slidesPerView + 1;
    }
    const slidesPerGroup = params.slidesPerGroupAuto ? slidesPerView : params.slidesPerGroup;
    let loopedSlides = bothDirections ? Math.max(slidesPerGroup, Math.ceil(slidesPerView / 2)) : slidesPerGroup;
    if (loopedSlides % slidesPerGroup !== 0) loopedSlides += slidesPerGroup - loopedSlides % slidesPerGroup;
    loopedSlides += params.loopAdditionalSlides;
    swiper.loopedSlides = loopedSlides;
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    if (slides.length < slidesPerView + loopedSlides || swiper.params.effect === 'cards' && slides.length < slidesPerView + loopedSlides * 2) (0, $3e0e2b092da8f124$export$d141bba7fdc215a3)('Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters');
    else if (gridEnabled && params.grid.fill === 'row') (0, $3e0e2b092da8f124$export$d141bba7fdc215a3)('Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`');
    const prependSlidesIndexes = [];
    const appendSlidesIndexes = [];
    const cols = gridEnabled ? Math.ceil(slides.length / params.grid.rows) : slides.length;
    const isInitialOverflow = initial && cols - initialSlide < slidesPerView && !bothDirections;
    let activeIndex = isInitialOverflow ? initialSlide : swiper.activeIndex;
    if (typeof activeSlideIndex === 'undefined') activeSlideIndex = swiper.getSlideIndex(slides.find((el)=>el.classList.contains(params.slideActiveClass)));
    else activeIndex = activeSlideIndex;
    const isNext = direction === 'next' || !direction;
    const isPrev = direction === 'prev' || !direction;
    let slidesPrepended = 0;
    let slidesAppended = 0;
    const activeColIndex = gridEnabled ? slides[activeSlideIndex].column ?? 0 : activeSlideIndex;
    const activeColIndexWithShift = activeColIndex + (bothDirections && typeof setTranslate === 'undefined' ? -slidesPerView / 2 + 0.5 : 0);
    // prepend last slides before start
    if (activeColIndexWithShift < loopedSlides) {
        slidesPrepended = Math.max(loopedSlides - activeColIndexWithShift, slidesPerGroup);
        for(let i = 0; i < loopedSlides - activeColIndexWithShift; i += 1){
            const index = i - Math.floor(i / cols) * cols;
            if (gridEnabled) {
                const colIndexToPrepend = cols - index - 1;
                for(let j = slides.length - 1; j >= 0; j -= 1)if (slides[j].column === colIndexToPrepend) prependSlidesIndexes.push(j);
            } else prependSlidesIndexes.push(cols - index - 1);
        }
    } else if (activeColIndexWithShift + slidesPerView > cols - loopedSlides) {
        slidesAppended = Math.max(activeColIndexWithShift - (cols - loopedSlides * 2), slidesPerGroup);
        if (isInitialOverflow) slidesAppended = Math.max(slidesAppended, slidesPerView - cols + initialSlide + 1);
        for(let i = 0; i < slidesAppended; i += 1){
            const index = i - Math.floor(i / cols) * cols;
            if (gridEnabled) slides.forEach((slide, slideIndex)=>{
                if (slide.column === index) appendSlidesIndexes.push(slideIndex);
            });
            else appendSlidesIndexes.push(index);
        }
    }
    swiper.__preventObserver__ = true;
    requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
    if (swiper.params.effect === 'cards' && slides.length < slidesPerView + loopedSlides * 2) {
        if (appendSlidesIndexes.includes(activeSlideIndex)) appendSlidesIndexes.splice(appendSlidesIndexes.indexOf(activeSlideIndex), 1);
        if (prependSlidesIndexes.includes(activeSlideIndex)) prependSlidesIndexes.splice(prependSlidesIndexes.indexOf(activeSlideIndex), 1);
    }
    if (isPrev) prependSlidesIndexes.forEach((index)=>{
        const slideEl = slides[index];
        slideEl.swiperLoopMoveDOM = true;
        slidesEl.prepend(slideEl);
        slideEl.swiperLoopMoveDOM = false;
    });
    if (isNext) appendSlidesIndexes.forEach((index)=>{
        const slideEl = slides[index];
        slideEl.swiperLoopMoveDOM = true;
        slidesEl.append(slideEl);
        slideEl.swiperLoopMoveDOM = false;
    });
    swiper.recalcSlides();
    if (params.slidesPerView === 'auto') swiper.updateSlides();
    else if (gridEnabled && (prependSlidesIndexes.length > 0 && isPrev || appendSlidesIndexes.length > 0 && isNext)) swiper.slides.forEach((slide, slideIndex)=>{
        swiper.grid.updateSlide(slideIndex, slide, swiper.slides);
    });
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    if (slideTo) {
        if (prependSlidesIndexes.length > 0 && isPrev) {
            if (typeof slideRealIndex === 'undefined') {
                const currentSlideTranslate = swiper.slidesGrid[activeIndex];
                const newSlideTranslate = swiper.slidesGrid[activeIndex + slidesPrepended];
                const diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex + Math.ceil(slidesPrepended), 0, false, true);
                    if (setTranslate) {
                        swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
                        swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
                    }
                }
            } else if (setTranslate) {
                const shift = gridEnabled ? prependSlidesIndexes.length / params.grid.rows : prependSlidesIndexes.length;
                swiper.slideTo(swiper.activeIndex + shift, 0, false, true);
                swiper.touchEventsData.currentTranslate = swiper.translate;
            }
        } else if (appendSlidesIndexes.length > 0 && isNext) {
            if (typeof slideRealIndex === 'undefined') {
                const currentSlideTranslate = swiper.slidesGrid[activeIndex];
                const newSlideTranslate = swiper.slidesGrid[activeIndex - slidesAppended];
                const diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex - slidesAppended, 0, false, true);
                    if (setTranslate) {
                        swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
                        swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
                    }
                }
            } else {
                const shift = gridEnabled ? appendSlidesIndexes.length / params.grid.rows : appendSlidesIndexes.length;
                swiper.slideTo(swiper.activeIndex - shift, 0, false, true);
            }
        }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    const controlled = swiper.controller?.control;
    if (controlled && !byController) {
        const loopParams = {
            slideRealIndex: slideRealIndex,
            direction: direction,
            setTranslate: setTranslate,
            activeSlideIndex: activeSlideIndex,
            byController: true
        };
        if (Array.isArray(controlled)) controlled.forEach((c)=>{
            if (!c.destroyed && c.params.loop) c.loopFix({
                ...loopParams,
                slideTo: c.params.slidesPerView === params.slidesPerView ? slideTo : false
            });
        });
        else if (controlled instanceof swiper.constructor && controlled.params.loop) controlled.loopFix({
            ...loopParams,
            slideTo: controlled.params.slidesPerView === params.slidesPerView ? slideTo : false
        });
    }
    swiper.emit('loopFix');
}
var $6946bfb4689eabba$var$loop = {
    loopCreate: $6946bfb4689eabba$var$loopCreate,
    loopFix: $6946bfb4689eabba$var$loopFix,
    loopDestroy: $6946bfb4689eabba$var$loopDestroy
};
function $6946bfb4689eabba$var$moduleExtendParams(params, allModulesParams) {
    return function extendParams(obj = {}) {
        const moduleParamName = Object.keys(obj)[0];
        const moduleParams = obj[moduleParamName];
        if (typeof moduleParams !== 'object' || moduleParams === null) {
            (0, $3e0e2b092da8f124$export$7ccc53e8f1e7dfc5)(allModulesParams, obj);
            return;
        }
        if (params[moduleParamName] === true) params[moduleParamName] = {
            enabled: true
        };
        if (moduleParamName === 'navigation' && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].prevEl && !params[moduleParamName].nextEl) params[moduleParamName].auto = true;
        if ([
            'pagination',
            'scrollbar'
        ].indexOf(moduleParamName) >= 0 && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].el) params[moduleParamName].auto = true;
        if (!(moduleParamName in params && 'enabled' in moduleParams)) {
            (0, $3e0e2b092da8f124$export$7ccc53e8f1e7dfc5)(allModulesParams, obj);
            return;
        }
        if (typeof params[moduleParamName] === 'object' && !('enabled' in params[moduleParamName])) params[moduleParamName].enabled = true;
        if (!params[moduleParamName]) params[moduleParamName] = {
            enabled: false
        };
        (0, $3e0e2b092da8f124$export$7ccc53e8f1e7dfc5)(allModulesParams, obj);
    };
}
const $6946bfb4689eabba$var$Observer = ({ swiper: swiper, extendParams: extendParams, on: on })=>{
    const observers = [];
    const attach = (target, options = {})=>{
        const ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
        if (!ObserverFunc) return;
        const observer = new ObserverFunc((mutations)=>{
            // The observerUpdate event should only be triggered
            // once despite the number of mutations.  Additional
            // triggers are redundant and are very costly
            if (swiper.__preventObserver__) return;
            if (mutations.length === 1) {
                swiper.emit('observerUpdate', mutations[0]);
                return;
            }
            const observerUpdate = function observerUpdate() {
                swiper.emit('observerUpdate', mutations[0]);
            };
            if (window.requestAnimationFrame) window.requestAnimationFrame(observerUpdate);
            else window.setTimeout(observerUpdate, 0);
        });
        observer.observe(target, {
            attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
            childList: swiper.isElement || (typeof options.childList === 'undefined' ? true : options.childList),
            characterData: typeof options.characterData === 'undefined' ? true : options.characterData
        });
        observers.push(observer);
    };
    const init = ()=>{
        if (!swiper.params.observer) return;
        if (swiper.params.observeParents) {
            const containerParents = (0, $3e0e2b092da8f124$export$35e795649ee09318)(swiper.hostEl);
            for(let i = 0; i < containerParents.length; i += 1)attach(containerParents[i]);
        }
        // Observe container
        attach(swiper.hostEl, {
            childList: swiper.params.observeSlideChildren
        });
        // Observe wrapper
        attach(swiper.wrapperEl, {
            attributes: false
        });
    };
    const destroy = ()=>{
        observers.forEach((observer)=>{
            observer.disconnect();
        });
        observers.splice(0, observers.length);
    };
    extendParams({
        observer: false,
        observeParents: false,
        observeSlideChildren: false
    });
    on('init', init);
    on('destroy', destroy);
};
const $6946bfb4689eabba$var$Resize = ({ swiper: swiper, on: on, emit: emit })=>{
    let observer = null;
    let animationFrame = null;
    const resizeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit('beforeResize');
        emit('resize');
    };
    const createObserver = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        observer = new ResizeObserver((entries)=>{
            animationFrame = window.requestAnimationFrame(()=>{
                const { width: width, height: height } = swiper;
                let newWidth = width;
                let newHeight = height;
                entries.forEach(({ contentBoxSize: contentBoxSize, contentRect: contentRect, target: target })=>{
                    if (target && target !== swiper.el) return;
                    // Older Safari (≤15) exposed `contentBoxSize` as a single object instead of an array.
                    const box = Array.isArray(contentBoxSize) ? contentBoxSize[0] : contentBoxSize;
                    newWidth = contentRect ? contentRect.width : box.inlineSize;
                    newHeight = contentRect ? contentRect.height : box.blockSize;
                });
                if (newWidth !== width || newHeight !== height) resizeHandler();
            });
        });
        observer.observe(swiper.el);
    };
    const removeObserver = ()=>{
        if (animationFrame) window.cancelAnimationFrame(animationFrame);
        if (observer && observer.unobserve && swiper.el) {
            observer.unobserve(swiper.el);
            observer = null;
        }
    };
    const orientationChangeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit('orientationchange');
    };
    on('init', ()=>{
        if (swiper.params.resizeObserver && typeof window.ResizeObserver !== 'undefined') {
            createObserver();
            return;
        }
        window.addEventListener('resize', resizeHandler);
        window.addEventListener('orientationchange', orientationChangeHandler);
    });
    on('destroy', ()=>{
        removeObserver();
        window.removeEventListener('resize', resizeHandler);
        window.removeEventListener('orientationchange', orientationChangeHandler);
    });
};
function $6946bfb4689eabba$var$slideNext(speed, runCallbacks = true, internal) {
    const swiper = this;
    const { enabled: enabled, params: params, animating: animating } = swiper;
    if (!enabled || swiper.destroyed) return swiper;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    let perGroup = params.slidesPerGroup;
    if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) perGroup = Math.max(swiper.slidesPerViewDynamic('current', true), 1);
    const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
    const isVirtual = swiper.virtual && params.virtual?.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: 'next'
        });
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
        if (swiper.activeIndex === swiper.slides.length - 1 && params.cssMode) {
            requestAnimationFrame(()=>{
                swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
            });
            return true;
        }
    }
    if (params.rewind && swiper.isEnd) return swiper.slideTo(0, speed, runCallbacks, internal);
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}
function $6946bfb4689eabba$var$slidePrev(speed, runCallbacks = true, internal) {
    const swiper = this;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, rtlTranslate: rtlTranslate, enabled: enabled, animating: animating } = swiper;
    if (!enabled || swiper.destroyed) return swiper;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    const isVirtual = swiper.virtual && params.virtual?.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: 'prev'
        });
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
    }
    const translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
    }
    const normalizedTranslate = normalize(translate);
    const normalizedSnapGrid = snapGrid.map((val)=>normalize(val));
    const isFreeMode = params.freeMode && params.freeMode.enabled;
    let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === 'undefined' && (params.cssMode || isFreeMode)) {
        let prevSnapIndex;
        snapGrid.forEach((snap, snapIndex)=>{
            if (normalizedTranslate >= snap) prevSnapIndex = snapIndex;
        });
        if (typeof prevSnapIndex !== 'undefined') prevSnap = isFreeMode ? snapGrid[prevSnapIndex] : snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
    let prevIndex = 0;
    if (typeof prevSnap !== 'undefined') {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
        if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
            prevIndex = prevIndex - swiper.slidesPerViewDynamic('previous', true) + 1;
            prevIndex = Math.max(prevIndex, 0);
        }
    }
    if (params.rewind && swiper.isBeginning) {
        const lastIndex = swiper.params.virtual?.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
    } else if (params.loop && swiper.activeIndex === 0 && params.cssMode) {
        requestAnimationFrame(()=>{
            swiper.slideTo(prevIndex, speed, runCallbacks, internal);
        });
        return true;
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}
function $6946bfb4689eabba$var$slideReset(speed, runCallbacks = true, internal) {
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}
function $6946bfb4689eabba$var$slideTo(index = 0, speed, runCallbacks = true, internal, initial) {
    if (typeof index === 'string') index = parseInt(index, 10);
    const swiper = this;
    let slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, previousIndex: previousIndex, activeIndex: activeIndex, rtlTranslate: rtl, wrapperEl: wrapperEl, enabled: enabled } = swiper;
    if (!enabled && !internal && !initial || swiper.destroyed || swiper.animating && params.preventInteractionOnTransition) return false;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    const translate = -snapGrid[snapIndex];
    // Normalize slideIndex
    if (params.normalizeSlideIndex) for(let i = 0; i < slidesGrid.length; i += 1){
        const normalizedTranslate = -Math.floor(translate * 100);
        const normalizedGrid = Math.floor(slidesGrid[i] * 100);
        const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
        if (typeof slidesGrid[i + 1] !== 'undefined') {
            if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) slideIndex = i;
            else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) slideIndex = i + 1;
        } else if (normalizedTranslate >= normalizedGrid) slideIndex = i;
    }
    // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && (rtl ? translate > swiper.translate && translate > swiper.minTranslate() : translate < swiper.translate && translate < swiper.minTranslate())) return false;
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
            if ((activeIndex || 0) !== slideIndex) return false;
        }
    }
    if (slideIndex !== (previousIndex || 0) && runCallbacks) swiper.emit('beforeSlideChangeStart');
    // Update progress
    swiper.updateProgress(translate);
    let direction;
    if (slideIndex > activeIndex) direction = 'next';
    else if (slideIndex < activeIndex) direction = 'prev';
    else direction = 'reset';
    // initial virtual
    const isVirtual = swiper.virtual && swiper.params.virtual?.enabled;
    const isInitialVirtual = isVirtual && initial;
    // Update Index
    if (!isInitialVirtual && (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate)) {
        swiper.updateActiveIndex(slideIndex);
        // Update Height
        if (params.autoHeight) swiper.updateAutoHeight();
        swiper.updateSlidesClasses();
        if (params.effect !== 'slide') swiper.setTranslate(translate);
        if (direction !== 'reset') {
            swiper.transitionStart(runCallbacks, direction);
            swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
    }
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        const t = rtl ? translate : -translate;
        if (speed === 0) {
            if (isVirtual) {
                swiper.wrapperEl.style.scrollSnapType = 'none';
                swiper._immediateVirtual = true;
            }
            if (isVirtual && !swiper._cssModeVirtualInitialSet && (swiper.params.initialSlide ?? 0) > 0) {
                swiper._cssModeVirtualInitialSet = true;
                requestAnimationFrame(()=>{
                    wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
                });
            } else wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
            if (isVirtual) requestAnimationFrame(()=>{
                swiper.wrapperEl.style.scrollSnapType = '';
                swiper._immediateVirtual = false;
            });
        } else wrapperEl.scrollTo({
            [isH ? 'left' : 'top']: t,
            behavior: 'smooth'
        });
        return true;
    }
    const browser = $6946bfb4689eabba$var$getBrowser();
    const isSafari = browser.isSafari;
    if (isVirtual && !initial && isSafari && swiper.isElement) swiper.virtual.update(false, false, slideIndex);
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit('beforeTransitionStart', speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (speed === 0) swiper.transitionEnd(runCallbacks, direction);
    else if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.wrapperEl.removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
        };
        swiper.wrapperEl.addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
    }
    return true;
}
function $6946bfb4689eabba$var$slideToClickedSlide() {
    const swiper = this;
    if (swiper.destroyed) return;
    const { params: params, slidesEl: slidesEl, clickedSlide: clickedSlide, clickedIndex: clickedIndex } = swiper;
    if (clickedSlide === undefined || clickedIndex === undefined) return;
    const slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    let slideToIndex = swiper.getSlideIndexWhenGrid(clickedIndex);
    let realIndex;
    const slideSelector = swiper.isElement ? `swiper-slide` : `.${params.slideClass}`;
    const isGrid = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
    if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt(clickedSlide.getAttribute('data-swiper-slide-index'), 10);
        if (params.centeredSlides) swiper.slideToLoop(realIndex);
        else if (slideToIndex > (isGrid ? (swiper.slides.length - slidesPerView) / 2 - (swiper.params.grid.rows - 1) : swiper.slides.length - slidesPerView)) {
            swiper.loopFix();
            slideToIndex = swiper.getSlideIndex((0, $3e0e2b092da8f124$export$f1e1789686576879)(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
            (0, $3e0e2b092da8f124$export$625550452a3fa3ec)(()=>{
                swiper.slideTo(slideToIndex);
            });
        } else swiper.slideTo(slideToIndex);
    } else swiper.slideTo(slideToIndex);
}
function $6946bfb4689eabba$var$slideToClosest(speed, runCallbacks = true, internal, threshold = 0.5) {
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    let index = swiper.activeIndex;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        const currentSnap = swiper.snapGrid[snapIndex];
        const nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) index += swiper.params.slidesPerGroup;
    } else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        const prevSnap = swiper.snapGrid[snapIndex - 1];
        const currentSnap = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) index -= swiper.params.slidesPerGroup;
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
}
function $6946bfb4689eabba$var$slideToLoop(index = 0, speed, runCallbacks = true, internal) {
    if (typeof index === 'string') {
        const indexAsNumber = parseInt(index, 10);
        index = indexAsNumber;
    }
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    const gridEnabled = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
    let newIndex = index;
    if (swiper.params.loop) {
        if (swiper.virtual && swiper.params.virtual?.enabled) newIndex = newIndex + (swiper.virtual.slidesBefore ?? 0);
        else {
            let targetSlideIndex;
            if (gridEnabled) {
                const slideIndex = newIndex * swiper.params.grid.rows;
                const targetSlideEl = swiper.slides.find((slideEl)=>Number(slideEl.getAttribute('data-swiper-slide-index')) === slideIndex);
                targetSlideIndex = targetSlideEl?.column ?? 0;
            } else targetSlideIndex = swiper.getSlideIndexByData(newIndex);
            const cols = gridEnabled ? Math.ceil(swiper.slides.length / swiper.params.grid.rows) : swiper.slides.length;
            const { centeredSlides: centeredSlides, slidesOffsetBefore: slidesOffsetBefore, slidesOffsetAfter: slidesOffsetAfter } = swiper.params;
            const bothDirections = centeredSlides || !!slidesOffsetBefore || !!slidesOffsetAfter;
            let slidesPerView;
            if (swiper.params.slidesPerView === 'auto') slidesPerView = swiper.slidesPerViewDynamic();
            else {
                slidesPerView = Math.ceil(parseFloat(String(swiper.params.slidesPerView)));
                if (bothDirections && slidesPerView % 2 === 0) slidesPerView = slidesPerView + 1;
            }
            let needLoopFix = cols - targetSlideIndex < slidesPerView;
            if (bothDirections) needLoopFix = needLoopFix || targetSlideIndex < Math.ceil(slidesPerView / 2);
            if (internal && bothDirections && swiper.params.slidesPerView !== 'auto' && !gridEnabled) needLoopFix = false;
            if (needLoopFix) {
                const direction = bothDirections ? targetSlideIndex < swiper.activeIndex ? 'prev' : 'next' : targetSlideIndex - swiper.activeIndex - 1 < swiper.params.slidesPerView ? 'next' : 'prev';
                swiper.loopFix({
                    direction: direction,
                    slideTo: true,
                    activeSlideIndex: direction === 'next' ? targetSlideIndex + 1 : targetSlideIndex - cols + 1,
                    slideRealIndex: direction === 'next' ? swiper.realIndex : undefined
                });
            }
            if (gridEnabled) {
                const slideIndex = newIndex * swiper.params.grid.rows;
                const targetSlideEl = swiper.slides.find((slideEl)=>Number(slideEl.getAttribute('data-swiper-slide-index')) === slideIndex);
                newIndex = targetSlideEl?.column ?? 0;
            } else newIndex = swiper.getSlideIndexByData(newIndex);
        }
    }
    requestAnimationFrame(()=>{
        swiper.slideTo(newIndex, speed, runCallbacks, internal);
    });
    return swiper;
}
var $6946bfb4689eabba$var$slide = {
    slideTo: $6946bfb4689eabba$var$slideTo,
    slideToLoop: $6946bfb4689eabba$var$slideToLoop,
    slideNext: $6946bfb4689eabba$var$slideNext,
    slidePrev: $6946bfb4689eabba$var$slidePrev,
    slideReset: $6946bfb4689eabba$var$slideReset,
    slideToClosest: $6946bfb4689eabba$var$slideToClosest,
    slideToClickedSlide: $6946bfb4689eabba$var$slideToClickedSlide
};
function $6946bfb4689eabba$var$setTransition(duration, byController) {
    const swiper = this;
    if (!swiper.params.cssMode) {
        swiper.wrapperEl.style.transitionDuration = `${duration}ms`;
        swiper.wrapperEl.style.transitionDelay = duration === 0 ? `0ms` : '';
    }
    swiper.emit('setTransition', duration, byController);
}
function $6946bfb4689eabba$var$transitionEmit({ swiper: swiper, runCallbacks: runCallbacks, direction: direction, step: step }) {
    const { activeIndex: activeIndex, previousIndex: previousIndex } = swiper;
    let dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = 'next';
        else if (activeIndex < previousIndex) dir = 'prev';
        else dir = 'reset';
    }
    swiper.emit(`transition${step}`);
    if (runCallbacks && dir === 'reset') swiper.emit(`slideResetTransition${step}`);
    else if (runCallbacks && activeIndex !== previousIndex) {
        swiper.emit(`slideChangeTransition${step}`);
        if (dir === 'next') swiper.emit(`slideNextTransition${step}`);
        else swiper.emit(`slidePrevTransition${step}`);
    }
}
function $6946bfb4689eabba$var$transitionEnd(runCallbacks = true, direction) {
    const swiper = this;
    const { params: params } = swiper;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    $6946bfb4689eabba$var$transitionEmit({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: 'End'
    });
}
function $6946bfb4689eabba$var$transitionStart(runCallbacks = true, direction) {
    const swiper = this;
    const { params: params } = swiper;
    if (params.cssMode) return;
    if (params.autoHeight) swiper.updateAutoHeight();
    $6946bfb4689eabba$var$transitionEmit({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: 'Start'
    });
}
var $6946bfb4689eabba$var$transition = {
    setTransition: $6946bfb4689eabba$var$setTransition,
    transitionStart: $6946bfb4689eabba$var$transitionStart,
    transitionEnd: $6946bfb4689eabba$var$transitionEnd
};
function $6946bfb4689eabba$var$getSwiperTranslate(axis = this.isHorizontal() ? 'x' : 'y') {
    const swiper = this;
    const { params: params, rtlTranslate: rtl, translate: translate, wrapperEl: wrapperEl } = swiper;
    if (params.virtualTranslate) return rtl ? -translate : translate;
    if (params.cssMode) return translate;
    let currentTranslate = (0, $3e0e2b092da8f124$export$9e5f44173e64f162)(wrapperEl, axis);
    currentTranslate += swiper.cssOverflowAdjustment();
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
}
function $6946bfb4689eabba$var$maxTranslate() {
    return -this.snapGrid[this.snapGrid.length - 1];
}
function $6946bfb4689eabba$var$minTranslate() {
    return -this.snapGrid[0];
}
function $6946bfb4689eabba$var$setTranslate(translate, byController) {
    const swiper = this;
    const { rtlTranslate: rtl, params: params, wrapperEl: wrapperEl, progress: progress } = swiper;
    let x = 0;
    let y = 0;
    const z = 0;
    if (swiper.isHorizontal()) x = rtl ? -translate : translate;
    else y = translate;
    if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
    }
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y;
    if (params.cssMode) wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
    else if (!params.virtualTranslate) {
        if (swiper.isHorizontal()) x -= swiper.cssOverflowAdjustment();
        else y -= swiper.cssOverflowAdjustment();
        wrapperEl.style.transform = `translate3d(${x}px, ${y}px, ${z}px)`;
    }
    // Check if we need to update progress
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== progress) swiper.updateProgress(translate);
    swiper.emit('setTranslate', swiper.translate, byController);
}
function $6946bfb4689eabba$var$translateTo(translate = 0, speed = this.params.speed, runCallbacks = true, translateBounds = true, internal) {
    const swiper = this;
    const { params: params, wrapperEl: wrapperEl } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition) return false;
    const minTranslate = swiper.minTranslate();
    const maxTranslate = swiper.maxTranslate();
    let newTranslate;
    if (translateBounds && translate > minTranslate) newTranslate = minTranslate;
    else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;
    else newTranslate = translate;
    // Update progress
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        if (speed === 0) wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
        else wrapperEl.scrollTo({
            [isH ? 'left' : 'top']: -newTranslate,
            behavior: 'smooth'
        });
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionEnd');
        }
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionStart');
        }
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onTranslateToWrapperTransitionEnd) swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed) return;
                if (e.target !== this) return;
                swiper.wrapperEl.removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
                swiper.onTranslateToWrapperTransitionEnd = null;
                delete swiper.onTranslateToWrapperTransitionEnd;
                swiper.animating = false;
                if (runCallbacks) swiper.emit('transitionEnd');
            };
            swiper.wrapperEl.addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
        }
    }
    return true;
}
var $6946bfb4689eabba$var$translate = {
    getTranslate: $6946bfb4689eabba$var$getSwiperTranslate,
    setTranslate: $6946bfb4689eabba$var$setTranslate,
    minTranslate: $6946bfb4689eabba$var$minTranslate,
    maxTranslate: $6946bfb4689eabba$var$maxTranslate,
    translateTo: $6946bfb4689eabba$var$translateTo
};
function $6946bfb4689eabba$var$getActiveIndexByTranslate(swiper) {
    const { slidesGrid: slidesGrid, params: params } = swiper;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    let activeIndex;
    for(let i = 0; i < slidesGrid.length; i += 1){
        if (typeof slidesGrid[i + 1] !== 'undefined') {
            if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) activeIndex = i;
            else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) activeIndex = i + 1;
        } else if (translate >= slidesGrid[i]) activeIndex = i;
    }
    // Normalize slideIndex
    if (params.normalizeSlideIndex) {
        if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
    }
    return activeIndex;
}
function $6946bfb4689eabba$var$updateActiveIndex(newActiveIndex) {
    const swiper = this;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    const { snapGrid: snapGrid, params: params, activeIndex: previousIndex, realIndex: previousRealIndex, snapIndex: previousSnapIndex } = swiper;
    let activeIndex = newActiveIndex;
    let snapIndex;
    const getVirtualRealIndex = (aIndex)=>{
        const virtualSlides = swiper.virtual.slides;
        let realIndex = aIndex - (swiper.virtual.slidesBefore ?? 0);
        if (realIndex < 0) realIndex = virtualSlides.length + realIndex;
        if (realIndex >= virtualSlides.length) realIndex -= virtualSlides.length;
        return realIndex;
    };
    if (typeof activeIndex === 'undefined') activeIndex = $6946bfb4689eabba$var$getActiveIndexByTranslate(swiper);
    if (snapGrid.indexOf(translate) >= 0) snapIndex = snapGrid.indexOf(translate);
    else {
        const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex && !swiper.params.loop) {
        if (snapIndex !== previousSnapIndex) {
            swiper.snapIndex = snapIndex;
            swiper.emit('snapIndexChange');
        }
        return;
    }
    if (activeIndex === previousIndex && swiper.params.loop && swiper.virtual && swiper.params.virtual?.enabled) {
        swiper.realIndex = getVirtualRealIndex(activeIndex);
        return;
    }
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    // Get real index
    let realIndex;
    if (swiper.virtual && params.virtual?.enabled) {
        if (params.loop) realIndex = getVirtualRealIndex(activeIndex);
        else realIndex = activeIndex;
    } else if (gridEnabled) {
        const firstSlideInColumn = swiper.slides.find((slideEl)=>slideEl.column === activeIndex);
        let activeSlideIndex = parseInt(firstSlideInColumn.getAttribute('data-swiper-slide-index'), 10);
        if (Number.isNaN(activeSlideIndex)) activeSlideIndex = Math.max(swiper.slides.indexOf(firstSlideInColumn), 0);
        realIndex = Math.floor(activeSlideIndex / params.grid.rows);
    } else if (swiper.slides[activeIndex]) {
        const slideIndex = swiper.slides[activeIndex].getAttribute('data-swiper-slide-index');
        if (slideIndex) realIndex = parseInt(slideIndex, 10);
        else realIndex = activeIndex;
    } else realIndex = activeIndex;
    Object.assign(swiper, {
        previousSnapIndex: previousSnapIndex,
        snapIndex: snapIndex,
        previousRealIndex: previousRealIndex,
        realIndex: realIndex,
        previousIndex: previousIndex,
        activeIndex: activeIndex
    });
    if (swiper.initialized) $6946bfb4689eabba$var$preload(swiper);
    swiper.emit('activeIndexChange');
    swiper.emit('snapIndexChange');
    if (swiper.initialized || swiper.params.runCallbacksOnInit) {
        if (previousRealIndex !== realIndex) swiper.emit('realIndexChange');
        swiper.emit('slideChange');
    }
}
function $6946bfb4689eabba$var$updateAutoHeight(speed) {
    const swiper = this;
    const activeSlides = [];
    const isVirtual = swiper.virtual && swiper.params.virtual?.enabled;
    let newHeight = 0;
    let i;
    if (typeof speed === 'number') swiper.setTransition(speed);
    else if (speed === true) swiper.setTransition(swiper.params.speed);
    const getSlideByIndex = (index)=>{
        if (isVirtual) return swiper.slides[swiper.getSlideIndexByData(index)];
        return swiper.slides[index];
    };
    // Find slides currently in view
    if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
        if (swiper.params.centeredSlides) (swiper.visibleSlides || []).forEach((slide)=>{
            activeSlides.push(slide);
        });
        else for(i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1){
            const index = swiper.activeIndex + i;
            if (index > swiper.slides.length && !isVirtual) break;
            const slide = getSlideByIndex(index);
            if (slide) activeSlides.push(slide);
        }
    } else {
        const slide = getSlideByIndex(swiper.activeIndex);
        if (slide) activeSlides.push(slide);
    }
    // Find new height from highest slide in view
    for(i = 0; i < activeSlides.length; i += 1)if (typeof activeSlides[i] !== 'undefined') {
        const height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
    }
    // Update Height
    if (newHeight || newHeight === 0) swiper.wrapperEl.style.height = `${newHeight}px`;
}
function $6946bfb4689eabba$var$updateClickedSlide(el, path) {
    const swiper = this;
    const params = swiper.params;
    let slide = el.closest(`.${params.slideClass}, swiper-slide`);
    if (!slide && swiper.isElement && path && path.length > 1 && path.includes(el)) [
        ...path.slice(path.indexOf(el) + 1, path.length)
    ].forEach((pathEl)=>{
        if (!slide && pathEl.matches && pathEl.matches(`.${params.slideClass}, swiper-slide`)) slide = pathEl;
    });
    let slideFound = false;
    let slideIndex;
    if (slide) {
        for(let i = 0; i < swiper.slides.length; i += 1)if (swiper.slides[i] === slide) {
            slideFound = true;
            slideIndex = i;
            break;
        }
    }
    if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual?.enabled) swiper.clickedIndex = parseInt(slide.getAttribute('data-swiper-slide-index'), 10);
        else swiper.clickedIndex = slideIndex;
    } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) swiper.slideToClickedSlide();
}
function $6946bfb4689eabba$var$updateProgress(translate) {
    const swiper = this;
    if (typeof translate === 'undefined') {
        const multiplier = swiper.rtlTranslate ? -1 : 1;
        translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    const params = swiper.params;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    let { progress: progress, isBeginning: isBeginning, isEnd: isEnd } = swiper;
    let progressLoop = swiper.progressLoop;
    const wasBeginning = isBeginning;
    const wasEnd = isEnd;
    if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
    } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        const isBeginningRounded = Math.abs(translate - swiper.minTranslate()) < 1;
        const isEndRounded = Math.abs(translate - swiper.maxTranslate()) < 1;
        isBeginning = isBeginningRounded || progress <= 0;
        isEnd = isEndRounded || progress >= 1;
        if (isBeginningRounded) progress = 0;
        if (isEndRounded) progress = 1;
    }
    if (params.loop) {
        const firstSlideIndex = swiper.getSlideIndexByData(0);
        const lastSlideIndex = swiper.getSlideIndexByData(swiper.slides.length - 1);
        const firstSlideTranslate = swiper.slidesGrid[firstSlideIndex];
        const lastSlideTranslate = swiper.slidesGrid[lastSlideIndex];
        const translateMax = swiper.slidesGrid[swiper.slidesGrid.length - 1];
        const translateAbs = Math.abs(translate);
        if (translateAbs >= firstSlideTranslate) progressLoop = (translateAbs - firstSlideTranslate) / translateMax;
        else progressLoop = (translateAbs + translateMax - lastSlideTranslate) / translateMax;
        if (progressLoop > 1) progressLoop -= 1;
    }
    Object.assign(swiper, {
        progress: progress,
        progressLoop: progressLoop,
        isBeginning: isBeginning,
        isEnd: isEnd
    });
    if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
    if (isBeginning && !wasBeginning) swiper.emit('reachBeginning toEdge');
    if (isEnd && !wasEnd) swiper.emit('reachEnd toEdge');
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) swiper.emit('fromEdge');
    swiper.emit('progress', progress);
}
function $6946bfb4689eabba$var$updateSize() {
    const swiper = this;
    let width;
    let height;
    const el = swiper.el;
    if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) width = swiper.params.width;
    else width = el.clientWidth;
    if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) height = swiper.params.height;
    else height = el.clientHeight;
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) return;
    // Subtract paddings
    width = width - parseInt((0, $3e0e2b092da8f124$export$882b5998b3b9117c)(el, 'padding-left') || '0', 10) - parseInt((0, $3e0e2b092da8f124$export$882b5998b3b9117c)(el, 'padding-right') || '0', 10);
    height = height - parseInt((0, $3e0e2b092da8f124$export$882b5998b3b9117c)(el, 'padding-top') || '0', 10) - parseInt((0, $3e0e2b092da8f124$export$882b5998b3b9117c)(el, 'padding-bottom') || '0', 10);
    if (Number.isNaN(width)) width = 0;
    if (Number.isNaN(height)) height = 0;
    Object.assign(swiper, {
        width: width,
        height: height,
        size: swiper.isHorizontal() ? width : height
    });
}
function $6946bfb4689eabba$var$updateSlides() {
    const swiper = this;
    function getDirectionPropertyValue(node, label) {
        return parseFloat(node.getPropertyValue(swiper.getDirectionLabel(label)) || '0');
    }
    const params = swiper.params;
    const { wrapperEl: wrapperEl, slidesEl: slidesEl, rtlTranslate: rtl, wrongRTL: wrongRTL } = swiper;
    const isVirtual = !!(swiper.virtual && params.virtual?.enabled);
    const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    const slides = (0, $3e0e2b092da8f124$export$f1e1789686576879)(slidesEl, `.${swiper.params.slideClass}, swiper-slide`);
    const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    let snapGrid = [];
    const slidesGrid = [];
    const slidesSizesGrid = [];
    const resolveOffset = (value)=>typeof value === 'function' ? value.call(swiper) : value;
    const offsetBefore = resolveOffset(params.slidesOffsetBefore);
    const offsetAfter = resolveOffset(params.slidesOffsetAfter);
    const previousSnapGridLength = swiper.snapGrid.length;
    const previousSlidesGridLength = swiper.slidesGrid.length;
    const swiperSize = swiper.size - offsetBefore - offsetAfter;
    let spaceBetween = params.spaceBetween;
    let slidePosition = -offsetBefore;
    let prevSlideSize = 0;
    let index = 0;
    if (typeof swiperSize === 'undefined') return;
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
    else if (typeof spaceBetween === 'string') spaceBetween = parseFloat(spaceBetween);
    swiper.virtualSize = -spaceBetween - offsetBefore - offsetAfter;
    // reset margins
    slides.forEach((slideEl)=>{
        if (rtl) slideEl.style.marginLeft = '';
        else slideEl.style.marginRight = '';
        slideEl.style.marginBottom = '';
        slideEl.style.marginTop = '';
    });
    // reset cssMode offsets
    if (params.centeredSlides && params.cssMode) {
        (0, $3e0e2b092da8f124$export$90a7f3efeed30595)(wrapperEl, '--swiper-centered-offset-before', '');
        (0, $3e0e2b092da8f124$export$90a7f3efeed30595)(wrapperEl, '--swiper-centered-offset-after', '');
    }
    // set cssMode offsets
    if (params.cssMode) {
        (0, $3e0e2b092da8f124$export$90a7f3efeed30595)(wrapperEl, '--swiper-slides-offset-before', `${offsetBefore}px`);
        (0, $3e0e2b092da8f124$export$90a7f3efeed30595)(wrapperEl, '--swiper-slides-offset-after', `${offsetAfter}px`);
    }
    const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
    if (gridEnabled) swiper.grid.initSlides(slides);
    else if (swiper.grid) swiper.grid.unsetSlides();
    // Calc slides
    let slideSize = 0;
    const shouldResetSlideSize = params.slidesPerView === 'auto' && params.breakpoints && Object.keys(params.breakpoints).filter((key)=>{
        const bp = params.breakpoints[key];
        return typeof bp?.slidesPerView !== 'undefined';
    }).length > 0;
    for(let i = 0; i < slidesLength; i += 1){
        slideSize = 0;
        const slide = slides[i];
        if (slide) {
            if (gridEnabled) swiper.grid.updateSlide(i, slide, slides);
            if ((0, $3e0e2b092da8f124$export$882b5998b3b9117c)(slide, 'display') === 'none') continue;
        }
        if (isVirtual && params.slidesPerView === 'auto') {
            if (params.virtual?.slidesPerViewAutoSlideSize) slideSize = params.virtual.slidesPerViewAutoSlideSize;
            if (slideSize && slide) {
                if (params.roundLengths) slideSize = Math.floor(slideSize);
                slide.style[swiper.getDirectionLabel('width')] = `${slideSize}px`;
            }
        } else if (params.slidesPerView === 'auto') {
            if (shouldResetSlideSize) slide.style[swiper.getDirectionLabel('width')] = ``;
            const slideStyles = getComputedStyle(slide);
            const currentTransform = slide.style.transform;
            const currentWebKitTransform = slide.style.webkitTransform;
            if (currentTransform) slide.style.transform = 'none';
            if (currentWebKitTransform) slide.style.webkitTransform = 'none';
            if (params.roundLengths) slideSize = swiper.isHorizontal() ? (0, $3e0e2b092da8f124$export$23f2a1d2818174ef)(slide, 'width') : (0, $3e0e2b092da8f124$export$23f2a1d2818174ef)(slide, 'height');
            else {
                const width = getDirectionPropertyValue(slideStyles, 'width');
                const paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
                const paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
                const marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
                const marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
                const boxSizing = slideStyles.getPropertyValue('box-sizing');
                if (boxSizing && boxSizing === 'border-box') slideSize = width + marginLeft + marginRight;
                else {
                    const { clientWidth: clientWidth, offsetWidth: offsetWidth } = slide;
                    slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
                }
            }
            if (currentTransform) slide.style.transform = currentTransform;
            if (currentWebKitTransform) slide.style.webkitTransform = currentWebKitTransform;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
            slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
            if (slide) slide.style[swiper.getDirectionLabel('width')] = `${slideSize}px`;
        }
        if (slide) slide.swiperSlideSize = slideSize;
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
            slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
            if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (Math.abs(slidePosition) < 0.001) slidePosition = 0;
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
        } else {
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
            slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) wrapperEl.style.width = `${swiper.virtualSize + spaceBetween}px`;
    if (params.setWrapperSize) wrapperEl.style[swiper.getDirectionLabel('width')] = `${swiper.virtualSize + spaceBetween}px`;
    if (gridEnabled) swiper.grid.updateWrapperSize(slideSize, snapGrid);
    // Remove last grid elements depending on width
    if (!params.centeredSlides) {
        // Check if snapToSlideEdge should be applied
        const isFractionalSlidesPerView = params.slidesPerView !== 'auto' && params.slidesPerView % 1 !== 0;
        const shouldSnapToSlideEdge = params.snapToSlideEdge && !params.loop && (params.slidesPerView === 'auto' || isFractionalSlidesPerView);
        // Calculate the last allowed snap index when snapToSlideEdge is enabled
        // This ensures minimum slides are visible at the end
        let lastAllowedSnapIndex = snapGrid.length;
        if (shouldSnapToSlideEdge) {
            let minVisibleSlides;
            if (params.slidesPerView === 'auto') {
                // For 'auto' mode, calculate how many slides fit based on actual sizes
                minVisibleSlides = 1;
                let accumulatedSize = 0;
                for(let i = slidesSizesGrid.length - 1; i >= 0; i -= 1){
                    accumulatedSize += slidesSizesGrid[i] + (i < slidesSizesGrid.length - 1 ? spaceBetween : 0);
                    if (accumulatedSize <= swiperSize) minVisibleSlides = slidesSizesGrid.length - i;
                    else break;
                }
            } else minVisibleSlides = Math.floor(params.slidesPerView);
            lastAllowedSnapIndex = Math.max(slidesLength - minVisibleSlides, 0);
        }
        const newSlidesGrid = [];
        for(let i = 0; i < snapGrid.length; i += 1){
            let slidesGridItem = snapGrid[i];
            if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
            if (shouldSnapToSlideEdge) // When snapToSlideEdge is enabled, only keep snaps up to lastAllowedSnapIndex
            {
                if (i <= lastAllowedSnapIndex) newSlidesGrid.push(slidesGridItem);
            } else if (snapGrid[i] <= swiper.virtualSize - swiperSize) // When snapToSlideEdge is disabled, keep snaps that fit within scrollable area
            newSlidesGrid.push(slidesGridItem);
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) // Only add edge-aligned snap if snapToSlideEdge is not enabled
        {
            if (!shouldSnapToSlideEdge) snapGrid.push(swiper.virtualSize - swiperSize);
        }
    }
    if (isVirtual && params.loop) {
        const size = slidesSizesGrid[0] + spaceBetween;
        const slidesBefore = swiper.virtual.slidesBefore ?? 0;
        const slidesAfter = swiper.virtual.slidesAfter ?? 0;
        const virtualLoopCount = slidesBefore + slidesAfter;
        if (params.slidesPerGroup > 1) {
            const groups = Math.ceil(virtualLoopCount / params.slidesPerGroup);
            const groupSize = size * params.slidesPerGroup;
            for(let i = 0; i < groups; i += 1)snapGrid.push(snapGrid[snapGrid.length - 1] + groupSize);
        }
        for(let i = 0; i < virtualLoopCount; i += 1){
            if (params.slidesPerGroup === 1) snapGrid.push(snapGrid[snapGrid.length - 1] + size);
            slidesGrid.push(slidesGrid[slidesGrid.length - 1] + size);
            swiper.virtualSize += size;
        }
    }
    if (snapGrid.length === 0) snapGrid = [
        0
    ];
    if (spaceBetween !== 0) {
        const key = swiper.isHorizontal() && rtl ? 'marginLeft' : swiper.getDirectionLabel('marginRight');
        slides.filter((_, slideIndex)=>{
            if (!params.cssMode || params.loop) return true;
            if (slideIndex === slides.length - 1) return false;
            return true;
        }).forEach((slideEl)=>{
            slideEl.style[key] = `${spaceBetween}px`;
        });
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        const maxSnap = allSlidesSize > swiperSize ? allSlidesSize - swiperSize : 0;
        snapGrid = snapGrid.map((snap)=>{
            if (snap <= 0) return -offsetBefore;
            if (snap > maxSnap) return maxSnap + offsetAfter;
            return snap;
        });
    }
    if (params.centerInsufficientSlides) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        if (allSlidesSize < swiperSize) {
            const allSlidesOffset = (swiperSize - allSlidesSize) / 2;
            snapGrid.forEach((snap, snapIndex)=>{
                snapGrid[snapIndex] = snap - allSlidesOffset;
            });
            slidesGrid.forEach((snap, snapIndex)=>{
                slidesGrid[snapIndex] = snap + allSlidesOffset;
            });
        }
    }
    Object.assign(swiper, {
        slides: slides,
        snapGrid: snapGrid,
        slidesGrid: slidesGrid,
        slidesSizesGrid: slidesSizesGrid
    });
    if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
        (0, $3e0e2b092da8f124$export$90a7f3efeed30595)(wrapperEl, '--swiper-centered-offset-before', `${-snapGrid[0]}px`);
        (0, $3e0e2b092da8f124$export$90a7f3efeed30595)(wrapperEl, '--swiper-centered-offset-after', `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
        const addToSnapGrid = -swiper.snapGrid[0];
        const addToSlidesGrid = -swiper.slidesGrid[0];
        swiper.snapGrid = swiper.snapGrid.map((v)=>v + addToSnapGrid);
        swiper.slidesGrid = swiper.slidesGrid.map((v)=>v + addToSlidesGrid);
    }
    if (slidesLength !== previousSlidesLength) swiper.emit('slidesLengthChange');
    if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit('snapGridLengthChange');
    }
    if (slidesGrid.length !== previousSlidesGridLength) swiper.emit('slidesGridLengthChange');
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    swiper.emit('slidesUpdated');
    if (!isVirtual && !params.cssMode && (params.effect === 'slide' || params.effect === 'fade')) {
        const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
        const hasClassBackfaceClassAdded = swiper.el.classList.contains(backFaceHiddenClass);
        if (slidesLength <= params.maxBackfaceHiddenSlides) {
            if (!hasClassBackfaceClassAdded) swiper.el.classList.add(backFaceHiddenClass);
        } else if (hasClassBackfaceClassAdded) swiper.el.classList.remove(backFaceHiddenClass);
    }
}
const $6946bfb4689eabba$var$toggleSlideClasses$1 = (slideEl, condition, className)=>{
    if (condition && !slideEl.classList.contains(className)) slideEl.classList.add(className);
    else if (!condition && slideEl.classList.contains(className)) slideEl.classList.remove(className);
};
function $6946bfb4689eabba$var$updateSlidesClasses() {
    const swiper = this;
    const { slides: slides, params: params, slidesEl: slidesEl, activeIndex: activeIndex } = swiper;
    const isVirtual = !!(swiper.virtual && params.virtual?.enabled);
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    const getFilteredSlide = (selector)=>{
        return (0, $3e0e2b092da8f124$export$f1e1789686576879)(slidesEl, `.${params.slideClass}${selector}, swiper-slide${selector}`)[0];
    };
    let activeSlide;
    let prevSlide;
    let nextSlide;
    if (isVirtual) {
        if (params.loop) {
            const virtualSlides = swiper.virtual.slides;
            let slideIndex = activeIndex - (swiper.virtual.slidesBefore ?? 0);
            if (slideIndex < 0) slideIndex = virtualSlides.length + slideIndex;
            if (slideIndex >= virtualSlides.length) slideIndex -= virtualSlides.length;
            activeSlide = getFilteredSlide(`[data-swiper-slide-index="${slideIndex}"]`);
        } else activeSlide = getFilteredSlide(`[data-swiper-slide-index="${activeIndex}"]`);
    } else if (gridEnabled) {
        activeSlide = slides.find((slideEl)=>slideEl.column === activeIndex);
        nextSlide = slides.find((slideEl)=>slideEl.column === activeIndex + 1);
        prevSlide = slides.find((slideEl)=>slideEl.column === activeIndex - 1);
    } else activeSlide = slides[activeIndex];
    if (activeSlide) {
        if (!gridEnabled) {
            // Next Slide
            nextSlide = (0, $3e0e2b092da8f124$export$39b482c5e57630a8)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
            if (params.loop && !nextSlide) nextSlide = slides[0];
            // Prev Slide
            prevSlide = (0, $3e0e2b092da8f124$export$342063e11d6c3cad)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
            // NOTE: legacy guard from v9; `(!prevSlide) === 0` is always false, but we preserve
            // the original behaviour (no-op) to avoid runtime changes in v14. Audit candidate.
            params.loop;
        }
    }
    slides.forEach((slideEl)=>{
        $6946bfb4689eabba$var$toggleSlideClasses$1(slideEl, slideEl === activeSlide, params.slideActiveClass);
        $6946bfb4689eabba$var$toggleSlideClasses$1(slideEl, slideEl === nextSlide, params.slideNextClass);
        $6946bfb4689eabba$var$toggleSlideClasses$1(slideEl, slideEl === prevSlide, params.slidePrevClass);
    });
    swiper.emitSlidesClasses();
}
function $6946bfb4689eabba$var$updateSlidesOffset() {
    const swiper = this;
    const slides = swiper.slides;
    const minusOffset = swiper.isElement ? swiper.isHorizontal() ? swiper.wrapperEl.offsetLeft : swiper.wrapperEl.offsetTop : 0;
    for(let i = 0; i < slides.length; i += 1)slides[i].swiperSlideOffset = (swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop) - minusOffset - swiper.cssOverflowAdjustment();
}
const $6946bfb4689eabba$var$toggleSlideClasses = (slideEl, condition, className)=>{
    if (condition && !slideEl.classList.contains(className)) slideEl.classList.add(className);
    else if (!condition && slideEl.classList.contains(className)) slideEl.classList.remove(className);
};
function $6946bfb4689eabba$var$updateSlidesProgress(translate = this && this.translate || 0) {
    const swiper = this;
    const params = swiper.params;
    const { slides: slides, rtlTranslate: rtl, snapGrid: snapGrid } = swiper;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
    let offsetCenter = -translate;
    if (rtl) offsetCenter = translate;
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    let spaceBetween = params.spaceBetween;
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiper.size;
    else if (typeof spaceBetween === 'string') spaceBetween = parseFloat(spaceBetween);
    for(let i = 0; i < slides.length; i += 1){
        const slide = slides[i];
        let slideOffset = slide.swiperSlideOffset ?? 0;
        if (params.cssMode && params.centeredSlides) slideOffset -= slides[0].swiperSlideOffset ?? 0;
        const slideSize = slide.swiperSlideSize ?? 0;
        const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slideSize + spaceBetween);
        const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slideSize + spaceBetween);
        const slideBefore = -(offsetCenter - slideOffset);
        const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        const isFullyVisible = slideBefore >= 0 && slideBefore <= swiper.size - swiper.slidesSizesGrid[i];
        const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
        if (isVisible) {
            swiper.visibleSlides.push(slide);
            swiper.visibleSlidesIndexes.push(i);
        }
        $6946bfb4689eabba$var$toggleSlideClasses(slide, isVisible, params.slideVisibleClass);
        $6946bfb4689eabba$var$toggleSlideClasses(slide, isFullyVisible, params.slideFullyVisibleClass);
        slide.progress = rtl ? -slideProgress : slideProgress;
        slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
    }
}
var $6946bfb4689eabba$var$update = {
    updateSize: $6946bfb4689eabba$var$updateSize,
    updateSlides: $6946bfb4689eabba$var$updateSlides,
    updateAutoHeight: $6946bfb4689eabba$var$updateAutoHeight,
    updateSlidesOffset: $6946bfb4689eabba$var$updateSlidesOffset,
    updateSlidesProgress: $6946bfb4689eabba$var$updateSlidesProgress,
    updateProgress: $6946bfb4689eabba$var$updateProgress,
    updateSlidesClasses: $6946bfb4689eabba$var$updateSlidesClasses,
    updateActiveIndex: $6946bfb4689eabba$var$updateActiveIndex,
    updateClickedSlide: $6946bfb4689eabba$var$updateClickedSlide
};
const $6946bfb4689eabba$var$prototypes = {
    eventsEmitter: $6946bfb4689eabba$var$eventsEmitter,
    update: $6946bfb4689eabba$var$update,
    translate: $6946bfb4689eabba$var$translate,
    transition: $6946bfb4689eabba$var$transition,
    slide: $6946bfb4689eabba$var$slide,
    loop: $6946bfb4689eabba$var$loop,
    grabCursor: $6946bfb4689eabba$var$grabCursor,
    events: $6946bfb4689eabba$var$events$1,
    breakpoints: $6946bfb4689eabba$var$breakpoints,
    checkOverflow: $6946bfb4689eabba$var$checkOverflow$1,
    classes: $6946bfb4689eabba$var$classes
};
const $6946bfb4689eabba$var$extendedDefaults = {};
class $6946bfb4689eabba$export$25ce5a424b770e84 {
    static extendedDefaults;
    static defaults;
    constructor(...args){
        let el;
        let params;
        if (args.length === 1 && args[0] !== null && typeof args[0] === 'object' && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') params = args[0];
        else [el, params] = args;
        if (!params) params = {};
        params = (0, $3e0e2b092da8f124$export$7ccc53e8f1e7dfc5)({}, params);
        if (el && !params.el) params.el = el;
        if (params.el && typeof params.el === 'string' && typeof document !== 'undefined' && document.querySelectorAll(params.el).length > 1) {
            const swipers = [];
            document.querySelectorAll(params.el).forEach((containerEl)=>{
                const newParams = (0, $3e0e2b092da8f124$export$7ccc53e8f1e7dfc5)({}, params, {
                    el: containerEl
                });
                swipers.push(new $6946bfb4689eabba$export$25ce5a424b770e84(newParams));
            });
            return swipers;
        }
        // Swiper Instance
        const swiper = this;
        swiper.__swiper__ = true;
        swiper.support = $6946bfb4689eabba$var$getSupport();
        swiper.device = $6946bfb4689eabba$var$getDevice({
            userAgent: params.userAgent ?? undefined
        });
        swiper.browser = $6946bfb4689eabba$var$getBrowser();
        swiper.eventsListeners = {};
        swiper.eventsAnyListeners = [];
        swiper.modules = [
            ...swiper.__modules__ || []
        ];
        if (params.modules && Array.isArray(params.modules)) params.modules.forEach((mod)=>{
            const fn = mod;
            if (typeof fn === 'function' && swiper.modules.indexOf(fn) < 0) swiper.modules.push(fn);
        });
        const allModulesParams = {};
        swiper.modules.forEach((mod)=>{
            mod({
                params: params,
                swiper: swiper,
                extendParams: $6946bfb4689eabba$var$moduleExtendParams(params, allModulesParams),
                on: swiper.on.bind(swiper),
                once: swiper.once.bind(swiper),
                off: swiper.off.bind(swiper),
                emit: swiper.emit.bind(swiper)
            });
        });
        // Extend defaults with modules params
        const swiperParams = (0, $3e0e2b092da8f124$export$7ccc53e8f1e7dfc5)({}, $6946bfb4689eabba$export$4368d992c4eafac0, allModulesParams);
        // Extend defaults with passed params
        swiper.params = (0, $3e0e2b092da8f124$export$7ccc53e8f1e7dfc5)({}, swiperParams, $6946bfb4689eabba$var$extendedDefaults, params);
        swiper.originalParams = (0, $3e0e2b092da8f124$export$7ccc53e8f1e7dfc5)({}, swiper.params);
        swiper.passedParams = (0, $3e0e2b092da8f124$export$7ccc53e8f1e7dfc5)({}, params);
        // add event listeners
        if (swiper.params && swiper.params.on) {
            const onHandlers = swiper.params.on;
            Object.keys(onHandlers).forEach((eventName)=>{
                const handler = onHandlers[eventName];
                if (handler) swiper.on(eventName, handler);
            });
        }
        if (swiper.params && swiper.params.onAny) swiper.onAny(swiper.params.onAny);
        // Extend Swiper
        Object.assign(swiper, {
            enabled: swiper.params.enabled,
            el: el,
            // Classes
            classNames: [],
            // Slides
            slides: [],
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            // isDirection
            isHorizontal () {
                return swiper.params.direction === 'horizontal';
            },
            isVertical () {
                return swiper.params.direction === 'vertical';
            },
            // Indexes
            activeIndex: 0,
            realIndex: 0,
            //
            isBeginning: true,
            isEnd: false,
            // Props
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: false,
            cssOverflowAdjustment () {
                // Returns 0 unless `translate` is > 2**23
                // Should be subtracted from css values to prevent overflow
                return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
            },
            // Locks
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev,
            // Touch Events
            touchEventsData: {
                isTouched: undefined,
                isMoved: undefined,
                allowTouchCallbacks: undefined,
                touchStartTime: undefined,
                isScrolling: undefined,
                currentTranslate: undefined,
                startTranslate: undefined,
                allowThresholdMove: undefined,
                // Form elements to match
                focusableElements: swiper.params.focusableElements,
                // Last click time
                lastClickTime: 0,
                clickTimeout: undefined,
                // Velocities
                velocities: [],
                allowMomentumBounce: undefined,
                startMoving: undefined,
                pointerId: null,
                touchId: null
            },
            // Clicks
            allowClick: true,
            // Touches
            allowTouchMove: swiper.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            // Images
            imagesToLoad: [],
            imagesLoaded: 0
        });
        swiper.emit('_swiper');
        // Init
        if (swiper.params.init) swiper.init();
        // Return app instance
        return swiper;
    }
    getDirectionLabel(property) {
        if (this.isHorizontal()) return property;
        // oxfmt-ignore
        return ({
            'width': 'height',
            'margin-top': 'margin-left',
            'margin-bottom ': 'margin-right',
            'margin-left': 'margin-top',
            'margin-right': 'margin-bottom',
            'padding-left': 'padding-top',
            'padding-right': 'padding-bottom',
            'marginRight': 'marginBottom'
        })[property];
    }
    /**
     * !INTERNAL
     */ isHorizontal() {
        return this.params.direction === 'horizontal';
    }
    isVertical() {
        return this.params.direction === 'vertical';
    }
    cssOverflowAdjustment() {
        return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
    }
    getSlideIndex(slideEl) {
        const { slidesEl: slidesEl, params: params } = this;
        const slides = (0, $3e0e2b092da8f124$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
        const firstSlideIndex = (0, $3e0e2b092da8f124$export$8b22cf2602fb60ce)(slides[0]);
        return (0, $3e0e2b092da8f124$export$8b22cf2602fb60ce)(slideEl) - (firstSlideIndex ?? 0);
    }
    getSlideIndexByData(index) {
        return this.getSlideIndex(this.slides.find((slideEl)=>Number(slideEl.getAttribute('data-swiper-slide-index')) === index));
    }
    getSlideIndexWhenGrid(index) {
        if (this.grid && this.params.grid && this.params.grid.rows > 1) {
            if (this.params.grid.fill === 'column') index = Math.floor(index / this.params.grid.rows);
            else if (this.params.grid.fill === 'row') index = index % Math.ceil(this.slides.length / this.params.grid.rows);
        }
        return index;
    }
    recalcSlides() {
        const { slidesEl: slidesEl, params: params } = this;
        this.slides = (0, $3e0e2b092da8f124$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
    }
    /**
     * Enable Swiper (if it was disabled)
     */ enable() {
        if (this.enabled) return;
        this.enabled = true;
        if (this.params.grabCursor) this.setGrabCursor();
        this.emit('enable');
    }
    /**
     * Disable Swiper (if it was enabled). When Swiper is disabled, it will hide all navigation elements and won't respond to any events and interactions
     */ disable() {
        if (!this.enabled) return;
        this.enabled = false;
        if (this.params.grabCursor) this.unsetGrabCursor();
        this.emit('disable');
    }
    /**
     * Set Swiper translate progress (from 0 to 1). Where 0 - its initial position (offset) on first slide, and 1 - its maximum position (offset) on last slide
     *
     * @param progress Swiper translate progress (from 0 to 1).
     * @param speed Transition duration (in ms).
     */ setProgress(progress, speed) {
        progress = Math.min(Math.max(progress, 0), 1);
        const min = this.minTranslate();
        const max = this.maxTranslate();
        const current = (max - min) * progress + min;
        this.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
        this.updateActiveIndex();
        this.updateSlidesClasses();
    }
    emitContainerClasses() {
        if (!this.params._emitClasses || !this.el) return;
        const cls = this.el.className.split(' ').filter((className)=>{
            return className.indexOf('swiper') === 0 || className.indexOf(this.params.containerModifierClass) === 0;
        });
        this.emit('_containerClasses', cls.join(' '));
    }
    getSlideClasses(slideEl) {
        if (this.destroyed) return '';
        return slideEl.className.split(' ').filter((className)=>{
            return className.indexOf('swiper-slide') === 0 || className.indexOf(this.params.slideClass) === 0;
        }).join(' ');
    }
    emitSlidesClasses() {
        if (!this.params._emitClasses || !this.el) return;
        const updates = [];
        this.slides.forEach((slideEl)=>{
            const classNames = this.getSlideClasses(slideEl);
            updates.push({
                slideEl: slideEl,
                classNames: classNames
            });
            this.emit('_slideClass', slideEl, classNames);
        });
        this.emit('_slideClasses', updates);
    }
    /**
     * Get dynamically calculated amount of slides per view, useful only when slidesPerView set to `auto`
     */ slidesPerViewDynamic(view = 'current', exact = false) {
        const { params: params, slides: slides, slidesGrid: slidesGrid, slidesSizesGrid: slidesSizesGrid, size: swiperSize, activeIndex: activeIndex } = this;
        let spv = 1;
        if (typeof params.slidesPerView === 'number') return params.slidesPerView;
        if (params.centeredSlides) {
            let slideSize = slides[activeIndex] ? Math.ceil(slides[activeIndex].swiperSlideSize ?? 0) : 0;
            let breakLoop = false;
            for(let i = activeIndex + 1; i < slides.length; i += 1)if (slides[i] && !breakLoop) {
                slideSize += Math.ceil(slides[i].swiperSlideSize ?? 0);
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
            for(let i = activeIndex - 1; i >= 0; i -= 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize ?? 0;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
        } else if (view === 'current') for(let i = activeIndex + 1; i < slides.length; i += 1){
            const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
            if (slideInView) spv += 1;
        }
        else // previous
        for(let i = activeIndex - 1; i >= 0; i -= 1){
            const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
            if (slideInView) spv += 1;
        }
        return spv;
    }
    /**
     * You should call it after you add/remove slides
     * manually, or after you hide/show it, or do any
     * custom DOM modifications with Swiper
     * This method also includes subcall of the following
     * methods which you can use separately:
     */ update() {
        const swiper = this;
        if (!swiper || swiper.destroyed) return;
        const { snapGrid: snapGrid, params: params } = swiper;
        // Breakpoints
        if (params.breakpoints) swiper.setBreakpoint();
        [
            ...swiper.el.querySelectorAll('[loading="lazy"]')
        ].forEach((imageEl)=>{
            if (imageEl.complete) $6946bfb4689eabba$var$processLazyPreloader(swiper, imageEl);
        });
        swiper.updateSize();
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        function setTranslate() {
            const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
            const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
            swiper.setTranslate(newTranslate);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
        let translated;
        if (params.freeMode?.enabled && !params.cssMode) {
            setTranslate();
            if (params.autoHeight) swiper.updateAutoHeight();
        } else {
            if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !params.centeredSlides) {
                const slidesLength = swiper.virtual && params.virtual?.enabled ? swiper.virtual.slides.length : swiper.slides.length;
                translated = swiper.slideTo(slidesLength - 1, 0, false, true);
            } else translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
            if (!translated) setTranslate();
        }
        if (params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
        swiper.emit('update');
    }
    /**
     * Changes slider direction from horizontal to vertical and back.
     *
     * @param direction New direction. If not specified, then will automatically changed to opposite direction
     * @param needUpdate Will call swiper.update(). Default true
     */ changeDirection(newDirection, needUpdate = true) {
        const swiper = this;
        const currentDirection = swiper.params.direction;
        if (!newDirection) newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
        if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') return swiper;
        swiper.el.classList.remove(`${swiper.params.containerModifierClass}${currentDirection}`);
        swiper.el.classList.add(`${swiper.params.containerModifierClass}${newDirection}`);
        swiper.emitContainerClasses();
        swiper.params.direction = newDirection;
        swiper.slides.forEach((slideEl)=>{
            if (newDirection === 'vertical') slideEl.style.width = '';
            else slideEl.style.height = '';
        });
        swiper.emit('changeDirection');
        if (needUpdate) swiper.update();
        return swiper;
    }
    /**
     * Changes slider language
     *
     * @param direction New direction. Should be `rtl` or `ltr`
     */ changeLanguageDirection(direction) {
        const swiper = this;
        if (swiper.rtl && direction === 'rtl' || !swiper.rtl && direction === 'ltr') return;
        swiper.rtl = direction === 'rtl';
        swiper.rtlTranslate = swiper.params.direction === 'horizontal' && swiper.rtl;
        if (swiper.rtl) {
            swiper.el.classList.add(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = 'rtl';
        } else {
            swiper.el.classList.remove(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = 'ltr';
        }
        swiper.update();
    }
    mount(element) {
        const swiper = this;
        if (swiper.mounted) return true;
        // No DOM (SSR / Node) — nothing to mount to.
        if (typeof document === 'undefined') return false;
        // Find el (params.el can be a CSSSelector, HTMLElement, or undefined)
        const initialEl = element ?? swiper.params.el;
        let el = null;
        if (typeof initialEl === 'string') el = document.querySelector(initialEl);
        else if (initialEl instanceof HTMLElement) el = initialEl;
        if (!el) return false;
        el.swiper = swiper;
        const parent = el.parentNode;
        if (parent && parent.host && parent.host.nodeName === swiper.params.swiperElementNodeName.toUpperCase()) swiper.isElement = true;
        const getWrapperSelector = ()=>{
            return `.${(swiper.params.wrapperClass || '').trim().split(' ').join('.')}`;
        };
        const getWrapper = ()=>{
            if (el && el.shadowRoot) {
                const res = el.shadowRoot.querySelector(getWrapperSelector());
                // Children needs to return slot items
                return res;
            }
            return (0, $3e0e2b092da8f124$export$f1e1789686576879)(el, getWrapperSelector())[0];
        };
        // Find Wrapper
        let wrapperEl = getWrapper();
        if (!wrapperEl && swiper.params.createElements) {
            wrapperEl = (0, $3e0e2b092da8f124$export$407448d2b89b1813)('div', swiper.params.wrapperClass);
            el.append(wrapperEl);
            (0, $3e0e2b092da8f124$export$f1e1789686576879)(el, `.${swiper.params.slideClass}`).forEach((slideEl)=>{
                wrapperEl.append(slideEl);
            });
        }
        const host = swiper.isElement ? el.parentNode.host : null;
        Object.assign(swiper, {
            el: el,
            wrapperEl: wrapperEl,
            slidesEl: swiper.isElement && !host.slideSlots ? host : wrapperEl,
            hostEl: swiper.isElement ? host : el,
            mounted: true,
            // RTL
            rtl: el.dir.toLowerCase() === 'rtl' || (0, $3e0e2b092da8f124$export$882b5998b3b9117c)(el, 'direction') === 'rtl',
            rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || (0, $3e0e2b092da8f124$export$882b5998b3b9117c)(el, 'direction') === 'rtl'),
            wrongRTL: (0, $3e0e2b092da8f124$export$882b5998b3b9117c)(wrapperEl, 'display') === '-webkit-box'
        });
        return true;
    }
    /**
     * Initialize slider
     */ init(el) {
        const swiper = this;
        if (swiper.initialized) return swiper;
        const mounted = swiper.mount(el);
        if (mounted === false) return swiper;
        swiper.emit('beforeInit');
        // Set breakpoint
        if (swiper.params.breakpoints) swiper.setBreakpoint();
        // Add Classes
        swiper.addClasses();
        // Update size
        swiper.updateSize();
        // Update slides
        swiper.updateSlides();
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        // Set Grab Cursor
        if (swiper.params.grabCursor && swiper.enabled) swiper.setGrabCursor();
        // Slide To Initial Slide
        if (swiper.params.loop && swiper.virtual && swiper.params.virtual?.enabled) swiper.slideTo((swiper.params.initialSlide ?? 0) + (swiper.virtual.slidesBefore ?? 0), 0, swiper.params.runCallbacksOnInit, false, true);
        else swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
        // Create loop
        if (swiper.params.loop) swiper.loopCreate(undefined, true);
        // Attach events
        swiper.attachEvents();
        const lazyElements = [
            ...swiper.el.querySelectorAll('[loading="lazy"]')
        ];
        if (swiper.isElement) lazyElements.push(...swiper.hostEl.querySelectorAll('[loading="lazy"]'));
        lazyElements.forEach((imageEl)=>{
            if (imageEl.complete) $6946bfb4689eabba$var$processLazyPreloader(swiper, imageEl);
            else imageEl.addEventListener('load', (e)=>{
                $6946bfb4689eabba$var$processLazyPreloader(swiper, e.target);
            });
        });
        $6946bfb4689eabba$var$preload(swiper);
        // Init Flag
        swiper.initialized = true;
        $6946bfb4689eabba$var$preload(swiper);
        // Emit
        swiper.emit('init');
        swiper.emit('afterInit');
        return swiper;
    }
    /**
     * Destroy slider instance and detach all events listeners
     *
     * @param deleteInstance Set it to false (by default it is true) to not to delete Swiper instance
     * @param cleanStyles Set it to true (by default it is true) and all custom styles will be removed from slides, wrapper and container.
     * Useful if you need to destroy Swiper and to init again with new options or in different direction
     */ destroy(deleteInstance = true, cleanStyles = true) {
        const swiper = this;
        const { params: params, el: el, wrapperEl: wrapperEl, slides: slides } = swiper;
        if (typeof swiper.params === 'undefined' || swiper.destroyed) return null;
        swiper.emit('beforeDestroy');
        // Init Flag
        swiper.initialized = false;
        // Detach events
        swiper.detachEvents();
        // Destroy loop
        if (params.loop) swiper.loopDestroy();
        // Cleanup styles
        if (cleanStyles) {
            swiper.removeClasses();
            if (el && typeof el !== 'string') el.removeAttribute('style');
            if (wrapperEl) wrapperEl.removeAttribute('style');
            if (slides && slides.length) slides.forEach((slideEl)=>{
                slideEl.classList.remove(params.slideVisibleClass, params.slideFullyVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
                slideEl.removeAttribute('style');
                slideEl.removeAttribute('data-swiper-slide-index');
            });
        }
        swiper.emit('destroy');
        // Detach emitter events
        Object.keys(swiper.eventsListeners).forEach((eventName)=>{
            swiper.off(eventName);
        });
        if (deleteInstance !== false) {
            if (swiper.el && typeof swiper.el !== 'string') swiper.el.swiper = null;
            (0, $3e0e2b092da8f124$export$4368d992c4eafac0)(swiper);
        }
        swiper.destroyed = true;
        return null;
    }
    static extendDefaults(newDefaults) {
        (0, $3e0e2b092da8f124$export$7ccc53e8f1e7dfc5)($6946bfb4689eabba$var$extendedDefaults, newDefaults);
    }
    static installModule(mod) {
        if (!$6946bfb4689eabba$export$25ce5a424b770e84.prototype.__modules__) $6946bfb4689eabba$export$25ce5a424b770e84.prototype.__modules__ = [];
        const modules = $6946bfb4689eabba$export$25ce5a424b770e84.prototype.__modules__;
        if (typeof mod === 'function' && modules.indexOf(mod) < 0) modules.push(mod);
    }
    static use(module) {
        if (Array.isArray(module)) {
            module.forEach((m)=>$6946bfb4689eabba$export$25ce5a424b770e84.installModule(m));
            return $6946bfb4689eabba$export$25ce5a424b770e84;
        }
        $6946bfb4689eabba$export$25ce5a424b770e84.installModule(module);
        return $6946bfb4689eabba$export$25ce5a424b770e84;
    }
}
Object.defineProperty($6946bfb4689eabba$export$25ce5a424b770e84, 'extendedDefaults', {
    get () {
        return $6946bfb4689eabba$var$extendedDefaults;
    }
});
Object.defineProperty($6946bfb4689eabba$export$25ce5a424b770e84, 'defaults', {
    get () {
        return $6946bfb4689eabba$export$4368d992c4eafac0;
    }
});
// Attach prototype-mixin method groups onto Swiper.prototype. Each group is a
// plain record of method-name → function; we copy them across as-is.
const $6946bfb4689eabba$var$prototypeRecord = $6946bfb4689eabba$var$prototypes;
const $6946bfb4689eabba$var$swiperProto = $6946bfb4689eabba$export$25ce5a424b770e84.prototype;
Object.keys($6946bfb4689eabba$var$prototypeRecord).forEach((prototypeGroup)=>{
    const group = $6946bfb4689eabba$var$prototypeRecord[prototypeGroup];
    Object.keys(group).forEach((protoMethod)=>{
        $6946bfb4689eabba$var$swiperProto[protoMethod] = group[protoMethod];
    });
});
$6946bfb4689eabba$export$25ce5a424b770e84.use([
    $6946bfb4689eabba$var$Resize,
    $6946bfb4689eabba$var$Observer
]);





const $46fa7b324a069045$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on, emit: emit })=>{
    extendParams({
        virtual: {
            enabled: false,
            slides: [],
            cache: true,
            slidesPerViewAutoSlideSize: 320,
            renderSlide: null,
            renderExternal: null,
            renderExternalUpdate: true,
            addSlidesBefore: 0,
            addSlidesAfter: 0
        }
    });
    let cssModeTimeout;
    // Methods (appendSlide/prependSlide/removeSlide/removeAllSlides/update) are
    // attached via Object.assign below once they're defined. Cast through
    // Partial<> so the initial state-only literal can be assigned without
    // pretending the methods exist yet.
    swiper.virtual = {
        cache: {},
        from: 0,
        to: 0,
        slides: [],
        offset: 0,
        slidesGrid: []
    };
    function getParams() {
        return swiper.params.virtual;
    }
    // Created lazily so module init does not touch the DOM (SSR / Node safe).
    let tempDOM;
    const getTempDOM = ()=>tempDOM ??= document.createElement('div');
    function renderSlide(slide, index) {
        const params = getParams();
        if (params.cache && swiper.virtual.cache[index]) return swiper.virtual.cache[index];
        let slideEl;
        if (params.renderSlide) {
            const rendered = params.renderSlide.call(swiper, slide, index);
            if (typeof rendered === 'string') {
                const el = getTempDOM();
                (0, $3e0e2b092da8f124$export$efccba1c4a2ef57b)(el, rendered);
                slideEl = el.children[0];
            } else slideEl = rendered;
        } else if (swiper.isElement) slideEl = (0, $3e0e2b092da8f124$export$407448d2b89b1813)('swiper-slide');
        else slideEl = (0, $3e0e2b092da8f124$export$407448d2b89b1813)('div', swiper.params.slideClass);
        slideEl.setAttribute('data-swiper-slide-index', String(index));
        if (!params.renderSlide) (0, $3e0e2b092da8f124$export$efccba1c4a2ef57b)(slideEl, slide);
        if (params.cache) swiper.virtual.cache[index] = slideEl;
        return slideEl;
    }
    function update(force, beforeInit, forceActiveIndex) {
        const { slidesPerGroup: slidesPerGroup, centeredSlides: centeredSlides, slidesPerView: slidesPerView, loop: isLoop, initialSlide: initialSlide } = swiper.params;
        if (beforeInit && !isLoop && (initialSlide ?? 0) > 0) return;
        const { addSlidesBefore: addSlidesBefore, addSlidesAfter: addSlidesAfter, slidesPerViewAutoSlideSize: slidesPerViewAutoSlideSize } = getParams();
        const { from: previousFrom, to: previousTo, slides: slides, slidesGrid: previousSlidesGrid, offset: previousOffset } = swiper.virtual;
        if (!swiper.params.cssMode) swiper.updateActiveIndex();
        const activeIndex = typeof forceActiveIndex === 'undefined' ? swiper.activeIndex || 0 : forceActiveIndex;
        let offsetProp;
        if (swiper.rtlTranslate) offsetProp = 'right';
        else offsetProp = swiper.isHorizontal() ? 'left' : 'top';
        let slidesPerViewNumeric;
        if (slidesPerView === 'auto') {
            if (slidesPerViewAutoSlideSize) {
                let swiperSize = swiper.size;
                if (!swiperSize) swiperSize = swiper.isHorizontal() ? swiper.el.getBoundingClientRect().width : swiper.el.getBoundingClientRect().height;
                slidesPerViewNumeric = Math.max(1, Math.ceil(swiperSize / slidesPerViewAutoSlideSize));
            } else slidesPerViewNumeric = 1;
        } else slidesPerViewNumeric = slidesPerView ?? 1;
        const groupSize = slidesPerGroup ?? 1;
        let slidesAfter;
        let slidesBefore;
        if (centeredSlides) {
            slidesAfter = Math.floor(slidesPerViewNumeric / 2) + groupSize + addSlidesAfter;
            slidesBefore = Math.floor(slidesPerViewNumeric / 2) + groupSize + addSlidesBefore;
        } else {
            slidesAfter = slidesPerViewNumeric + (groupSize - 1) + addSlidesAfter;
            slidesBefore = (isLoop ? slidesPerViewNumeric : groupSize) + addSlidesBefore;
        }
        let from = activeIndex - slidesBefore;
        let to = activeIndex + slidesAfter;
        if (!isLoop) {
            from = Math.max(from, 0);
            to = Math.min(to, slides.length - 1);
        }
        let offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
        if (isLoop && activeIndex >= slidesBefore) {
            from -= slidesBefore;
            if (!centeredSlides) offset += swiper.slidesGrid[0];
        } else if (isLoop && activeIndex < slidesBefore) {
            from = -slidesBefore;
            if (centeredSlides) offset += swiper.slidesGrid[0];
        }
        Object.assign(swiper.virtual, {
            from: from,
            to: to,
            offset: offset,
            slidesGrid: swiper.slidesGrid,
            slidesBefore: slidesBefore,
            slidesAfter: slidesAfter
        });
        function onRendered() {
            swiper.updateSlides();
            swiper.updateProgress();
            swiper.updateSlidesClasses();
            emit('virtualUpdate');
        }
        if (previousFrom === from && previousTo === to && !force) {
            if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) swiper.slides.forEach((slideEl)=>{
                slideEl.style.setProperty(offsetProp, `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`);
            });
            swiper.updateProgress();
            emit('virtualUpdate');
            return;
        }
        const virtualParams = getParams();
        if (virtualParams.renderExternal) {
            const slidesToRender = [];
            for(let i = from; i <= to; i += 1)slidesToRender.push(slides[i]);
            virtualParams.renderExternal.call(swiper, {
                offset: offset,
                from: from,
                to: to,
                slides: slidesToRender
            });
            if (virtualParams.renderExternalUpdate) onRendered();
            else emit('virtualUpdate');
            return;
        }
        const prependIndexes = [];
        const appendIndexes = [];
        const getSlideIndex = (index)=>{
            let slideIndex = index;
            if (index < 0) slideIndex = slides.length + index;
            else if (slideIndex >= slides.length) slideIndex = slideIndex - slides.length;
            return slideIndex;
        };
        if (force) swiper.slides.filter((el)=>el.matches(`.${swiper.params.slideClass}, swiper-slide`)).forEach((slideEl)=>{
            slideEl.remove();
        });
        else {
            for(let i = previousFrom; i <= previousTo; i += 1)if (i < from || i > to) {
                const slideIndex = getSlideIndex(i);
                swiper.slides.filter((el)=>el.matches(`.${swiper.params.slideClass}[data-swiper-slide-index="${slideIndex}"], swiper-slide[data-swiper-slide-index="${slideIndex}"]`)).forEach((slideEl)=>{
                    slideEl.remove();
                });
            }
        }
        const loopFrom = isLoop ? -slides.length : 0;
        const loopTo = isLoop ? slides.length * 2 : slides.length;
        for(let i = loopFrom; i < loopTo; i += 1)if (i >= from && i <= to) {
            const slideIndex = getSlideIndex(i);
            if (typeof previousTo === 'undefined' || force) appendIndexes.push(slideIndex);
            else {
                if (i > previousTo) appendIndexes.push(slideIndex);
                if (i < previousFrom) prependIndexes.push(slideIndex);
            }
        }
        appendIndexes.forEach((index)=>{
            swiper.slidesEl.append(renderSlide(slides[index], index));
        });
        if (isLoop) for(let i = prependIndexes.length - 1; i >= 0; i -= 1){
            const index = prependIndexes[i];
            swiper.slidesEl.prepend(renderSlide(slides[index], index));
        }
        else {
            prependIndexes.sort((a, b)=>b - a);
            prependIndexes.forEach((index)=>{
                swiper.slidesEl.prepend(renderSlide(slides[index], index));
            });
        }
        (0, $3e0e2b092da8f124$export$f1e1789686576879)(swiper.slidesEl, '.swiper-slide, swiper-slide').forEach((slideEl)=>{
            slideEl.style.setProperty(offsetProp, `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`);
        });
        onRendered();
    }
    function appendSlide(slides) {
        if (slides !== null && typeof slides === 'object' && 'length' in slides) {
            const arr = slides;
            for(let i = 0; i < arr.length; i += 1)if (arr[i]) swiper.virtual.slides.push(arr[i]);
        } else swiper.virtual.slides.push(slides);
        update(true);
    }
    function prependSlide(slides) {
        const activeIndex = swiper.activeIndex;
        let newActiveIndex = activeIndex + 1;
        let numberOfNewSlides = 1;
        if (Array.isArray(slides)) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
            newActiveIndex = activeIndex + slides.length;
            numberOfNewSlides = slides.length;
        } else swiper.virtual.slides.unshift(slides);
        if (getParams().cache) {
            const cache = swiper.virtual.cache;
            const newCache = {};
            Object.keys(cache).forEach((cachedIndex)=>{
                const cachedEl = cache[Number(cachedIndex)];
                const cachedElIndex = cachedEl.getAttribute('data-swiper-slide-index');
                if (cachedElIndex) cachedEl.setAttribute('data-swiper-slide-index', String(parseInt(cachedElIndex, 10) + numberOfNewSlides));
                newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = cachedEl;
            });
            swiper.virtual.cache = newCache;
        }
        update(true);
        swiper.slideTo(newActiveIndex, 0);
    }
    function removeSlide(slidesIndexes) {
        if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) return;
        let activeIndex = swiper.activeIndex;
        const shiftCacheDownFrom = (removedIndex)=>{
            Object.keys(swiper.virtual.cache).forEach((key)=>{
                const numericKey = Number(key);
                if (numericKey > removedIndex) {
                    const shifted = swiper.virtual.cache[numericKey];
                    swiper.virtual.cache[numericKey - 1] = shifted;
                    shifted.setAttribute('data-swiper-slide-index', String(numericKey - 1));
                    delete swiper.virtual.cache[numericKey];
                }
            });
        };
        if (Array.isArray(slidesIndexes)) for(let i = slidesIndexes.length - 1; i >= 0; i -= 1){
            if (getParams().cache) {
                delete swiper.virtual.cache[slidesIndexes[i]];
                shiftCacheDownFrom(slidesIndexes[i]);
            }
            swiper.virtual.slides.splice(slidesIndexes[i], 1);
            if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        else {
            if (getParams().cache) {
                delete swiper.virtual.cache[slidesIndexes];
                shiftCacheDownFrom(slidesIndexes);
            }
            swiper.virtual.slides.splice(slidesIndexes, 1);
            if (slidesIndexes < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        update(true);
        swiper.slideTo(activeIndex, 0);
    }
    function removeAllSlides() {
        swiper.virtual.slides = [];
        if (getParams().cache) swiper.virtual.cache = {};
        update(true);
        swiper.slideTo(0, 0);
    }
    on('beforeInit', ()=>{
        if (!getParams().enabled) return;
        let domSlidesAssigned = false;
        const passedVirtual = swiper.passedParams.virtual;
        const passedSlidesUndefined = !passedVirtual || typeof passedVirtual !== 'object' || passedVirtual.slides === undefined;
        if (passedSlidesUndefined) {
            const slides = [
                ...swiper.slidesEl.children
            ].filter((el)=>el.matches(`.${swiper.params.slideClass}, swiper-slide`));
            if (slides && slides.length) {
                swiper.virtual.slides = [
                    ...slides
                ];
                domSlidesAssigned = true;
                slides.forEach((slideEl, slideIndex)=>{
                    slideEl.setAttribute('data-swiper-slide-index', String(slideIndex));
                    swiper.virtual.cache[slideIndex] = slideEl;
                    slideEl.remove();
                });
            }
        }
        if (!domSlidesAssigned) swiper.virtual.slides = getParams().slides;
        swiper.classNames.push(`${swiper.params.containerModifierClass}virtual`);
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
        update(false, true);
    });
    on('setTranslate', ()=>{
        if (!getParams().enabled) return;
        if (swiper.params.cssMode && !swiper._immediateVirtual) {
            clearTimeout(cssModeTimeout);
            cssModeTimeout = setTimeout(()=>{
                update();
            }, 100);
        } else update();
    });
    on('init update resize', ()=>{
        if (!getParams().enabled) return;
        if (swiper.params.cssMode) (0, $3e0e2b092da8f124$export$90a7f3efeed30595)(swiper.wrapperEl, '--swiper-virtual-size', `${swiper.virtualSize}px`);
    });
    Object.assign(swiper.virtual, {
        appendSlide: appendSlide,
        prependSlide: prependSlide,
        removeSlide: removeSlide,
        removeAllSlides: removeAllSlides,
        update: update
    });
};



const $398e6017151607ad$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on, emit: emit })=>{
    extendParams({
        keyboard: {
            enabled: false,
            onlyInViewport: true,
            pageUpDown: true,
            speed: undefined
        }
    });
    function getParams() {
        return swiper.params.keyboard;
    }
    function handle(event) {
        if (!swiper.enabled) return;
        const { rtlTranslate: rtl } = swiper;
        const e = 'originalEvent' in event && event.originalEvent ? event.originalEvent : event;
        const kc = e.keyCode || e.charCode;
        const params = getParams();
        const pageUpDown = !!params.pageUpDown;
        const isPageUp = pageUpDown && kc === 33;
        const isPageDown = pageUpDown && kc === 34;
        const isArrowLeft = kc === 37;
        const isArrowRight = kc === 39;
        const isArrowUp = kc === 38;
        const isArrowDown = kc === 40;
        // Directions locks
        if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) return false;
        if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) return false;
        if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) return undefined;
        const activeElement = document.activeElement;
        if (activeElement && (activeElement.isContentEditable || activeElement.nodeName && (activeElement.nodeName.toLowerCase() === 'input' || activeElement.nodeName.toLowerCase() === 'textarea'))) return undefined;
        if (params.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
            let inView = false;
            // Check that swiper should be inside of visible area of window
            if ((0, $3e0e2b092da8f124$export$35e795649ee09318)(swiper.el, `.${swiper.params.slideClass}, swiper-slide`).length > 0 && (0, $3e0e2b092da8f124$export$35e795649ee09318)(swiper.el, `.${swiper.params.slideActiveClass}`).length === 0) return undefined;
            const el = swiper.el;
            const swiperWidth = el.clientWidth;
            const swiperHeight = el.clientHeight;
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            const swiperOffset = (0, $3e0e2b092da8f124$export$dda1d9f60106f0e9)(el);
            if (rtl) swiperOffset.left -= el.scrollLeft;
            const swiperCoord = [
                [
                    swiperOffset.left,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left,
                    swiperOffset.top + swiperHeight
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top + swiperHeight
                ]
            ];
            for(let i = 0; i < swiperCoord.length; i += 1){
                const point = swiperCoord[i];
                if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
                    if (point[0] === 0 && point[1] === 0) continue;
                    inView = true;
                }
            }
            if (!inView) return undefined;
        }
        const speed = params.speed;
        if (swiper.isHorizontal()) {
            if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
                if (e.cancelable) e.preventDefault();
            }
            if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext(speed);
            if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev(speed);
        } else {
            if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
                if (e.cancelable) e.preventDefault();
            }
            if (isPageDown || isArrowDown) swiper.slideNext(speed);
            if (isPageUp || isArrowUp) swiper.slidePrev(speed);
        }
        emit('keyPress', kc);
        return undefined;
    }
    function enable() {
        if (swiper.keyboard.enabled) return;
        document.addEventListener('keydown', handle);
        swiper.keyboard.enabled = true;
    }
    function disable() {
        if (!swiper.keyboard.enabled) return;
        document.removeEventListener('keydown', handle);
        swiper.keyboard.enabled = false;
    }
    swiper.keyboard = {
        enabled: false,
        enable: enable,
        disable: disable
    };
    on('init', ()=>{
        if (getParams().enabled) enable();
    });
    on('destroy', ()=>{
        if (swiper.keyboard.enabled) disable();
    });
};



const $343d866400a2e3c2$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on, emit: emit })=>{
    extendParams({
        mousewheel: {
            enabled: false,
            releaseOnEdges: false,
            invert: false,
            forceToAxis: false,
            sensitivity: 1,
            eventsTarget: 'container',
            thresholdDelta: null,
            thresholdTime: null,
            noMousewheelClass: 'swiper-no-mousewheel'
        }
    });
    let timeout;
    let lastScrollTime = (0, $3e0e2b092da8f124$export$3b14a55fb2447963)();
    let lastEventBeforeSnap;
    let mouseEntered = false;
    const recentWheelEvents = [];
    function getParams() {
        return swiper.params.mousewheel;
    }
    function normalize(e) {
        // Reasonable defaults
        const PIXEL_STEP = 10;
        const LINE_HEIGHT = 40;
        const PAGE_HEIGHT = 800;
        const ev = e;
        let sX = 0;
        let sY = 0; // spinX, spinY
        let pX = 0;
        let pY = 0; // pixelX, pixelY
        // Legacy
        if (ev.detail !== undefined) sY = ev.detail;
        if (ev.wheelDelta !== undefined) sY = -ev.wheelDelta / 120;
        if (ev.wheelDeltaY !== undefined) sY = -ev.wheelDeltaY / 120;
        if (ev.wheelDeltaX !== undefined) sX = -ev.wheelDeltaX / 120;
        // side scrolling on FF with DOMMouseScroll
        if (ev.axis !== undefined && ev.HORIZONTAL_AXIS !== undefined && ev.axis === ev.HORIZONTAL_AXIS) {
            sX = sY;
            sY = 0;
        }
        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;
        if (ev.deltaY !== undefined) pY = ev.deltaY;
        if (ev.deltaX !== undefined) pX = ev.deltaX;
        if (ev.shiftKey && !pX) {
            // if user scrolls with shift he wants horizontal scroll
            pX = pY;
            pY = 0;
        }
        if ((pX || pY) && ev.deltaMode) {
            if (ev.deltaMode === 1) {
                // delta in LINE units
                pX *= LINE_HEIGHT;
                pY *= LINE_HEIGHT;
            } else {
                // delta in PAGE units
                pX *= PAGE_HEIGHT;
                pY *= PAGE_HEIGHT;
            }
        }
        // Fall-back if spin cannot be determined
        if (pX && !sX) sX = pX < 1 ? -1 : 1;
        if (pY && !sY) sY = pY < 1 ? -1 : 1;
        return {
            spinX: sX,
            spinY: sY,
            pixelX: pX,
            pixelY: pY
        };
    }
    function handleMouseEnter() {
        if (!swiper.enabled) return;
        mouseEntered = true;
    }
    function handleMouseLeave() {
        if (!swiper.enabled) return;
        mouseEntered = false;
    }
    function animateSlider(newEvent) {
        const params = getParams();
        if (params.thresholdDelta && newEvent.delta < params.thresholdDelta) // Prevent if delta of wheel scroll delta is below configured threshold
        return false;
        if (params.thresholdTime && (0, $3e0e2b092da8f124$export$3b14a55fb2447963)() - lastScrollTime < params.thresholdTime) // Prevent if time between scrolls is below configured threshold
        return false;
        // If the movement is NOT big enough and
        // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
        //   Don't go any further (avoid insignificant scroll movement).
        if (newEvent.delta >= 6 && (0, $3e0e2b092da8f124$export$3b14a55fb2447963)() - lastScrollTime < 60) // Return false as a default
        return true;
        if (newEvent.direction < 0) {
            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
                swiper.slideNext();
                emit('scroll', newEvent.raw);
            }
        } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
            swiper.slidePrev();
            emit('scroll', newEvent.raw);
        }
        // If you got here is because an animation has been triggered so store the current time
        lastScrollTime = new window.Date().getTime();
        // Return false as a default
        return false;
    }
    function releaseScroll(newEvent) {
        const params = getParams();
        if (newEvent.direction < 0) {
            if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
            return true;
        } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
        return true;
        return false;
    }
    function handle(event) {
        let e = 'originalEvent' in event && event.originalEvent ? event.originalEvent : event;
        let disableParentSwiper = true;
        if (!swiper.enabled) return false;
        // Ignore event if the target or its parents have the swiper-no-mousewheel class
        const params = getParams();
        if (event.target.closest(`.${params.noMousewheelClass}`)) return false;
        if (swiper.params.cssMode) e.preventDefault();
        let targetEl = swiper.el;
        if (params.eventsTarget !== 'container') targetEl = document.querySelector(params.eventsTarget);
        const targetElContainsTarget = targetEl && targetEl.contains(e.target);
        if (!mouseEntered && !targetElContainsTarget && !params.releaseOnEdges) return true;
        let delta = 0;
        const rtlFactor = swiper.rtlTranslate ? -1 : 1;
        const data = normalize(e);
        if (params.forceToAxis) {
            if (swiper.isHorizontal()) {
                if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;
                else return true;
            } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;
            else return true;
        } else delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
        if (delta === 0) return true;
        if (params.invert) delta = -delta;
        // Get the scroll positions
        let positions = swiper.getTranslate() + delta * (params.sensitivity ?? 1);
        if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
        if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate();
        // When loop is true:
        //     the disableParentSwiper will be true.
        // When loop is false:
        //     if the scroll positions is not on edge,
        //     then the disableParentSwiper will be true.
        //     if the scroll on edge positions,
        //     then the disableParentSwiper will be false.
        disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
        if (disableParentSwiper && swiper.params.nested) e.stopPropagation();
        const freeModeParams = swiper.params.freeMode;
        if (!swiper.params.freeMode || !freeModeParams?.enabled) {
            // Register the new event in a variable which stores the relevant data
            const newEvent = {
                time: (0, $3e0e2b092da8f124$export$3b14a55fb2447963)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta),
                raw: event
            };
            // Keep the most recent events
            if (recentWheelEvents.length >= 2) recentWheelEvents.shift(); // only store the last N events
            const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
            recentWheelEvents.push(newEvent);
            if (prevEvent) {
                if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) animateSlider(newEvent);
            } else animateSlider(newEvent);
            // If it's time to release the scroll:
            //   Return now so you don't hit the preventDefault.
            if (releaseScroll(newEvent)) return true;
        } else {
            // Freemode or scrollContainer:
            const newEvent = {
                time: (0, $3e0e2b092da8f124$export$3b14a55fb2447963)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta)
            };
            const ignoreWheelEvents = lastEventBeforeSnap && newEvent.time < lastEventBeforeSnap.time + 500 && newEvent.delta <= lastEventBeforeSnap.delta && newEvent.direction === lastEventBeforeSnap.direction;
            if (!ignoreWheelEvents) {
                lastEventBeforeSnap = undefined;
                let position = swiper.getTranslate() + delta * (params.sensitivity ?? 1);
                const wasBeginning = swiper.isBeginning;
                const wasEnd = swiper.isEnd;
                if (position >= swiper.minTranslate()) position = swiper.minTranslate();
                if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
                swiper.setTransition(0);
                swiper.setTranslate(position);
                swiper.updateProgress();
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
                if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) swiper.updateSlidesClasses();
                if (swiper.params.loop) swiper.loopFix({
                    direction: newEvent.direction < 0 ? 'next' : 'prev',
                    byMousewheel: true
                });
                if (freeModeParams?.sticky) {
                    clearTimeout(timeout);
                    timeout = undefined;
                    if (recentWheelEvents.length >= 15) recentWheelEvents.shift(); // only store the last N events
                    const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
                    const firstEvent = recentWheelEvents[0];
                    recentWheelEvents.push(newEvent);
                    if (prevEvent && (newEvent.delta > prevEvent.delta || newEvent.direction !== prevEvent.direction)) // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
                    recentWheelEvents.splice(0);
                    else if (recentWheelEvents.length >= 15 && firstEvent && newEvent.time - firstEvent.time < 500 && firstEvent.delta - newEvent.delta >= 1 && newEvent.delta <= 6) {
                        const snapToThreshold = delta > 0 ? 0.8 : 0.2;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        timeout = (0, $3e0e2b092da8f124$export$625550452a3fa3ec)(()=>{
                            if (swiper.destroyed || !swiper.params) return;
                            swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                        }, 0); // no delay; move on next tick
                    }
                    if (!timeout) timeout = (0, $3e0e2b092da8f124$export$625550452a3fa3ec)(()=>{
                        if (swiper.destroyed || !swiper.params) return;
                        const snapToThreshold = 0.5;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                    }, 500);
                }
                // Emit event
                if (!ignoreWheelEvents) emit('scroll', e);
                // Stop autoplay
                const autoplayParams = swiper.params.autoplay;
                if (swiper.params.autoplay && autoplayParams?.disableOnInteraction) swiper.autoplay.stop();
                // Return page scroll on edge positions
                if (params.releaseOnEdges && (position === swiper.minTranslate() || position === swiper.maxTranslate())) return true;
            }
        }
        if (e.cancelable) e.preventDefault();
        return false;
    }
    function events(method) {
        const params = getParams();
        let targetEl = swiper.el;
        if (params.eventsTarget !== 'container') targetEl = document.querySelector(params.eventsTarget);
        targetEl[method]('mouseenter', handleMouseEnter);
        targetEl[method]('mouseleave', handleMouseLeave);
        targetEl[method]('wheel', handle);
    }
    function enable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.removeEventListener('wheel', handle);
            return true;
        }
        if (swiper.mousewheel.enabled) return false;
        events('addEventListener');
        swiper.mousewheel.enabled = true;
        return true;
    }
    function disable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.addEventListener('wheel', handle);
            return true;
        }
        if (!swiper.mousewheel.enabled) return false;
        events('removeEventListener');
        swiper.mousewheel.enabled = false;
        return true;
    }
    on('init', ()=>{
        const params = getParams();
        if (!params.enabled && swiper.params.cssMode) disable();
        if (params.enabled) enable();
    });
    swiper.mousewheel = {
        enabled: false,
        enable: enable,
        disable: disable
    };
    on('destroy', ()=>{
        if (swiper.params.cssMode) enable();
        if (swiper.mousewheel.enabled) disable();
    });
};



function $d6f86baea06bd282$export$db3b6bfb95261072(swiper, originalParams, params, checkProps) {
    const target = params ?? {};
    const original = originalParams ?? {};
    if (swiper.params.createElements) Object.keys(checkProps).forEach((key)=>{
        if (!target[key] && target.auto === true) {
            let element = (0, $3e0e2b092da8f124$export$f1e1789686576879)(swiper.el, `.${checkProps[key]}`)[0];
            if (!element) {
                element = (0, $3e0e2b092da8f124$export$407448d2b89b1813)('div', checkProps[key]);
                element.className = checkProps[key];
                swiper.el.append(element);
            }
            target[key] = element;
            original[key] = element;
        }
    });
    return target;
}



const $ad56a2ca63fb5863$var$arrowSvg = `<svg class="swiper-navigation-icon" width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.38296 20.0762C0.111788 19.805 0.111788 19.3654 0.38296 19.0942L9.19758 10.2796L0.38296 1.46497C0.111788 1.19379 0.111788 0.754138 0.38296 0.482966C0.654131 0.211794 1.09379 0.211794 1.36496 0.482966L10.4341 9.55214C10.8359 9.9539 10.8359 10.6053 10.4341 11.007L1.36496 20.0762C1.09379 20.3474 0.654131 20.3474 0.38296 20.0762Z" fill="currentColor"/></svg>`;
const $ad56a2ca63fb5863$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on, emit: emit })=>{
    extendParams({
        navigation: {
            nextEl: null,
            prevEl: null,
            addIcons: true,
            hideOnClick: false,
            disabledClass: 'swiper-button-disabled',
            hiddenClass: 'swiper-button-hidden',
            lockClass: 'swiper-button-lock',
            navigationDisabledClass: 'swiper-navigation-disabled'
        }
    });
    // Initialized as a partial; remaining methods (update, init, destroy,
    // enable, disable) attach after their definitions below.
    swiper.navigation = {
        nextEl: null,
        prevEl: null,
        arrowSvg: $ad56a2ca63fb5863$var$arrowSvg
    };
    function getParams() {
        return swiper.params.navigation;
    }
    function getEl(el) {
        let res;
        if (el && typeof el === 'string' && swiper.isElement) {
            res = swiper.el.querySelector(el) || swiper.hostEl.querySelector(el);
            if (res) return res;
        }
        if (el) {
            if (typeof el === 'string') res = [
                ...document.querySelectorAll(el)
            ];
            if (swiper.params.uniqueNavElements && typeof el === 'string' && res && res.length > 1 && swiper.el.querySelectorAll(el).length === 1) res = swiper.el.querySelector(el);
            else if (res && res.length === 1) res = res[0];
        }
        if (el && !res) return el;
        return res;
    }
    function toggleEl(el, disabled) {
        const params = getParams();
        const els = (0, $3e0e2b092da8f124$export$2408f22a0fab9ae5)(el);
        els.forEach((subEl)=>{
            if (subEl) {
                subEl.classList[disabled ? 'add' : 'remove'](...params.disabledClass.split(' '));
                if (subEl.tagName === 'BUTTON') subEl.disabled = disabled;
                if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? 'add' : 'remove'](params.lockClass);
            }
        });
    }
    function update() {
        // Update Navigation Buttons
        const { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        if (swiper.params.loop) {
            toggleEl(prevEl, false);
            toggleEl(nextEl, false);
            return;
        }
        toggleEl(prevEl, swiper.isBeginning && !swiper.params.rewind);
        toggleEl(nextEl, swiper.isEnd && !swiper.params.rewind);
    }
    function onPrevClick(e) {
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slidePrev();
        emit('navigationPrev');
    }
    function onNextClick(e) {
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slideNext();
        emit('navigationNext');
    }
    function init() {
        swiper.params.navigation = (0, $d6f86baea06bd282$export$db3b6bfb95261072)(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
            nextEl: 'swiper-button-next',
            prevEl: 'swiper-button-prev'
        });
        const params = getParams();
        if (!(params.nextEl || params.prevEl)) return;
        const nextEl = getEl(params.nextEl);
        const prevEl = getEl(params.prevEl);
        Object.assign(swiper.navigation, {
            nextEl: nextEl,
            prevEl: prevEl
        });
        const nextEls = (0, $3e0e2b092da8f124$export$2408f22a0fab9ae5)(nextEl);
        const prevEls = (0, $3e0e2b092da8f124$export$2408f22a0fab9ae5)(prevEl);
        const initButton = (el, dir)=>{
            if (el) {
                if (params.addIcons && el.matches('.swiper-button-next,.swiper-button-prev') && !el.querySelector('svg')) {
                    const tempEl = document.createElement('div');
                    (0, $3e0e2b092da8f124$export$efccba1c4a2ef57b)(tempEl, $ad56a2ca63fb5863$var$arrowSvg);
                    const svgEl = tempEl.querySelector('svg');
                    if (svgEl) el.appendChild(svgEl);
                    tempEl.remove();
                }
                el.addEventListener('click', dir === 'next' ? onNextClick : onPrevClick);
            }
            if (!swiper.enabled && el) el.classList.add(...params.lockClass.split(' '));
        };
        nextEls.forEach((el)=>initButton(el, 'next'));
        prevEls.forEach((el)=>initButton(el, 'prev'));
    }
    function destroy() {
        const params = getParams();
        const { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        const nextEls = (0, $3e0e2b092da8f124$export$2408f22a0fab9ae5)(nextEl);
        const prevEls = (0, $3e0e2b092da8f124$export$2408f22a0fab9ae5)(prevEl);
        const destroyButton = (el, dir)=>{
            el.removeEventListener('click', dir === 'next' ? onNextClick : onPrevClick);
            el.classList.remove(...params.disabledClass.split(' '));
        };
        nextEls.forEach((el)=>destroyButton(el, 'next'));
        prevEls.forEach((el)=>destroyButton(el, 'prev'));
    }
    on('init', ()=>{
        if (getParams().enabled === false) disable();
        else {
            init();
            update();
        }
    });
    on('toEdge fromEdge lock unlock', ()=>{
        update();
    });
    on('destroy', ()=>{
        destroy();
    });
    on('enable disable', ()=>{
        const params = getParams();
        const { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        const nextEls = (0, $3e0e2b092da8f124$export$2408f22a0fab9ae5)(nextEl);
        const prevEls = (0, $3e0e2b092da8f124$export$2408f22a0fab9ae5)(prevEl);
        if (swiper.enabled) {
            update();
            return;
        }
        [
            ...nextEls,
            ...prevEls
        ].filter((el)=>!!el).forEach((el)=>el.classList.add(params.lockClass));
    });
    on('click', (_s, e)=>{
        const params = getParams();
        const { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        const nextEls = (0, $3e0e2b092da8f124$export$2408f22a0fab9ae5)(nextEl);
        const prevEls = (0, $3e0e2b092da8f124$export$2408f22a0fab9ae5)(prevEl);
        const targetEl = e.target;
        let targetIsButton = prevEls.includes(targetEl) || nextEls.includes(targetEl);
        if (swiper.isElement && !targetIsButton) {
            const path = e.composedPath ? e.composedPath() : [];
            if (path.length) targetIsButton = path.find((pathEl)=>nextEls.includes(pathEl) || prevEls.includes(pathEl));
        }
        if (params.hideOnClick && !targetIsButton) {
            if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
            let isHidden;
            if (nextEls.length) isHidden = nextEls[0].classList.contains(params.hiddenClass);
            else if (prevEls.length) isHidden = prevEls[0].classList.contains(params.hiddenClass);
            if (isHidden === true) emit('navigationShow');
            else emit('navigationHide');
            [
                ...nextEls,
                ...prevEls
            ].filter((el)=>!!el).forEach((el)=>el.classList.toggle(params.hiddenClass));
        }
    });
    const enable = ()=>{
        const params = getParams();
        swiper.el.classList.remove(...params.navigationDisabledClass.split(' '));
        init();
        update();
    };
    const disable = ()=>{
        const params = getParams();
        swiper.el.classList.add(...params.navigationDisabledClass.split(' '));
        destroy();
    };
    Object.assign(swiper.navigation, {
        enable: enable,
        disable: disable,
        update: update,
        init: init,
        destroy: destroy
    });
};


function $452edee79264d178$export$db3b6bfb95261072(classes = '') {
    return `.${classes.trim().replace(/([.:!+/()[\]#>~*^$|=,'"@{}\\])/g, '\\$1').replace(/ /g, '.')}`;
}




const $4b9f6507912f3e92$var$isVirtualEnabled = (swiper)=>!!swiper.virtual && !!swiper.params.virtual?.enabled;
const $4b9f6507912f3e92$var$isFreeModeEnabled = (swiper)=>!!swiper.params.freeMode?.enabled;
const $4b9f6507912f3e92$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on, emit: emit })=>{
    const pfx = 'swiper-pagination';
    extendParams({
        pagination: {
            el: null,
            bulletElement: 'span',
            clickable: false,
            hideOnClick: false,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: false,
            type: 'bullets',
            dynamicBullets: false,
            dynamicMainBullets: 1,
            formatFractionCurrent: (number)=>number,
            formatFractionTotal: (number)=>number,
            bulletClass: `${pfx}-bullet`,
            bulletActiveClass: `${pfx}-bullet-active`,
            modifierClass: `${pfx}-`,
            currentClass: `${pfx}-current`,
            totalClass: `${pfx}-total`,
            hiddenClass: `${pfx}-hidden`,
            progressbarFillClass: `${pfx}-progressbar-fill`,
            progressbarOppositeClass: `${pfx}-progressbar-opposite`,
            clickableClass: `${pfx}-clickable`,
            lockClass: `${pfx}-lock`,
            horizontalClass: `${pfx}-horizontal`,
            verticalClass: `${pfx}-vertical`,
            paginationDisabledClass: `${pfx}-disabled`
        }
    });
    // Initialized as a partial; remaining methods (render, update, init,
    // destroy, enable, disable) attach after their definitions below.
    swiper.pagination = {
        el: null,
        bullets: []
    };
    let bulletSize;
    let dynamicBulletIndex = 0;
    function getParams() {
        return swiper.params.pagination;
    }
    function isPaginationDisabled() {
        const elParam = getParams().el;
        return !elParam || !swiper.pagination.el || Array.isArray(swiper.pagination.el) && swiper.pagination.el.length === 0;
    }
    function setSideBullets(bulletEl, position) {
        const { bulletActiveClass: bulletActiveClass } = getParams();
        if (!bulletEl) return;
        let current = bulletEl[`${position === 'prev' ? 'previous' : 'next'}ElementSibling`];
        if (current) {
            current.classList.add(`${bulletActiveClass}-${position}`);
            current = current[`${position === 'prev' ? 'previous' : 'next'}ElementSibling`];
            if (current) current.classList.add(`${bulletActiveClass}-${position}-${position}`);
        }
    }
    function getMoveDirection(prevIndex, nextIndex, length) {
        prevIndex = prevIndex % length;
        nextIndex = nextIndex % length;
        if (nextIndex === prevIndex + 1) return 'next';
        else if (nextIndex === prevIndex - 1) return 'previous';
        return undefined;
    }
    function onBulletClick(e) {
        const targetEl = e.target;
        const bulletEl = targetEl.closest((0, $452edee79264d178$export$db3b6bfb95261072)(getParams().bulletClass));
        if (!bulletEl) return;
        e.preventDefault();
        const index = ((0, $3e0e2b092da8f124$export$8b22cf2602fb60ce)(bulletEl) ?? 0) * (swiper.params.slidesPerGroup ?? 1);
        if (swiper.params.loop) {
            if (swiper.realIndex === index) return;
            const moveDirection = getMoveDirection(swiper.realIndex, index, swiper.slides.length);
            if (moveDirection === 'next') swiper.slideNext();
            else if (moveDirection === 'previous') swiper.slidePrev();
            else swiper.slideToLoop(index);
        } else swiper.slideTo(index);
    }
    function update() {
        // Render || Update Pagination bullets/items
        const rtl = swiper.rtl;
        const params = getParams();
        if (isPaginationDisabled()) return;
        const els = (0, $3e0e2b092da8f124$export$2408f22a0fab9ae5)(swiper.pagination.el);
        // Current/Total
        let current;
        let previousIndex;
        const slidesLength = $4b9f6507912f3e92$var$isVirtualEnabled(swiper) ? swiper.virtual.slides.length : swiper.slides.length;
        const total = swiper.params.loop ? Math.ceil(slidesLength / (swiper.params.slidesPerGroup ?? 1)) : swiper.snapGrid.length;
        if (swiper.params.loop) {
            previousIndex = swiper.previousRealIndex || 0;
            current = (swiper.params.slidesPerGroup ?? 1) > 1 ? Math.floor(swiper.realIndex / (swiper.params.slidesPerGroup ?? 1)) : swiper.realIndex;
        } else if (typeof swiper.snapIndex !== 'undefined') {
            current = swiper.snapIndex;
            previousIndex = swiper.previousSnapIndex;
        } else {
            previousIndex = swiper.previousIndex || 0;
            current = swiper.activeIndex || 0;
        }
        // Types
        if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
            const bullets = swiper.pagination.bullets;
            let firstIndex = 0;
            let lastIndex = 0;
            let midIndex = 0;
            if (params.dynamicBullets) {
                bulletSize = (0, $3e0e2b092da8f124$export$23f2a1d2818174ef)(bullets[0], swiper.isHorizontal() ? 'width' : 'height');
                const dim = swiper.isHorizontal() ? 'width' : 'height';
                els.forEach((subEl)=>{
                    subEl.style[dim] = `${(bulletSize ?? 0) * (params.dynamicMainBullets + 4)}px`;
                });
                if (params.dynamicMainBullets > 1 && previousIndex !== undefined) {
                    dynamicBulletIndex += current - (previousIndex || 0);
                    if (dynamicBulletIndex > params.dynamicMainBullets - 1) dynamicBulletIndex = params.dynamicMainBullets - 1;
                    else if (dynamicBulletIndex < 0) dynamicBulletIndex = 0;
                }
                firstIndex = Math.max(current - dynamicBulletIndex, 0);
                lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
                midIndex = (lastIndex + firstIndex) / 2;
            }
            bullets.forEach((bulletEl)=>{
                const classesToRemove = [
                    '',
                    '-next',
                    '-next-next',
                    '-prev',
                    '-prev-prev',
                    '-main'
                ].map((suffix)=>`${params.bulletActiveClass}${suffix}`).flatMap((s)=>typeof s === 'string' && s.includes(' ') ? s.split(' ') : [
                        s
                    ]);
                bulletEl.classList.remove(...classesToRemove);
            });
            if (els.length > 1) bullets.forEach((bullet)=>{
                const bulletIndex = (0, $3e0e2b092da8f124$export$8b22cf2602fb60ce)(bullet);
                if (bulletIndex === current) bullet.classList.add(...params.bulletActiveClass.split(' '));
                else if (swiper.isElement) bullet.setAttribute('part', 'bullet');
                if (params.dynamicBullets && bulletIndex !== undefined) {
                    if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) bullet.classList.add(...`${params.bulletActiveClass}-main`.split(' '));
                    if (bulletIndex === firstIndex) setSideBullets(bullet, 'prev');
                    if (bulletIndex === lastIndex) setSideBullets(bullet, 'next');
                }
            });
            else {
                const bullet = bullets[current];
                if (bullet) bullet.classList.add(...params.bulletActiveClass.split(' '));
                if (swiper.isElement) bullets.forEach((bulletEl, bulletIndex)=>{
                    bulletEl.setAttribute('part', bulletIndex === current ? 'bullet-active' : 'bullet');
                });
                if (params.dynamicBullets) {
                    const firstDisplayedBullet = bullets[firstIndex];
                    const lastDisplayedBullet = bullets[lastIndex];
                    for(let i = firstIndex; i <= lastIndex; i += 1)if (bullets[i]) bullets[i].classList.add(...`${params.bulletActiveClass}-main`.split(' '));
                    setSideBullets(firstDisplayedBullet, 'prev');
                    setSideBullets(lastDisplayedBullet, 'next');
                }
            }
            if (params.dynamicBullets) {
                const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
                const bulletsOffset = ((bulletSize ?? 0) * dynamicBulletsLength - (bulletSize ?? 0)) / 2 - midIndex * (bulletSize ?? 0);
                const offsetProp = rtl ? 'right' : 'left';
                const positionDim = swiper.isHorizontal() ? offsetProp : 'top';
                bullets.forEach((bullet)=>{
                    bullet.style[positionDim] = `${bulletsOffset}px`;
                });
            }
        }
        els.forEach((subEl, subElIndex)=>{
            if (params.type === 'fraction') {
                subEl.querySelectorAll((0, $452edee79264d178$export$db3b6bfb95261072)(params.currentClass)).forEach((fractionEl)=>{
                    fractionEl.textContent = String(params.formatFractionCurrent(current + 1));
                });
                subEl.querySelectorAll((0, $452edee79264d178$export$db3b6bfb95261072)(params.totalClass)).forEach((totalEl)=>{
                    totalEl.textContent = String(params.formatFractionTotal(total));
                });
            }
            if (params.type === 'progressbar') {
                let progressbarDirection;
                if (params.progressbarOpposite) progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
                else progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
                const scale = (current + 1) / total;
                let scaleX = 1;
                let scaleY = 1;
                if (progressbarDirection === 'horizontal') scaleX = scale;
                else scaleY = scale;
                subEl.querySelectorAll((0, $452edee79264d178$export$db3b6bfb95261072)(params.progressbarFillClass)).forEach((progressEl)=>{
                    progressEl.style.transform = `translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`;
                    progressEl.style.transitionDuration = `${swiper.params.speed}ms`;
                });
            }
            if (params.type === 'custom' && params.renderCustom) {
                (0, $3e0e2b092da8f124$export$efccba1c4a2ef57b)(subEl, params.renderCustom(swiper, current + 1, total));
                if (subElIndex === 0) emit('paginationRender', subEl);
            } else {
                if (subElIndex === 0) emit('paginationRender', subEl);
                emit('paginationUpdate', subEl);
            }
            if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? 'add' : 'remove'](params.lockClass);
        });
    }
    function render() {
        // Render Container
        const params = getParams();
        if (isPaginationDisabled()) return;
        const gridParams = swiper.params.grid;
        const slidesLength = $4b9f6507912f3e92$var$isVirtualEnabled(swiper) ? swiper.virtual.slides.length : swiper.grid && gridParams?.rows && gridParams.rows > 1 ? swiper.slides.length / Math.ceil(gridParams.rows) : swiper.slides.length;
        const els = (0, $3e0e2b092da8f124$export$2408f22a0fab9ae5)(swiper.pagination.el);
        let paginationHTML = '';
        if (params.type === 'bullets') {
            let numberOfBullets = swiper.params.loop ? Math.ceil(slidesLength / (swiper.params.slidesPerGroup ?? 1)) : swiper.snapGrid.length;
            if (swiper.params.freeMode && $4b9f6507912f3e92$var$isFreeModeEnabled(swiper) && numberOfBullets > slidesLength) numberOfBullets = slidesLength;
            for(let i = 0; i < numberOfBullets; i += 1)if (params.renderBullet) paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
            else // oxfmt-ignore
            paginationHTML += `<${params.bulletElement} ${swiper.isElement ? 'part="bullet"' : ''} class="${params.bulletClass}"></${params.bulletElement}>`;
        }
        if (params.type === 'fraction') {
            if (params.renderFraction) paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
            else paginationHTML = `<span class="${params.currentClass}"></span>` + ' / ' + `<span class="${params.totalClass}"></span>`;
        }
        if (params.type === 'progressbar') {
            if (params.renderProgressbar) paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
            else paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
        }
        swiper.pagination.bullets = [];
        els.forEach((subEl)=>{
            if (params.type !== 'custom') (0, $3e0e2b092da8f124$export$efccba1c4a2ef57b)(subEl, paginationHTML || '');
            if (params.type === 'bullets') swiper.pagination.bullets.push(...Array.from(subEl.querySelectorAll((0, $452edee79264d178$export$db3b6bfb95261072)(params.bulletClass))));
        });
        if (params.type !== 'custom') emit('paginationRender', els[0]);
    }
    function init() {
        swiper.params.pagination = (0, $d6f86baea06bd282$export$db3b6bfb95261072)(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
            el: 'swiper-pagination'
        });
        const params = getParams();
        if (!params.el) return;
        let el;
        if (typeof params.el === 'string' && swiper.isElement) el = swiper.el.querySelector(params.el);
        if (!el && typeof params.el === 'string') el = [
            ...document.querySelectorAll(params.el)
        ];
        if (!el) el = params.el;
        if (!el || Array.isArray(el) && el.length === 0) return;
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && Array.isArray(el) && el.length > 1) {
            el = [
                ...swiper.el.querySelectorAll(params.el)
            ];
            // check if it belongs to another nested Swiper
            if (el.length > 1) {
                const found = el.find((subEl)=>{
                    if ((0, $3e0e2b092da8f124$export$35e795649ee09318)(subEl, '.swiper')[0] !== swiper.el) return false;
                    return true;
                });
                if (found) el = found;
            }
        }
        if (Array.isArray(el) && el.length === 1) el = el[0];
        Object.assign(swiper.pagination, {
            el: el
        });
        const els = (0, $3e0e2b092da8f124$export$2408f22a0fab9ae5)(el);
        els.forEach((subEl)=>{
            if (params.type === 'bullets' && params.clickable) subEl.classList.add(...(params.clickableClass || '').split(' '));
            subEl.classList.add(params.modifierClass + params.type);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
            if (params.type === 'bullets' && params.dynamicBullets) {
                subEl.classList.add(`${params.modifierClass}${params.type}-dynamic`);
                dynamicBulletIndex = 0;
                if (params.dynamicMainBullets < 1) params.dynamicMainBullets = 1;
            }
            if (params.type === 'progressbar' && params.progressbarOpposite) subEl.classList.add(params.progressbarOppositeClass);
            if (params.clickable) subEl.addEventListener('click', onBulletClick);
            if (!swiper.enabled) subEl.classList.add(params.lockClass);
        });
    }
    function destroy() {
        const params = getParams();
        if (isPaginationDisabled()) return;
        const el = swiper.pagination.el;
        if (el) {
            const els = (0, $3e0e2b092da8f124$export$2408f22a0fab9ae5)(el);
            els.forEach((subEl)=>{
                subEl.classList.remove(params.hiddenClass);
                subEl.classList.remove(params.modifierClass + params.type);
                subEl.classList.remove(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
                if (params.clickable) {
                    subEl.classList.remove(...(params.clickableClass || '').split(' '));
                    subEl.removeEventListener('click', onBulletClick);
                }
            });
        }
        if (swiper.pagination.bullets) swiper.pagination.bullets.forEach((subEl)=>subEl.classList.remove(...params.bulletActiveClass.split(' ')));
    }
    on('changeDirection', ()=>{
        if (!swiper.pagination || !swiper.pagination.el) return;
        const params = getParams();
        const els = (0, $3e0e2b092da8f124$export$2408f22a0fab9ae5)(swiper.pagination.el);
        els.forEach((subEl)=>{
            subEl.classList.remove(params.horizontalClass, params.verticalClass);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        });
    });
    on('init', ()=>{
        if (getParams().enabled === false) disable();
        else {
            init();
            render();
            update();
        }
    });
    on('activeIndexChange', ()=>{
        if (typeof swiper.snapIndex === 'undefined') update();
    });
    on('snapIndexChange', ()=>{
        update();
    });
    on('snapGridLengthChange', ()=>{
        render();
        update();
    });
    on('destroy', ()=>{
        destroy();
    });
    on('enable disable', ()=>{
        const { el: el } = swiper.pagination;
        if (el) {
            const params = getParams();
            const els = (0, $3e0e2b092da8f124$export$2408f22a0fab9ae5)(el);
            els.forEach((subEl)=>subEl.classList[swiper.enabled ? 'remove' : 'add'](params.lockClass));
        }
    });
    on('lock unlock', ()=>{
        update();
    });
    on('click', (_s, e)=>{
        const targetEl = e.target;
        const els = (0, $3e0e2b092da8f124$export$2408f22a0fab9ae5)(swiper.pagination.el);
        const params = getParams();
        if (params.el && params.hideOnClick && els && els.length > 0 && !targetEl.classList.contains(params.bulletClass)) {
            if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
            const isHidden = els[0].classList.contains(params.hiddenClass);
            if (isHidden === true) emit('paginationShow');
            else emit('paginationHide');
            els.forEach((subEl)=>subEl.classList.toggle(params.hiddenClass));
        }
    });
    const enable = ()=>{
        const params = getParams();
        swiper.el.classList.remove(params.paginationDisabledClass);
        const { el: el } = swiper.pagination;
        if (el) {
            const els = (0, $3e0e2b092da8f124$export$2408f22a0fab9ae5)(el);
            els.forEach((subEl)=>subEl.classList.remove(params.paginationDisabledClass));
        }
        init();
        render();
        update();
    };
    const disable = ()=>{
        const params = getParams();
        swiper.el.classList.add(params.paginationDisabledClass);
        const { el: el } = swiper.pagination;
        if (el) {
            const els = (0, $3e0e2b092da8f124$export$2408f22a0fab9ae5)(el);
            els.forEach((subEl)=>subEl.classList.add(params.paginationDisabledClass));
        }
        destroy();
    };
    Object.assign(swiper.pagination, {
        enable: enable,
        disable: disable,
        render: render,
        update: update,
        init: init,
        destroy: destroy
    });
};





const $86d9ada396b8d520$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on, emit: emit })=>{
    let isTouched = false;
    let timeout = null;
    let dragTimeout = null;
    let dragStartPos = 0;
    let dragSize = 0;
    let trackSize = 0;
    let divider = 0;
    extendParams({
        scrollbar: {
            el: null,
            dragSize: 'auto',
            hide: false,
            draggable: false,
            snapOnRelease: true,
            lockClass: 'swiper-scrollbar-lock',
            dragClass: 'swiper-scrollbar-drag',
            scrollbarDisabledClass: 'swiper-scrollbar-disabled',
            horizontalClass: `swiper-scrollbar-horizontal`,
            verticalClass: `swiper-scrollbar-vertical`
        }
    });
    // Initialized as a partial; remaining methods (updateSize, setTranslate,
    // init, destroy, enable, disable) attach after their definitions below.
    swiper.scrollbar = {
        el: null,
        dragEl: null
    };
    function getParams() {
        return swiper.params.scrollbar;
    }
    function setTranslate() {
        const params = getParams();
        if (!params.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar, rtlTranslate: rtl } = swiper;
        const { dragEl: dragEl, el: el } = scrollbar;
        const progress = swiper.params.loop ? swiper.progressLoop ?? 0 : swiper.progress;
        let newSize = dragSize;
        let newPos = (trackSize - dragSize) * progress;
        if (rtl) {
            newPos = -newPos;
            if (newPos > 0) {
                newSize = dragSize - newPos;
                newPos = 0;
            } else if (-newPos + dragSize > trackSize) newSize = trackSize + newPos;
        } else if (newPos < 0) {
            newSize = dragSize + newPos;
            newPos = 0;
        } else if (newPos + dragSize > trackSize) newSize = trackSize - newPos;
        if (swiper.isHorizontal()) {
            dragEl.style.transform = `translate3d(${newPos}px, 0, 0)`;
            dragEl.style.width = `${newSize}px`;
        } else {
            dragEl.style.transform = `translate3d(0px, ${newPos}px, 0)`;
            dragEl.style.height = `${newSize}px`;
        }
        if (params.hide) {
            if (timeout) clearTimeout(timeout);
            el.style.opacity = '1';
            timeout = setTimeout(()=>{
                el.style.opacity = '0';
                el.style.transitionDuration = '400ms';
            }, 1000);
        }
    }
    function setTransition(duration) {
        if (!getParams().el || !swiper.scrollbar.el) return;
        swiper.scrollbar.dragEl.style.transitionDuration = `${duration}ms`;
    }
    function updateSize() {
        const params = getParams();
        if (!params.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar } = swiper;
        const { dragEl: dragEl, el: el } = scrollbar;
        dragEl.style.width = '';
        dragEl.style.height = '';
        trackSize = swiper.isHorizontal() ? el.offsetWidth : el.offsetHeight;
        divider = swiper.size / (swiper.virtualSize + (swiper.params.slidesOffsetBefore ?? 0) - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));
        if (params.dragSize === 'auto') dragSize = trackSize * divider;
        else dragSize = parseInt(String(params.dragSize), 10);
        if (swiper.isHorizontal()) dragEl.style.width = `${dragSize}px`;
        else dragEl.style.height = `${dragSize}px`;
        if (divider >= 1) el.style.display = 'none';
        else el.style.display = '';
        if (params.hide) el.style.opacity = '0';
        if (swiper.params.watchOverflow && swiper.enabled) scrollbar.el.classList[swiper.isLocked ? 'add' : 'remove'](params.lockClass);
    }
    function getPointerPosition(e) {
        if (swiper.isHorizontal()) return e.clientX ?? e.touches?.[0]?.clientX ?? 0;
        return e.clientY ?? e.touches?.[0]?.clientY ?? 0;
    }
    function setDragPosition(e) {
        const { scrollbar: scrollbar, rtlTranslate: rtl } = swiper;
        const { el: el } = scrollbar;
        let positionRatio;
        positionRatio = (getPointerPosition(e) - (0, $3e0e2b092da8f124$export$dda1d9f60106f0e9)(el)[swiper.isHorizontal() ? 'left' : 'top'] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
        positionRatio = Math.max(Math.min(positionRatio, 1), 0);
        if (rtl) positionRatio = 1 - positionRatio;
        const position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
        swiper.updateProgress(position);
        swiper.setTranslate(position);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    function onDragStart(e) {
        const params = getParams();
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el, dragEl: dragEl } = scrollbar;
        isTouched = true;
        dragStartPos = e.target === dragEl ? getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
        e.preventDefault();
        e.stopPropagation();
        wrapperEl.style.transitionDuration = '100ms';
        dragEl.style.transitionDuration = '100ms';
        setDragPosition(e);
        if (dragTimeout) clearTimeout(dragTimeout);
        el.style.transitionDuration = '0ms';
        if (params.hide) el.style.opacity = '1';
        if (swiper.params.cssMode) swiper.wrapperEl.style.scrollSnapType = 'none';
        emit('scrollbarDragStart', e);
    }
    function onDragMove(e) {
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el, dragEl: dragEl } = scrollbar;
        if (!isTouched) return;
        if (e.cancelable) e.preventDefault();
        setDragPosition(e);
        wrapperEl.style.transitionDuration = '0ms';
        el.style.transitionDuration = '0ms';
        dragEl.style.transitionDuration = '0ms';
        emit('scrollbarDragMove', e);
    }
    function onDragEnd(e) {
        const params = getParams();
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el } = scrollbar;
        if (!isTouched) return;
        isTouched = false;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.scrollSnapType = '';
            wrapperEl.style.transitionDuration = '';
        }
        if (params.hide) {
            if (dragTimeout) clearTimeout(dragTimeout);
            dragTimeout = (0, $3e0e2b092da8f124$export$625550452a3fa3ec)(()=>{
                el.style.opacity = '0';
                el.style.transitionDuration = '400ms';
            }, 1000);
        }
        emit('scrollbarDragEnd', e);
        if (params.snapOnRelease) swiper.slideToClosest();
    }
    function events(method) {
        const { scrollbar: scrollbar, params: params } = swiper;
        const el = scrollbar.el;
        if (!el) return;
        const activeListener = params.passiveListeners ? {
            passive: false,
            capture: false
        } : false;
        const passiveListener = params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        const eventMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
        el[eventMethod]('pointerdown', onDragStart, activeListener);
        document[eventMethod]('pointermove', onDragMove, activeListener);
        document[eventMethod]('pointerup', onDragEnd, passiveListener);
    }
    function enableDraggable() {
        if (!getParams().el || !swiper.scrollbar.el) return;
        events('on');
    }
    function disableDraggable() {
        if (!getParams().el || !swiper.scrollbar.el) return;
        events('off');
    }
    function init() {
        const { scrollbar: scrollbar, el: swiperEl } = swiper;
        swiper.params.scrollbar = (0, $d6f86baea06bd282$export$db3b6bfb95261072)(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
            el: 'swiper-scrollbar'
        });
        const params = getParams();
        if (!params.el) return;
        let el;
        if (typeof params.el === 'string' && swiper.isElement) el = swiper.el.querySelector(params.el);
        else el = params.el;
        if (!el && typeof params.el === 'string') {
            el = document.querySelectorAll(params.el);
            if (!el.length) return;
        } else if (!el) el = params.el;
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && el.length > 1 && swiperEl.querySelectorAll(params.el).length === 1) el = swiperEl.querySelector(params.el);
        if (el.length > 0) el = el[0];
        const elTyped = el;
        elTyped.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        let dragEl = null;
        if (elTyped) {
            dragEl = elTyped.querySelector((0, $452edee79264d178$export$db3b6bfb95261072)(params.dragClass));
            if (!dragEl) {
                dragEl = (0, $3e0e2b092da8f124$export$407448d2b89b1813)('div', params.dragClass);
                elTyped.append(dragEl);
            }
        }
        Object.assign(scrollbar, {
            el: elTyped,
            dragEl: dragEl
        });
        if (params.draggable) enableDraggable();
        if (elTyped) elTyped.classList[swiper.enabled ? 'remove' : 'add'](...(0, $3e0e2b092da8f124$export$db3b6bfb95261072)(params.lockClass));
    }
    function destroy() {
        const params = getParams();
        const el = swiper.scrollbar.el;
        if (el) el.classList.remove(...(0, $3e0e2b092da8f124$export$db3b6bfb95261072)(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass));
        disableDraggable();
    }
    on('changeDirection', ()=>{
        if (!swiper.scrollbar || !swiper.scrollbar.el) return;
        const params = getParams();
        const els = (0, $3e0e2b092da8f124$export$2408f22a0fab9ae5)(swiper.scrollbar.el);
        els.forEach((subEl)=>{
            subEl.classList.remove(params.horizontalClass, params.verticalClass);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        });
    });
    on('init', ()=>{
        if (getParams().enabled === false) disable();
        else {
            init();
            updateSize();
            setTranslate();
        }
    });
    on('update resize observerUpdate lock unlock changeDirection', ()=>{
        updateSize();
    });
    on('setTranslate', ()=>{
        setTranslate();
    });
    on('setTransition', (_s, duration)=>{
        setTransition(duration);
    });
    on('enable disable', ()=>{
        const { el: el } = swiper.scrollbar;
        if (el) el.classList[swiper.enabled ? 'remove' : 'add'](...(0, $3e0e2b092da8f124$export$db3b6bfb95261072)(getParams().lockClass));
    });
    on('destroy', ()=>{
        destroy();
    });
    const enable = ()=>{
        const params = getParams();
        swiper.el.classList.remove(...(0, $3e0e2b092da8f124$export$db3b6bfb95261072)(params.scrollbarDisabledClass));
        if (swiper.scrollbar.el) swiper.scrollbar.el.classList.remove(...(0, $3e0e2b092da8f124$export$db3b6bfb95261072)(params.scrollbarDisabledClass));
        init();
        updateSize();
        setTranslate();
    };
    const disable = ()=>{
        const params = getParams();
        swiper.el.classList.add(...(0, $3e0e2b092da8f124$export$db3b6bfb95261072)(params.scrollbarDisabledClass));
        if (swiper.scrollbar.el) swiper.scrollbar.el.classList.add(...(0, $3e0e2b092da8f124$export$db3b6bfb95261072)(params.scrollbarDisabledClass));
        destroy();
    };
    Object.assign(swiper.scrollbar, {
        enable: enable,
        disable: disable,
        updateSize: updateSize,
        setTranslate: setTranslate,
        init: init,
        destroy: destroy
    });
};



const $9a5a5dc98a39a784$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on })=>{
    extendParams({
        parallax: {
            enabled: false
        }
    });
    function getParams() {
        return swiper.params.parallax;
    }
    const elementsSelector = '[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]';
    const setTransform = (el, progress)=>{
        const { rtl: rtl } = swiper;
        const rtlFactor = rtl ? -1 : 1;
        const p = el.getAttribute('data-swiper-parallax') || '0';
        let x = el.getAttribute('data-swiper-parallax-x');
        let y = el.getAttribute('data-swiper-parallax-y');
        const scale = el.getAttribute('data-swiper-parallax-scale');
        const opacity = el.getAttribute('data-swiper-parallax-opacity');
        const rotate = el.getAttribute('data-swiper-parallax-rotate');
        if (x || y) {
            x = x || '0';
            y = y || '0';
        } else if (swiper.isHorizontal()) {
            x = p;
            y = '0';
        } else {
            y = p;
            x = '0';
        }
        if (x.indexOf('%') >= 0) x = `${parseInt(x, 10) * progress * rtlFactor}%`;
        else x = `${Number(x) * progress * rtlFactor}px`;
        if (y.indexOf('%') >= 0) y = `${parseInt(y, 10) * progress}%`;
        else y = `${Number(y) * progress}px`;
        if (typeof opacity !== 'undefined' && opacity !== null) {
            const opacityNum = Number(opacity);
            const currentOpacity = opacityNum - (opacityNum - 1) * (1 - Math.abs(progress));
            el.style.opacity = String(currentOpacity);
        }
        let transform = `translate3d(${x}, ${y}, 0px)`;
        if (typeof scale !== 'undefined' && scale !== null) {
            const scaleNum = Number(scale);
            const currentScale = scaleNum - (scaleNum - 1) * (1 - Math.abs(progress));
            transform += ` scale(${currentScale})`;
        }
        if (rotate && typeof rotate !== 'undefined' && rotate !== null) {
            const currentRotate = Number(rotate) * progress * -1;
            transform += ` rotate(${currentRotate}deg)`;
        }
        el.style.transform = transform;
    };
    const setTranslate = ()=>{
        const { el: el, slides: slides, progress: progress, snapGrid: snapGrid } = swiper;
        const elements = (0, $3e0e2b092da8f124$export$f1e1789686576879)(el, elementsSelector);
        if (swiper.isElement) elements.push(...(0, $3e0e2b092da8f124$export$f1e1789686576879)(swiper.hostEl, elementsSelector));
        elements.forEach((subEl)=>{
            setTransform(subEl, progress);
        });
        slides.forEach((slideEl, slideIndex)=>{
            let slideProgress = slideEl.progress ?? 0;
            const slidesPerGroup = swiper.params.slidesPerGroup ?? 1;
            if (slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
            slideProgress = Math.min(Math.max(slideProgress, -1), 1);
            slideEl.querySelectorAll(`${elementsSelector}, [data-swiper-parallax-rotate]`).forEach((subEl)=>{
                setTransform(subEl, slideProgress);
            });
        });
    };
    const setTransition = (duration = swiper.params.speed ?? 300)=>{
        const { el: el, hostEl: hostEl } = swiper;
        const elements = [
            ...el.querySelectorAll(elementsSelector)
        ];
        if (swiper.isElement) elements.push(...hostEl.querySelectorAll(elementsSelector));
        elements.forEach((parallaxEl)=>{
            const attr = parallaxEl.getAttribute('data-swiper-parallax-duration');
            let parallaxDuration = (attr ? parseInt(attr, 10) : 0) || duration;
            if (duration === 0) parallaxDuration = 0;
            parallaxEl.style.transitionDuration = `${parallaxDuration}ms`;
        });
    };
    on('beforeInit', ()=>{
        if (!getParams().enabled) return;
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
    });
    on('init', ()=>{
        if (!getParams().enabled) return;
        setTranslate();
    });
    on('setTranslate', ()=>{
        if (!getParams().enabled) return;
        setTranslate();
    });
    on('setTransition', (_swiper, duration)=>{
        if (!getParams().enabled) return;
        setTransition(duration);
    });
};



const $902ac29743f68e69$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on, emit: emit })=>{
    extendParams({
        zoom: {
            enabled: false,
            limitToOriginalSize: false,
            maxRatio: 3,
            minRatio: 1,
            panOnMouseMove: false,
            toggle: true,
            containerClass: 'swiper-zoom-container',
            zoomedSlideClass: 'swiper-slide-zoomed'
        }
    });
    swiper.zoom = {
        enabled: false
    };
    function getParams() {
        return swiper.params.zoom;
    }
    let currentScale = 1;
    let isScaling = false;
    let isPanningWithMouse = false;
    let mousePanStart = {
        x: 0,
        y: 0
    };
    const mousePanSensitivity = -3; // Negative to invert pan direction
    let fakeGestureTouched = false;
    let fakeGestureMoved = false;
    const evCache = [];
    const gesture = {
        originX: 0,
        originY: 0,
        slideEl: undefined,
        slideWidth: undefined,
        slideHeight: undefined,
        imageEl: undefined,
        imageWrapEl: undefined,
        maxRatio: 3
    };
    const image = {
        isTouched: undefined,
        isMoved: undefined,
        currentX: undefined,
        currentY: undefined,
        minX: undefined,
        minY: undefined,
        maxX: undefined,
        maxY: undefined,
        width: undefined,
        height: undefined,
        startX: undefined,
        startY: undefined,
        touchesStart: {},
        touchesCurrent: {}
    };
    const velocity = {
        x: undefined,
        y: undefined,
        prevPositionX: undefined,
        prevPositionY: undefined,
        prevTime: undefined
    };
    let scale = 1;
    Object.defineProperty(swiper.zoom, 'scale', {
        get () {
            return scale;
        },
        set (value) {
            if (scale !== value) {
                const imageEl = gesture.imageEl;
                const slideEl = gesture.slideEl;
                emit('zoomChange', value, imageEl, slideEl);
            }
            scale = value;
        }
    });
    function getDistanceBetweenTouches() {
        if (evCache.length < 2) return 1;
        const x1 = evCache[0].pageX;
        const y1 = evCache[0].pageY;
        const x2 = evCache[1].pageX;
        const y2 = evCache[1].pageY;
        const distance = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
        return distance;
    }
    function getMaxRatio() {
        const params = getParams();
        const attr = gesture.imageWrapEl?.getAttribute('data-swiper-zoom');
        const maxRatio = attr != null ? Number(attr) : params.maxRatio;
        const imageEl = gesture.imageEl;
        if (params.limitToOriginalSize && imageEl && imageEl.naturalWidth) {
            const imageMaxRatio = imageEl.naturalWidth / imageEl.offsetWidth;
            return Math.min(imageMaxRatio, maxRatio);
        }
        return maxRatio;
    }
    function getScaleOrigin() {
        if (evCache.length < 2 || !gesture.imageEl) return [
            null,
            null
        ];
        const box = gesture.imageEl.getBoundingClientRect();
        return [
            (evCache[0].pageX + (evCache[1].pageX - evCache[0].pageX) / 2 - box.x - window.scrollX) / currentScale,
            (evCache[0].pageY + (evCache[1].pageY - evCache[0].pageY) / 2 - box.y - window.scrollY) / currentScale
        ];
    }
    function getSlideSelector() {
        return swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
    }
    function eventWithinSlide(e) {
        const slideSelector = getSlideSelector();
        const target = e.target;
        if (!target) return false;
        if (target.matches(slideSelector)) return true;
        if (swiper.slides.filter((slideEl)=>slideEl.contains(target)).length > 0) return true;
        return false;
    }
    function eventWithinZoomContainer(e) {
        const selector = `.${getParams().containerClass}`;
        const target = e.target;
        if (!target) return false;
        if (target.matches(selector)) return true;
        if ([
            ...swiper.hostEl.querySelectorAll(selector)
        ].filter((containerEl)=>containerEl.contains(target)).length > 0) return true;
        return false;
    }
    // Events
    function onGestureStart(e) {
        if (e.pointerType === 'mouse') evCache.splice(0, evCache.length);
        if (!eventWithinSlide(e)) return;
        const params = getParams();
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        evCache.push(e);
        if (evCache.length < 2) return;
        fakeGestureTouched = true;
        gesture.scaleStart = getDistanceBetweenTouches();
        if (!gesture.slideEl) {
            const target = e.target;
            gesture.slideEl = target?.closest(`.${swiper.params.slideClass}, swiper-slide`) ?? undefined;
            if (!gesture.slideEl) gesture.slideEl = swiper.slides[swiper.activeIndex];
            let imageEl = gesture.slideEl?.querySelector(`.${params.containerClass}`) ?? null;
            if (imageEl) imageEl = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0] ?? null;
            gesture.imageEl = imageEl ?? undefined;
            if (imageEl) gesture.imageWrapEl = (0, $3e0e2b092da8f124$export$35e795649ee09318)(imageEl, `.${params.containerClass}`)[0] ?? undefined;
            else gesture.imageWrapEl = undefined;
            if (!gesture.imageWrapEl) {
                gesture.imageEl = undefined;
                return;
            }
            gesture.maxRatio = getMaxRatio();
        }
        if (gesture.imageEl) {
            const [originX, originY] = getScaleOrigin();
            gesture.originX = originX ?? 0;
            gesture.originY = originY ?? 0;
            gesture.imageEl.style.transitionDuration = '0ms';
        }
        isScaling = true;
    }
    function onGestureChange(e) {
        if (!eventWithinSlide(e)) return;
        const params = getParams();
        const zoom = swiper.zoom;
        const pointerIndex = evCache.findIndex((cachedEv)=>cachedEv.pointerId === e.pointerId);
        if (pointerIndex >= 0) evCache[pointerIndex] = e;
        if (evCache.length < 2) return;
        fakeGestureMoved = true;
        gesture.scaleMove = getDistanceBetweenTouches();
        if (!gesture.imageEl) return;
        zoom.scale = gesture.scaleMove / (gesture.scaleStart ?? 1) * currentScale;
        if (zoom.scale > gesture.maxRatio) zoom.scale = gesture.maxRatio - 1 + (zoom.scale - gesture.maxRatio + 1) ** 0.5;
        if (zoom.scale < params.minRatio) zoom.scale = params.minRatio + 1 - (params.minRatio - zoom.scale + 1) ** 0.5;
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
    }
    function onGestureEnd(e) {
        if (!eventWithinSlide(e)) return;
        if (e.pointerType === 'mouse' && e.type === 'pointerout') return;
        const params = getParams();
        const zoom = swiper.zoom;
        const pointerIndex = evCache.findIndex((cachedEv)=>cachedEv.pointerId === e.pointerId);
        if (pointerIndex >= 0) evCache.splice(pointerIndex, 1);
        if (!fakeGestureTouched || !fakeGestureMoved) return;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        if (!gesture.imageEl) return;
        zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
        gesture.imageEl.style.transitionDuration = `${swiper.params.speed}ms`;
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
        currentScale = zoom.scale;
        isScaling = false;
        if (zoom.scale > 1 && gesture.slideEl) gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
        else if (zoom.scale <= 1 && gesture.slideEl) gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
        if (zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
            gesture.slideEl = undefined;
        }
    }
    let allowTouchMoveTimeout;
    function allowTouchMove() {
        swiper.touchEventsData.preventTouchMoveFromPointerMove = false;
    }
    function preventTouchMove() {
        if (allowTouchMoveTimeout !== undefined) clearTimeout(allowTouchMoveTimeout);
        swiper.touchEventsData.preventTouchMoveFromPointerMove = true;
        allowTouchMoveTimeout = setTimeout(()=>{
            if (swiper.destroyed) return;
            allowTouchMove();
        });
    }
    function onTouchStart(e) {
        const device = swiper.device;
        if (!gesture.imageEl) return;
        if (image.isTouched) return;
        if (device.android && e.cancelable) e.preventDefault();
        image.isTouched = true;
        const event = evCache.length > 0 ? evCache[0] : e;
        image.touchesStart.x = event.pageX;
        image.touchesStart.y = event.pageY;
    }
    function onTouchMove(e) {
        const isMouseEvent = e.pointerType === 'mouse';
        const isMousePan = isMouseEvent && getParams().panOnMouseMove;
        if (!eventWithinSlide(e) || !eventWithinZoomContainer(e)) return;
        const zoom = swiper.zoom;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !gesture.slideEl) {
            if (isMousePan) onMouseMove(e);
            return;
        }
        if (isMousePan) {
            onMouseMove(e);
            return;
        }
        if (!image.isMoved) {
            image.width = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            image.height = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            image.startX = (0, $3e0e2b092da8f124$export$9e5f44173e64f162)(gesture.imageWrapEl, 'x') || 0;
            image.startY = (0, $3e0e2b092da8f124$export$9e5f44173e64f162)(gesture.imageWrapEl, 'y') || 0;
            gesture.slideWidth = gesture.slideEl.offsetWidth;
            gesture.slideHeight = gesture.slideEl.offsetHeight;
            gesture.imageWrapEl.style.transitionDuration = '0ms';
        }
        // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.touchesCurrent.x = evCache.length > 0 ? evCache[0].pageX : e.pageX;
        image.touchesCurrent.y = evCache.length > 0 ? evCache[0].pageY : e.pageY;
        const touchesDiff = Math.max(Math.abs(image.touchesCurrent.x - (image.touchesStart.x ?? 0)), Math.abs(image.touchesCurrent.y - (image.touchesStart.y ?? 0)));
        if (touchesDiff > 5) swiper.allowClick = false;
        const startX = image.startX ?? 0;
        const startY = image.startY ?? 0;
        if (!image.isMoved && !isScaling) {
            if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(startX) && image.touchesCurrent.x < (image.touchesStart.x ?? 0) || Math.floor(image.maxX) === Math.floor(startX) && image.touchesCurrent.x > (image.touchesStart.x ?? 0))) {
                image.isTouched = false;
                allowTouchMove();
                return;
            }
            if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(startY) && image.touchesCurrent.y < (image.touchesStart.y ?? 0) || Math.floor(image.maxY) === Math.floor(startY) && image.touchesCurrent.y > (image.touchesStart.y ?? 0))) {
                image.isTouched = false;
                allowTouchMove();
                return;
            }
        }
        if (e.cancelable) e.preventDefault();
        e.stopPropagation();
        preventTouchMove();
        image.isMoved = true;
        const scaleRatio = (zoom.scale - currentScale) / (gesture.maxRatio - getParams().minRatio);
        const { originX: originX, originY: originY } = gesture;
        image.currentX = image.touchesCurrent.x - (image.touchesStart.x ?? 0) + startX + scaleRatio * (image.width - originX * 2);
        image.currentY = image.touchesCurrent.y - (image.touchesStart.y ?? 0) + startY + scaleRatio * (image.height - originY * 2);
        if (image.currentX < image.minX) image.currentX = image.minX + 1 - (image.minX - image.currentX + 1) ** 0.8;
        if (image.currentX > image.maxX) image.currentX = image.maxX - 1 + (image.currentX - image.maxX + 1) ** 0.8;
        if (image.currentY < image.minY) image.currentY = image.minY + 1 - (image.minY - image.currentY + 1) ** 0.8;
        if (image.currentY > image.maxY) image.currentY = image.maxY - 1 + (image.currentY - image.maxY + 1) ** 0.8;
        // Velocity
        if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
        if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
        if (!velocity.prevTime) velocity.prevTime = Date.now();
        velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
        velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
        if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
        if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
        velocity.prevPositionX = image.touchesCurrent.x;
        velocity.prevPositionY = image.touchesCurrent.y;
        velocity.prevTime = Date.now();
        gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
    }
    function onTouchEnd() {
        const zoom = swiper.zoom;
        evCache.length = 0;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !image.isMoved) {
            image.isTouched = false;
            image.isMoved = false;
            return;
        }
        image.isTouched = false;
        image.isMoved = false;
        let momentumDurationX = 300;
        let momentumDurationY = 300;
        const velocityX = velocity.x ?? 0;
        const velocityY = velocity.y ?? 0;
        const momentumDistanceX = velocityX * momentumDurationX;
        const newPositionX = image.currentX + momentumDistanceX;
        const momentumDistanceY = velocityY * momentumDurationY;
        const newPositionY = image.currentY + momentumDistanceY;
        // Fix duration
        if (velocityX !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocityX);
        if (velocityY !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocityY);
        const momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        image.currentX = newPositionX;
        image.currentY = newPositionY;
        // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
        image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
        gesture.imageWrapEl.style.transitionDuration = `${momentumDuration}ms`;
        gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
    }
    function onTransitionEnd() {
        const zoom = swiper.zoom;
        if (gesture.slideEl && swiper.activeIndex !== swiper.slides.indexOf(gesture.slideEl)) {
            if (gesture.imageEl) gesture.imageEl.style.transform = 'translate3d(0,0,0) scale(1)';
            if (gesture.imageWrapEl) gesture.imageWrapEl.style.transform = 'translate3d(0,0,0)';
            gesture.slideEl.classList.remove(`${getParams().zoomedSlideClass}`);
            zoom.scale = 1;
            currentScale = 1;
            gesture.slideEl = undefined;
            gesture.imageEl = undefined;
            gesture.imageWrapEl = undefined;
            gesture.originX = 0;
            gesture.originY = 0;
        }
    }
    function onMouseMove(e) {
        // Only pan if zoomed in and mouse panning is enabled
        if (currentScale <= 1 || !gesture.imageWrapEl) return;
        if (!eventWithinSlide(e) || !eventWithinZoomContainer(e)) return;
        const currentTransform = window.getComputedStyle(gesture.imageWrapEl).transform;
        const matrix = new window.DOMMatrix(currentTransform);
        if (!isPanningWithMouse) {
            isPanningWithMouse = true;
            mousePanStart.x = e.clientX;
            mousePanStart.y = e.clientY;
            image.startX = matrix.e;
            image.startY = matrix.f;
            image.width = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            image.height = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            gesture.slideWidth = gesture.slideEl.offsetWidth;
            gesture.slideHeight = gesture.slideEl.offsetHeight;
            return;
        }
        const deltaX = (e.clientX - mousePanStart.x) * mousePanSensitivity;
        const deltaY = (e.clientY - mousePanStart.y) * mousePanSensitivity;
        const scaledWidth = image.width * currentScale;
        const scaledHeight = image.height * currentScale;
        const slideWidth = gesture.slideWidth;
        const slideHeight = gesture.slideHeight;
        const minX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
        const maxX = -minX;
        const minY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
        const maxY = -minY;
        const newX = Math.max(Math.min(image.startX + deltaX, maxX), minX);
        const newY = Math.max(Math.min(image.startY + deltaY, maxY), minY);
        gesture.imageWrapEl.style.transitionDuration = '0ms';
        gesture.imageWrapEl.style.transform = `translate3d(${newX}px, ${newY}px, 0)`;
        mousePanStart.x = e.clientX;
        mousePanStart.y = e.clientY;
        image.startX = newX;
        image.startY = newY;
        image.currentX = newX;
        image.currentY = newY;
    }
    function zoomIn(e) {
        const zoom = swiper.zoom;
        const params = getParams();
        if (!gesture.slideEl) {
            if (e && typeof e !== 'number' && 'target' in e && e.target) gesture.slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`) ?? undefined;
            if (!gesture.slideEl) {
                const virtual = swiper.params.virtual;
                if (virtual && virtual.enabled && swiper.virtual) gesture.slideEl = (0, $3e0e2b092da8f124$export$f1e1789686576879)(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0] ?? undefined;
                else gesture.slideEl = swiper.slides[swiper.activeIndex];
            }
            let imageEl = gesture.slideEl?.querySelector(`.${params.containerClass}`) ?? null;
            if (imageEl) imageEl = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0] ?? null;
            gesture.imageEl = imageEl ?? undefined;
            if (imageEl) gesture.imageWrapEl = (0, $3e0e2b092da8f124$export$35e795649ee09318)(imageEl, `.${params.containerClass}`)[0] ?? undefined;
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl || !gesture.slideEl) return;
        gesture.maxRatio = getMaxRatio();
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = 'hidden';
            swiper.wrapperEl.style.touchAction = 'none';
        }
        gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
        let touchX;
        let touchY;
        let offsetX;
        let offsetY;
        let diffX;
        let diffY;
        let translateX;
        let translateY;
        let imageWidth;
        let imageHeight;
        let scaledWidth;
        let scaledHeight;
        let translateMinX;
        let translateMinY;
        let translateMaxX;
        let translateMaxY;
        let slideWidth;
        let slideHeight;
        const eventIsPointer = e && typeof e !== 'number';
        if (typeof image.touchesStart.x === 'undefined' && eventIsPointer) {
            touchX = e.pageX;
            touchY = e.pageY;
        } else {
            touchX = image.touchesStart.x;
            touchY = image.touchesStart.y;
        }
        const prevScale = currentScale;
        const forceZoomRatio = typeof e === 'number' ? e : null;
        if (currentScale === 1 && forceZoomRatio) {
            touchX = undefined;
            touchY = undefined;
            image.touchesStart.x = undefined;
            image.touchesStart.y = undefined;
        }
        const maxRatio = getMaxRatio();
        zoom.scale = forceZoomRatio || maxRatio;
        currentScale = forceZoomRatio || maxRatio;
        if (e && !(currentScale === 1 && forceZoomRatio)) {
            slideWidth = gesture.slideEl.offsetWidth;
            slideHeight = gesture.slideEl.offsetHeight;
            offsetX = (0, $3e0e2b092da8f124$export$dda1d9f60106f0e9)(gesture.slideEl).left + window.scrollX;
            offsetY = (0, $3e0e2b092da8f124$export$dda1d9f60106f0e9)(gesture.slideEl).top + window.scrollY;
            diffX = offsetX + slideWidth / 2 - (touchX ?? 0);
            diffY = offsetY + slideHeight / 2 - (touchY ?? 0);
            imageWidth = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            imageHeight = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            scaledWidth = imageWidth * zoom.scale;
            scaledHeight = imageHeight * zoom.scale;
            translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
            translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
            translateMaxX = -translateMinX;
            translateMaxY = -translateMinY;
            if (prevScale > 0 && forceZoomRatio && typeof image.currentX === 'number' && typeof image.currentY === 'number') {
                translateX = image.currentX * zoom.scale / prevScale;
                translateY = image.currentY * zoom.scale / prevScale;
            } else {
                translateX = diffX * zoom.scale;
                translateY = diffY * zoom.scale;
            }
            if (translateX < translateMinX) translateX = translateMinX;
            if (translateX > translateMaxX) translateX = translateMaxX;
            if (translateY < translateMinY) translateY = translateMinY;
            if (translateY > translateMaxY) translateY = translateMaxY;
        } else {
            translateX = 0;
            translateY = 0;
        }
        if (forceZoomRatio && zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
        }
        image.currentX = translateX;
        image.currentY = translateY;
        gesture.imageWrapEl.style.transitionDuration = '300ms';
        gesture.imageWrapEl.style.transform = `translate3d(${translateX}px, ${translateY}px,0)`;
        gesture.imageEl.style.transitionDuration = '300ms';
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
    }
    function zoomOut() {
        const zoom = swiper.zoom;
        const params = getParams();
        if (!gesture.slideEl) {
            const virtual = swiper.params.virtual;
            if (virtual && virtual.enabled && swiper.virtual) gesture.slideEl = (0, $3e0e2b092da8f124$export$f1e1789686576879)(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0] ?? undefined;
            else gesture.slideEl = swiper.slides[swiper.activeIndex];
            let imageEl = gesture.slideEl?.querySelector(`.${params.containerClass}`) ?? null;
            if (imageEl) imageEl = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0] ?? null;
            gesture.imageEl = imageEl ?? undefined;
            if (imageEl) gesture.imageWrapEl = (0, $3e0e2b092da8f124$export$35e795649ee09318)(imageEl, `.${params.containerClass}`)[0] ?? undefined;
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl || !gesture.slideEl) return;
        gesture.maxRatio = getMaxRatio();
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = '';
            swiper.wrapperEl.style.touchAction = '';
        }
        zoom.scale = 1;
        currentScale = 1;
        image.currentX = undefined;
        image.currentY = undefined;
        image.touchesStart.x = undefined;
        image.touchesStart.y = undefined;
        gesture.imageWrapEl.style.transitionDuration = '300ms';
        gesture.imageWrapEl.style.transform = 'translate3d(0,0,0)';
        gesture.imageEl.style.transitionDuration = '300ms';
        gesture.imageEl.style.transform = 'translate3d(0,0,0) scale(1)';
        gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
        gesture.slideEl = undefined;
        gesture.originX = 0;
        gesture.originY = 0;
        if (params.panOnMouseMove) {
            mousePanStart = {
                x: 0,
                y: 0
            };
            if (isPanningWithMouse) {
                isPanningWithMouse = false;
                image.startX = 0;
                image.startY = 0;
            }
        }
    }
    // Toggle Zoom
    function zoomToggle(e) {
        const zoom = swiper.zoom;
        if (zoom.scale && zoom.scale !== 1) // Zoom Out
        zoomOut();
        else // Zoom In
        zoomIn(e);
    }
    function getListeners() {
        const passiveListener = swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        const activeListenerWithCapture = swiper.params.passiveListeners ? {
            passive: false,
            capture: true
        } : true;
        return {
            passiveListener: passiveListener,
            activeListenerWithCapture: activeListenerWithCapture
        };
    }
    // Attach/Detach Events
    function enable() {
        const zoom = swiper.zoom;
        if (zoom.enabled) return;
        zoom.enabled = true;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        // Scale image
        swiper.wrapperEl.addEventListener('pointerdown', onGestureStart, passiveListener);
        swiper.wrapperEl.addEventListener('pointermove', onGestureChange, activeListenerWithCapture);
        [
            'pointerup',
            'pointercancel',
            'pointerout'
        ].forEach((eventName)=>{
            swiper.wrapperEl.addEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.addEventListener('pointermove', onTouchMove, activeListenerWithCapture);
    }
    function disable() {
        const zoom = swiper.zoom;
        if (!zoom.enabled) return;
        zoom.enabled = false;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        // Scale image
        swiper.wrapperEl.removeEventListener('pointerdown', onGestureStart, passiveListener);
        swiper.wrapperEl.removeEventListener('pointermove', onGestureChange, activeListenerWithCapture);
        [
            'pointerup',
            'pointercancel',
            'pointerout'
        ].forEach((eventName)=>{
            swiper.wrapperEl.removeEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.removeEventListener('pointermove', onTouchMove, activeListenerWithCapture);
    }
    on('init', ()=>{
        if (getParams().enabled) enable();
    });
    on('destroy', ()=>{
        disable();
    });
    on('touchStart', (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchStart(e);
    });
    on('touchEnd', ()=>{
        if (!swiper.zoom.enabled) return;
        onTouchEnd();
    });
    on('doubleTap', (_s, e)=>{
        if (!swiper.animating && getParams().enabled && swiper.zoom.enabled && getParams().toggle) zoomToggle(e);
    });
    on('transitionEnd', ()=>{
        if (swiper.zoom.enabled && getParams().enabled) onTransitionEnd();
    });
    on('slideChange', ()=>{
        if (swiper.zoom.enabled && getParams().enabled && swiper.params.cssMode) onTransitionEnd();
    });
    Object.assign(swiper.zoom, {
        enable: enable,
        disable: disable,
        in: zoomIn,
        out: zoomOut,
        toggle: zoomToggle
    });
};



class $8ad27336c27f2357$var$LinearSpline {
    x;
    y;
    lastIndex;
    binarySearch;
    constructor(x, y){
        let maxIndex;
        let minIndex;
        let guess;
        this.binarySearch = (array, val)=>{
            minIndex = -1;
            maxIndex = array.length;
            while(maxIndex - minIndex > 1){
                guess = maxIndex + minIndex >> 1;
                if (array[guess] <= val) minIndex = guess;
                else maxIndex = guess;
            }
            return maxIndex;
        };
        this.x = x;
        this.y = y;
        this.lastIndex = x.length - 1;
    }
    interpolate(x2) {
        if (!x2) return 0;
        const i3 = this.binarySearch(this.x, x2);
        const i1 = i3 - 1;
        // Given an x value (x2), return the expected y2 value:
        // (x1,y1) is the known point before given value,
        // (x3,y3) is the known point after given value.
        // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
        return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
    }
}
const $8ad27336c27f2357$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on })=>{
    extendParams({
        controller: {
            control: undefined,
            inverse: false,
            by: 'slide'
        }
    });
    swiper.controller = {
        control: undefined
    };
    function getParams() {
        return swiper.params.controller;
    }
    function getInterpolateFunction(c) {
        swiper.controller.spline = swiper.params.loop ? new $8ad27336c27f2357$var$LinearSpline(swiper.slidesGrid, c.slidesGrid) : new $8ad27336c27f2357$var$LinearSpline(swiper.snapGrid, c.snapGrid);
    }
    function setTranslate(_t, byController) {
        const controlled = swiper.controller.control;
        let multiplier;
        let controlledTranslate;
        const SwiperCtor = swiper.constructor;
        function setControlledTranslate(c) {
            if (c.destroyed) return;
            // this will create an Interpolate function based on the snapGrids
            // x is the Grid of the scrolled scroller and y will be the controlled scroller
            // it makes sense to create this only once and recall it for the interpolation
            // the function does a lot of value caching for performance
            const translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
            const controllerParams = getParams();
            if (controllerParams.by === 'slide') {
                getInterpolateFunction(c);
                // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
                // but it did not work out
                controlledTranslate = -swiper.controller.spline.interpolate(-translate);
            } else controlledTranslate = 0;
            if (!controlledTranslate || controllerParams.by === 'container') {
                multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
                if (Number.isNaN(multiplier) || !Number.isFinite(multiplier)) multiplier = 1;
                controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
            }
            if (controllerParams.inverse) controlledTranslate = c.maxTranslate() - controlledTranslate;
            c.updateProgress(controlledTranslate);
            c.setTranslate(controlledTranslate, swiper);
            c.updateActiveIndex();
            c.updateSlidesClasses();
        }
        if (Array.isArray(controlled)) for(let i = 0; i < controlled.length; i += 1){
            const target = controlled[i];
            if (target && target !== byController && target instanceof SwiperCtor) setControlledTranslate(target);
        }
        else if (controlled instanceof SwiperCtor && byController !== controlled) setControlledTranslate(controlled);
    }
    function setTransition(duration, byController) {
        const SwiperCtor = swiper.constructor;
        const controlled = swiper.controller.control;
        function setControlledTransition(c) {
            if (c.destroyed) return;
            c.setTransition(duration, swiper);
            if (duration !== 0) {
                c.transitionStart();
                if (c.params.autoHeight) (0, $3e0e2b092da8f124$export$625550452a3fa3ec)(()=>{
                    c.updateAutoHeight();
                });
                (0, $3e0e2b092da8f124$export$953cecd6e717a553)(c.wrapperEl, ()=>{
                    if (!controlled) return;
                    c.transitionEnd();
                });
            }
        }
        if (Array.isArray(controlled)) for(let i = 0; i < controlled.length; i += 1){
            const target = controlled[i];
            if (target && target !== byController && target instanceof SwiperCtor) setControlledTransition(target);
        }
        else if (controlled instanceof SwiperCtor && byController !== controlled) setControlledTransition(controlled);
    }
    function removeSpline() {
        if (!swiper.controller.control) return;
        if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
        }
    }
    on('beforeInit', ()=>{
        const controllerParam = getParams().control;
        if (typeof window !== 'undefined' && (typeof controllerParam === 'string' || controllerParam instanceof HTMLElement)) {
            const controlElements = typeof controllerParam === 'string' ? [
                ...document.querySelectorAll(controllerParam)
            ] : [
                controllerParam
            ];
            controlElements.forEach((controlElement)=>{
                if (!swiper.controller.control) swiper.controller.control = [];
                const list = swiper.controller.control;
                if (controlElement && controlElement.swiper) list.push(controlElement.swiper);
                else if (controlElement) {
                    const eventName = `${swiper.params.eventsPrefix}init`;
                    const onControllerSwiper = (e)=>{
                        const detail = e.detail;
                        if (detail && detail[0]) list.push(detail[0]);
                        swiper.update();
                        controlElement.removeEventListener(eventName, onControllerSwiper);
                    };
                    controlElement.addEventListener(eventName, onControllerSwiper);
                }
            });
            return;
        }
        // After this point control is either Swiper or Swiper[] (or null/undefined),
        // never the string/HTMLElement forms that the public option accepts.
        swiper.controller.control = controllerParam;
    });
    on('update', ()=>{
        removeSpline();
    });
    on('resize', ()=>{
        removeSpline();
    });
    on('observerUpdate', ()=>{
        removeSpline();
    });
    // Event payloads come typed against the legacy public Swiper class
    // (src/types/swiper-class.d.ts) until Phase 5 deletes src/types/; cast the
    // forwarded byController back to the core Swiper so it lines up with the
    // controller-internal signatures.
    on('setTranslate', (_s, translate, byController)=>{
        if (!swiper.controller.control) return;
        if (!Array.isArray(swiper.controller.control) && swiper.controller.control.destroyed) return;
        swiper.controller.setTranslate(translate, byController);
    });
    on('setTransition', (_s, duration, byController)=>{
        if (!swiper.controller.control) return;
        if (!Array.isArray(swiper.controller.control) && swiper.controller.control.destroyed) return;
        swiper.controller.setTransition(duration, byController);
    });
    Object.assign(swiper.controller, {
        setTranslate: setTranslate,
        setTransition: setTransition
    });
};




const $f036f37c54b3aa6f$var$isVirtualEnabled = (swiper)=>!!swiper.virtual && !!swiper.params.virtual?.enabled;
const $f036f37c54b3aa6f$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on })=>{
    extendParams({
        a11y: {
            enabled: true,
            notificationClass: 'swiper-notification',
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
            firstSlideMessage: 'This is the first slide',
            lastSlideMessage: 'This is the last slide',
            paginationBulletMessage: 'Go to slide {{index}}',
            slideLabelMessage: '{{index}} / {{slidesLength}}',
            containerMessage: null,
            containerRoleDescriptionMessage: null,
            containerRole: null,
            itemRoleDescriptionMessage: null,
            slideRole: 'group',
            id: null,
            scrollOnFocus: true,
            wrapperLiveRegion: true
        }
    });
    swiper.a11y = {
        clicked: false
    };
    let liveRegion = null;
    let preventFocusHandler = false;
    let focusTargetSlideEl;
    let visibilityChangedTimestamp = new Date().getTime();
    function getParams() {
        return swiper.params.a11y;
    }
    function notify(message) {
        const notification = liveRegion;
        if (!notification || !message) return;
        (0, $3e0e2b092da8f124$export$efccba1c4a2ef57b)(notification, message);
    }
    function getRandomNumber(size = 16) {
        const randomChar = ()=>Math.round(16 * Math.random()).toString(16);
        return 'x'.repeat(size).replace(/x/g, randomChar);
    }
    function makeElFocusable(el) {
        const els = (0, $3e0e2b092da8f124$export$2408f22a0fab9ae5)(el);
        els.forEach((subEl)=>{
            subEl.setAttribute('tabIndex', '0');
        });
    }
    function makeElNotFocusable(el) {
        const els = (0, $3e0e2b092da8f124$export$2408f22a0fab9ae5)(el);
        els.forEach((subEl)=>{
            subEl.setAttribute('tabIndex', '-1');
        });
    }
    function addElRole(el, role) {
        const els = (0, $3e0e2b092da8f124$export$2408f22a0fab9ae5)(el);
        els.forEach((subEl)=>{
            subEl.setAttribute('role', role);
        });
    }
    function addElRoleDescription(el, description) {
        const els = (0, $3e0e2b092da8f124$export$2408f22a0fab9ae5)(el);
        els.forEach((subEl)=>{
            subEl.setAttribute('aria-roledescription', description);
        });
    }
    function addElLabel(el, label) {
        const els = (0, $3e0e2b092da8f124$export$2408f22a0fab9ae5)(el);
        els.forEach((subEl)=>{
            subEl.setAttribute('aria-label', label);
        });
    }
    function addElId(el, id) {
        const els = (0, $3e0e2b092da8f124$export$2408f22a0fab9ae5)(el);
        els.forEach((subEl)=>{
            subEl.setAttribute('id', id);
        });
    }
    function addElLive(el, live) {
        const els = (0, $3e0e2b092da8f124$export$2408f22a0fab9ae5)(el);
        els.forEach((subEl)=>{
            subEl.setAttribute('aria-live', live);
        });
    }
    function disableEl(el) {
        const els = (0, $3e0e2b092da8f124$export$2408f22a0fab9ae5)(el);
        els.forEach((subEl)=>{
            subEl.setAttribute('aria-disabled', 'true');
        });
    }
    function enableEl(el) {
        const els = (0, $3e0e2b092da8f124$export$2408f22a0fab9ae5)(el);
        els.forEach((subEl)=>{
            subEl.removeAttribute('aria-disabled');
        });
    }
    function onEnterOrSpaceKey(e) {
        if (e.keyCode !== 13 && e.keyCode !== 32) return;
        const params = getParams();
        const paginationParams = swiper.params.pagination;
        const targetEl = e.target;
        if (swiper.pagination && swiper.pagination.el && (targetEl === swiper.pagination.el || swiper.pagination.el.contains(targetEl))) {
            if (!targetEl.matches((0, $452edee79264d178$export$db3b6bfb95261072)(paginationParams?.bulletClass))) return;
        }
        if (swiper.navigation && swiper.navigation.prevEl && swiper.navigation.nextEl) {
            const prevEls = (0, $3e0e2b092da8f124$export$2408f22a0fab9ae5)(swiper.navigation.prevEl);
            const nextEls = (0, $3e0e2b092da8f124$export$2408f22a0fab9ae5)(swiper.navigation.nextEl);
            if (nextEls.includes(targetEl)) {
                if (!(swiper.isEnd && !swiper.params.loop)) swiper.slideNext();
                if (swiper.isEnd) notify(params.lastSlideMessage);
                else notify(params.nextSlideMessage);
            }
            if (prevEls.includes(targetEl)) {
                if (!(swiper.isBeginning && !swiper.params.loop)) swiper.slidePrev();
                if (swiper.isBeginning) notify(params.firstSlideMessage);
                else notify(params.prevSlideMessage);
            }
        }
        if (swiper.pagination && targetEl.matches((0, $452edee79264d178$export$db3b6bfb95261072)(paginationParams?.bulletClass))) targetEl.click();
    }
    function updateNavigation() {
        if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
        const { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        if (prevEl) {
            if (swiper.isBeginning) {
                disableEl(prevEl);
                makeElNotFocusable(prevEl);
            } else {
                enableEl(prevEl);
                makeElFocusable(prevEl);
            }
        }
        if (nextEl) {
            if (swiper.isEnd) {
                disableEl(nextEl);
                makeElNotFocusable(nextEl);
            } else {
                enableEl(nextEl);
                makeElFocusable(nextEl);
            }
        }
    }
    function hasPagination() {
        return !!(swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length);
    }
    function hasClickablePagination() {
        const paginationParams = swiper.params.pagination;
        return hasPagination() && !!paginationParams?.clickable;
    }
    function updatePagination() {
        const params = getParams();
        if (!hasPagination()) return;
        const paginationParams = swiper.params.pagination;
        swiper.pagination.bullets.forEach((bulletEl)=>{
            if (paginationParams.clickable) {
                makeElFocusable(bulletEl);
                if (!paginationParams.renderBullet) {
                    addElRole(bulletEl, 'button');
                    addElLabel(bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, String(((0, $3e0e2b092da8f124$export$8b22cf2602fb60ce)(bulletEl) ?? 0) + 1)));
                }
            }
            if (bulletEl.matches((0, $452edee79264d178$export$db3b6bfb95261072)(paginationParams.bulletActiveClass))) bulletEl.setAttribute('aria-current', 'true');
            else bulletEl.removeAttribute('aria-current');
        });
    }
    const initNavEl = (el, _wrapperId, message)=>{
        makeElFocusable(el);
        if (el.tagName !== 'BUTTON') {
            addElRole(el, 'button');
            el.addEventListener('keydown', onEnterOrSpaceKey);
        }
        addElLabel(el, message);
    };
    const handlePointerDown = (e)=>{
        if (focusTargetSlideEl && focusTargetSlideEl !== e.target && !focusTargetSlideEl.contains(e.target)) preventFocusHandler = true;
        swiper.a11y.clicked = true;
    };
    const handlePointerUp = ()=>{
        preventFocusHandler = false;
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!swiper.destroyed) swiper.a11y.clicked = false;
            });
        });
    };
    const onVisibilityChange = (_e)=>{
        visibilityChangedTimestamp = new Date().getTime();
    };
    const handleFocus = (e)=>{
        const params = getParams();
        if (swiper.a11y.clicked || !params.scrollOnFocus) return;
        if (new Date().getTime() - visibilityChangedTimestamp < 100) return;
        const target = e.target;
        const slideEl = target.closest(`.${swiper.params.slideClass}, swiper-slide`);
        if (!slideEl || !swiper.slides.includes(slideEl)) return;
        focusTargetSlideEl = slideEl;
        const isVirtual = $f036f37c54b3aa6f$var$isVirtualEnabled(swiper);
        const isActive = (isVirtual ? parseInt(slideEl.getAttribute('data-swiper-slide-index') || '0', 10) : swiper.slides.indexOf(slideEl)) === swiper.activeIndex;
        const isVisible = swiper.params.watchSlidesProgress && swiper.visibleSlides && swiper.visibleSlides.includes(slideEl);
        if (isActive || isVisible) return;
        const sourceCapabilities = e.sourceCapabilities;
        if (sourceCapabilities && sourceCapabilities.firesTouchEvents) return;
        if (swiper.isHorizontal()) swiper.el.scrollLeft = 0;
        else swiper.el.scrollTop = 0;
        requestAnimationFrame(()=>{
            if (preventFocusHandler) return;
            if (swiper.params.loop) swiper.slideToLoop(swiper.getSlideIndexWhenGrid(parseInt(slideEl.getAttribute('data-swiper-slide-index') || '0', 10)), 0);
            else if (isVirtual) swiper.slideTo(swiper.getSlideIndexWhenGrid(parseInt(slideEl.getAttribute('data-swiper-slide-index') || '0', 10)), 0);
            else swiper.slideTo(swiper.getSlideIndexWhenGrid(swiper.slides.indexOf(slideEl)), 0);
            preventFocusHandler = false;
        });
    };
    const initSlides = ()=>{
        const params = getParams();
        if (params.itemRoleDescriptionMessage) addElRoleDescription(swiper.slides, params.itemRoleDescriptionMessage);
        if (params.slideRole) addElRole(swiper.slides, params.slideRole);
        const slidesLength = swiper.slides.length;
        const slideLabelMessage = params.slideLabelMessage;
        if (slideLabelMessage) swiper.slides.forEach((slideEl, index)=>{
            const slideIndex = swiper.params.loop ? parseInt(slideEl.getAttribute('data-swiper-slide-index') || '0', 10) : index;
            const ariaLabelMessage = slideLabelMessage.replace(/\{\{index\}\}/, String(slideIndex + 1)).replace(/\{\{slidesLength\}\}/, String(slidesLength));
            addElLabel(slideEl, ariaLabelMessage);
        });
    };
    const init = ()=>{
        const params = getParams();
        if (liveRegion) swiper.el.append(liveRegion);
        // Container
        const containerEl = swiper.el;
        if (params.containerRoleDescriptionMessage) addElRoleDescription(containerEl, params.containerRoleDescriptionMessage);
        if (params.containerMessage) addElLabel(containerEl, params.containerMessage);
        if (params.containerRole) addElRole(containerEl, params.containerRole);
        // Wrapper
        const wrapperEl = swiper.wrapperEl;
        const wrapperId = String(params.id || wrapperEl.getAttribute('id') || `swiper-wrapper-${getRandomNumber(16)}`);
        addElId(wrapperEl, wrapperId);
        if (params.wrapperLiveRegion) {
            const autoplayParams = swiper.params.autoplay;
            const live = swiper.params.autoplay && autoplayParams?.enabled ? 'off' : 'polite';
            addElLive(wrapperEl, live);
        }
        // Slide
        initSlides();
        // Navigation
        const nav = swiper.navigation ? swiper.navigation : {
            nextEl: undefined,
            prevEl: undefined
        };
        const nextEls = (0, $3e0e2b092da8f124$export$2408f22a0fab9ae5)(nav.nextEl);
        const prevEls = (0, $3e0e2b092da8f124$export$2408f22a0fab9ae5)(nav.prevEl);
        if (nextEls) nextEls.forEach((el)=>initNavEl(el, wrapperId, params.nextSlideMessage));
        if (prevEls) prevEls.forEach((el)=>initNavEl(el, wrapperId, params.prevSlideMessage));
        // Pagination
        if (hasClickablePagination()) {
            const paginationEl = (0, $3e0e2b092da8f124$export$2408f22a0fab9ae5)(swiper.pagination.el);
            paginationEl.forEach((el)=>{
                el.addEventListener('keydown', onEnterOrSpaceKey);
            });
        }
        // Tab focus
        document.addEventListener('visibilitychange', onVisibilityChange);
        swiper.el.addEventListener('focus', handleFocus, true);
        swiper.el.addEventListener('pointerdown', handlePointerDown, true);
        swiper.el.addEventListener('pointerup', handlePointerUp, true);
    };
    function destroy() {
        if (liveRegion) liveRegion.remove();
        const nav = swiper.navigation ? swiper.navigation : {
            nextEl: undefined,
            prevEl: undefined
        };
        const nextEls = (0, $3e0e2b092da8f124$export$2408f22a0fab9ae5)(nav.nextEl);
        const prevEls = (0, $3e0e2b092da8f124$export$2408f22a0fab9ae5)(nav.prevEl);
        if (nextEls) nextEls.forEach((el)=>el.removeEventListener('keydown', onEnterOrSpaceKey));
        if (prevEls) prevEls.forEach((el)=>el.removeEventListener('keydown', onEnterOrSpaceKey));
        // Pagination
        if (hasClickablePagination()) {
            const paginationEl = (0, $3e0e2b092da8f124$export$2408f22a0fab9ae5)(swiper.pagination.el);
            paginationEl.forEach((el)=>{
                el.removeEventListener('keydown', onEnterOrSpaceKey);
            });
        }
        document.removeEventListener('visibilitychange', onVisibilityChange);
        // Tab focus
        if (swiper.el && typeof swiper.el !== 'string') {
            swiper.el.removeEventListener('focus', handleFocus, true);
            swiper.el.removeEventListener('pointerdown', handlePointerDown, true);
            swiper.el.removeEventListener('pointerup', handlePointerUp, true);
        }
    }
    on('beforeInit', ()=>{
        liveRegion = (0, $3e0e2b092da8f124$export$407448d2b89b1813)('span', getParams().notificationClass);
        liveRegion.setAttribute('aria-live', 'assertive');
        liveRegion.setAttribute('aria-atomic', 'true');
    });
    on('afterInit', ()=>{
        if (!getParams().enabled) return;
        init();
    });
    on('slidesLengthChange snapGridLengthChange slidesGridLengthChange', ()=>{
        if (!getParams().enabled) return;
        initSlides();
    });
    on('fromEdge toEdge afterInit lock unlock', ()=>{
        if (!getParams().enabled) return;
        updateNavigation();
    });
    on('paginationUpdate', ()=>{
        if (!getParams().enabled) return;
        updatePagination();
    });
    on('destroy', ()=>{
        if (!getParams().enabled) return;
        destroy();
    });
};


const $0ce99a47f98448f9$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on })=>{
    extendParams({
        history: {
            enabled: false,
            root: '',
            replaceState: false,
            key: 'slides',
            keepQuery: false
        }
    });
    let initialized = false;
    let paths = {
        key: undefined,
        value: undefined
    };
    function getParams() {
        return swiper.params.history;
    }
    const slugify = (text)=>{
        return text.toString().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
    };
    const getPathValues = (urlOverride)=>{
        let location;
        if (urlOverride) location = new URL(urlOverride);
        else location = window.location;
        const pathArray = location.pathname.slice(1).split('/').filter((part)=>part !== '');
        const total = pathArray.length;
        const key = pathArray[total - 2];
        const value = pathArray[total - 1];
        return {
            key: key,
            value: value
        };
    };
    const setHistory = (key, index)=>{
        const params = getParams();
        if (!initialized || !params.enabled) return;
        let location;
        if (swiper.params.url) location = new URL(swiper.params.url);
        else location = window.location;
        const isVirtualEnabled = !!swiper.params.virtual?.enabled;
        const slide = swiper.virtual && isVirtualEnabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${index}"]`) : swiper.slides[index];
        if (!slide) return;
        let value = slugify(slide.getAttribute('data-history') || '');
        const root = params.root;
        if (root.length > 0) {
            const trimmedRoot = root[root.length - 1] === '/' ? root.slice(0, root.length - 1) : root;
            value = `${trimmedRoot}/${key ? `${key}/` : ''}${value}`;
        } else if (!location.pathname.includes(key || '')) value = `${key ? `${key}/` : ''}${value}`;
        if (params.keepQuery) value += location.search;
        const currentState = window.history.state;
        if (currentState && currentState.value === value) return;
        if (params.replaceState) window.history.replaceState({
            value: value
        }, '', value);
        else window.history.pushState({
            value: value
        }, '', value);
    };
    const scrollToSlide = (speed, value, runCallbacks)=>{
        if (value) for(let i = 0, length = swiper.slides.length; i < length; i += 1){
            const slide = swiper.slides[i];
            const slideHistory = slugify(slide.getAttribute('data-history') || '');
            if (slideHistory === value) {
                const index = swiper.getSlideIndex(slide);
                swiper.slideTo(index, speed, runCallbacks);
            }
        }
        else swiper.slideTo(0, speed, runCallbacks);
    };
    const setHistoryPopState = ()=>{
        paths = getPathValues(swiper.params.url);
        scrollToSlide(swiper.params.speed, paths.value, false);
    };
    const init = ()=>{
        const params = swiper.params.history;
        if (!params) return;
        if (!window.history || !window.history.pushState) {
            params.enabled = false;
            const hashParams = swiper.params.hashNavigation;
            if (hashParams) hashParams.enabled = true;
            return;
        }
        initialized = true;
        paths = getPathValues(swiper.params.url);
        if (!paths.key && !paths.value) {
            if (!params.replaceState) window.addEventListener('popstate', setHistoryPopState);
            return;
        }
        scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);
        if (!params.replaceState) window.addEventListener('popstate', setHistoryPopState);
    };
    const destroy = ()=>{
        if (!getParams().replaceState) window.removeEventListener('popstate', setHistoryPopState);
    };
    on('init', ()=>{
        if (getParams().enabled) init();
    });
    on('destroy', ()=>{
        if (getParams().enabled) destroy();
    });
    on('transitionEnd _freeModeNoMomentumRelease', ()=>{
        if (initialized) setHistory(getParams().key, swiper.activeIndex);
    });
    on('slideChange', ()=>{
        if (initialized && swiper.params.cssMode) setHistory(getParams().key, swiper.activeIndex);
    });
};



const $749dc992af967f35$var$isVirtualEnabled = (swiper)=>!!swiper.virtual && !!swiper.params.virtual?.enabled;
const $749dc992af967f35$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, emit: emit, on: on })=>{
    let initialized = false;
    extendParams({
        hashNavigation: {
            enabled: false,
            replaceState: false,
            watchState: false,
            getSlideIndex (_s, hash) {
                if ($749dc992af967f35$var$isVirtualEnabled(swiper)) {
                    const slideWithHash = swiper.slides.find((slideEl)=>slideEl.getAttribute('data-hash') === hash);
                    if (!slideWithHash) return 0;
                    const index = parseInt(slideWithHash.getAttribute('data-swiper-slide-index') || '0', 10);
                    return index;
                }
                const matched = (0, $3e0e2b092da8f124$export$f1e1789686576879)(swiper.slidesEl, `.${swiper.params.slideClass}[data-hash="${hash}"], swiper-slide[data-hash="${hash}"]`)[0];
                return matched ? swiper.getSlideIndex(matched) : 0;
            }
        }
    });
    function getParams() {
        return swiper.params.hashNavigation;
    }
    const onHashChange = ()=>{
        emit('hashChange');
        const newHash = document.location.hash.replace('#', '');
        const activeSlideEl = $749dc992af967f35$var$isVirtualEnabled(swiper) ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`) : swiper.slides[swiper.activeIndex];
        const activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute('data-hash') : '';
        if (newHash !== activeSlideHash) {
            const newIndex = getParams().getSlideIndex(swiper, newHash);
            if (typeof newIndex === 'undefined' || Number.isNaN(newIndex)) return;
            swiper.slideTo(newIndex);
        }
    };
    const setHash = ()=>{
        const params = getParams();
        if (!initialized || !params.enabled) return;
        const activeSlideEl = $749dc992af967f35$var$isVirtualEnabled(swiper) ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`) : swiper.slides[swiper.activeIndex];
        const activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute('data-hash') || activeSlideEl.getAttribute('data-history') : '';
        if (params.replaceState && window.history && window.history.replaceState) {
            window.history.replaceState(null, '', `#${activeSlideHash}` || '');
            emit('hashSet');
        } else {
            document.location.hash = activeSlideHash || '';
            emit('hashSet');
        }
    };
    const init = ()=>{
        const params = getParams();
        const historyParams = swiper.params.history;
        if (!params.enabled || historyParams && historyParams.enabled) return;
        initialized = true;
        const hash = document.location.hash.replace('#', '');
        if (hash) {
            const speed = 0;
            const index = params.getSlideIndex(swiper, hash);
            swiper.slideTo(index || 0, speed, swiper.params.runCallbacksOnInit, true);
        }
        if (params.watchState) window.addEventListener('hashchange', onHashChange);
    };
    const destroy = ()=>{
        if (getParams().watchState) window.removeEventListener('hashchange', onHashChange);
    };
    on('init', ()=>{
        if (getParams().enabled) init();
    });
    on('destroy', ()=>{
        if (getParams().enabled) destroy();
    });
    on('transitionEnd _freeModeNoMomentumRelease', ()=>{
        if (initialized) setHash();
    });
    on('slideChange', ()=>{
        if (initialized && swiper.params.cssMode) setHash();
    });
};


const $41ae6f5a5ccdab5c$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on, emit: emit, params: params })=>{
    swiper.autoplay = {
        running: false,
        paused: false,
        timeLeft: 0
    };
    extendParams({
        autoplay: {
            enabled: false,
            delay: 3000,
            waitForTransition: true,
            disableOnInteraction: false,
            stopOnLastSlide: false,
            reverseDirection: false,
            pauseOnMouseEnter: false
        }
    });
    function getParams() {
        return swiper.params.autoplay;
    }
    // params here is the user-supplied passedParams; extendParams hasn't yet
    // merged the defaults into swiper.params.autoplay at this point.
    const initialAutoplayDelay = typeof params.autoplay === 'object' && params.autoplay && typeof params.autoplay.delay === 'number' ? params.autoplay.delay : 3000;
    let timeout;
    let raf;
    let autoplayDelayTotal = initialAutoplayDelay;
    let autoplayDelayCurrent = initialAutoplayDelay;
    let autoplayTimeLeft = 0;
    let autoplayStartTime = new Date().getTime();
    let wasPaused = false;
    let isTouched = false;
    let pausedByTouch = false;
    let touchStartTimeout;
    let pausedByInteraction = false;
    let pausedByPointerEnter = false;
    function onTransitionEnd(e) {
        if (!swiper || swiper.destroyed || !swiper.wrapperEl) return;
        if (e.target !== swiper.wrapperEl) return;
        swiper.wrapperEl.removeEventListener('transitionend', onTransitionEnd);
        const detail = e.detail;
        if (pausedByPointerEnter || detail && detail.bySwiperTouchMove) return;
        resume();
    }
    const calcTimeLeft = ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.autoplay.paused) wasPaused = true;
        else if (wasPaused) {
            autoplayDelayCurrent = autoplayTimeLeft;
            wasPaused = false;
        }
        const timeLeft = swiper.autoplay.paused ? autoplayTimeLeft : autoplayStartTime + autoplayDelayCurrent - new Date().getTime();
        swiper.autoplay.timeLeft = timeLeft;
        emit('autoplayTimeLeft', timeLeft, timeLeft / autoplayDelayTotal);
        raf = requestAnimationFrame(()=>{
            calcTimeLeft();
        });
    };
    const getSlideDelay = ()=>{
        let activeSlideEl;
        const virtualEnabled = !!swiper.params.virtual?.enabled;
        if (swiper.virtual && virtualEnabled) activeSlideEl = swiper.slides.find((slideEl)=>slideEl.classList.contains('swiper-slide-active'));
        else activeSlideEl = swiper.slides[swiper.activeIndex];
        if (!activeSlideEl) return undefined;
        const attr = activeSlideEl.getAttribute('data-swiper-autoplay');
        if (attr == null) return undefined;
        return parseInt(attr, 10);
    };
    const getTotalDelay = ()=>{
        let totalDelay = getParams().delay;
        const currentSlideDelay = getSlideDelay();
        if (typeof currentSlideDelay === 'number' && !Number.isNaN(currentSlideDelay) && currentSlideDelay > 0) totalDelay = currentSlideDelay;
        return totalDelay;
    };
    const run = (delayForce)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return 0;
        if (raf !== undefined) cancelAnimationFrame(raf);
        calcTimeLeft();
        let delay = delayForce;
        if (typeof delay === 'undefined') {
            delay = getTotalDelay();
            autoplayDelayTotal = delay;
            autoplayDelayCurrent = delay;
        }
        autoplayTimeLeft = delay;
        const speed = swiper.params.speed;
        const proceed = ()=>{
            if (!swiper || swiper.destroyed) return;
            const autoplayParams = getParams();
            if (autoplayParams.reverseDirection) {
                if (!swiper.isBeginning || swiper.params.loop || swiper.params.rewind) {
                    swiper.slidePrev(speed, true, true);
                    emit('autoplay');
                } else if (!autoplayParams.stopOnLastSlide) {
                    swiper.slideTo(swiper.slides.length - 1, speed, true, true);
                    emit('autoplay');
                }
            } else {
                if (!swiper.isEnd || swiper.params.loop || swiper.params.rewind) {
                    swiper.slideNext(speed, true, true);
                    emit('autoplay');
                } else if (!autoplayParams.stopOnLastSlide) {
                    swiper.slideTo(0, speed, true, true);
                    emit('autoplay');
                }
            }
            if (swiper.params.cssMode) {
                autoplayStartTime = new Date().getTime();
                requestAnimationFrame(()=>{
                    run();
                });
            }
        };
        if (delay > 0) {
            if (timeout !== undefined) clearTimeout(timeout);
            timeout = setTimeout(()=>{
                proceed();
            }, delay);
        } else requestAnimationFrame(()=>{
            proceed();
        });
        return delay;
    };
    const start = ()=>{
        autoplayStartTime = new Date().getTime();
        swiper.autoplay.running = true;
        run();
        emit('autoplayStart');
        return true;
    };
    const stop = ()=>{
        swiper.autoplay.running = false;
        if (timeout !== undefined) clearTimeout(timeout);
        if (raf !== undefined) cancelAnimationFrame(raf);
        emit('autoplayStop');
        return true;
    };
    const pause = (internal, reset)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (timeout !== undefined) clearTimeout(timeout);
        if (!internal) pausedByInteraction = true;
        const proceed = ()=>{
            emit('autoplayPause');
            if (getParams().waitForTransition) swiper.wrapperEl.addEventListener('transitionend', onTransitionEnd);
            else resume();
        };
        swiper.autoplay.paused = true;
        if (reset) {
            proceed();
            return;
        }
        const delay = autoplayTimeLeft || getParams().delay;
        autoplayTimeLeft = delay - (new Date().getTime() - autoplayStartTime);
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop) return;
        if (autoplayTimeLeft < 0) autoplayTimeLeft = 0;
        proceed();
    };
    const resume = ()=>{
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop || swiper.destroyed || !swiper.autoplay.running) return;
        autoplayStartTime = new Date().getTime();
        if (pausedByInteraction) {
            pausedByInteraction = false;
            run(autoplayTimeLeft);
        } else run();
        swiper.autoplay.paused = false;
        emit('autoplayResume');
    };
    const onVisibilityChange = ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (document.visibilityState === 'hidden') {
            pausedByInteraction = true;
            pause(true);
        }
        if (document.visibilityState === 'visible') resume();
    };
    const onPointerEnter = (e)=>{
        if (e.pointerType !== 'mouse') return;
        pausedByInteraction = true;
        pausedByPointerEnter = true;
        if (swiper.animating || swiper.autoplay.paused) return;
        pause(true);
    };
    const onPointerLeave = (e)=>{
        if (e.pointerType !== 'mouse') return;
        pausedByPointerEnter = false;
        if (swiper.autoplay.paused) resume();
    };
    const attachMouseEvents = ()=>{
        if (getParams().pauseOnMouseEnter) {
            swiper.el.addEventListener('pointerenter', onPointerEnter);
            swiper.el.addEventListener('pointerleave', onPointerLeave);
        }
    };
    const detachMouseEvents = ()=>{
        if (swiper.el && typeof swiper.el !== 'string') {
            swiper.el.removeEventListener('pointerenter', onPointerEnter);
            swiper.el.removeEventListener('pointerleave', onPointerLeave);
        }
    };
    const attachDocumentEvents = ()=>{
        document.addEventListener('visibilitychange', onVisibilityChange);
    };
    const detachDocumentEvents = ()=>{
        document.removeEventListener('visibilitychange', onVisibilityChange);
    };
    on('init', ()=>{
        if (getParams().enabled) {
            attachMouseEvents();
            attachDocumentEvents();
            start();
        }
    });
    on('destroy', ()=>{
        detachMouseEvents();
        detachDocumentEvents();
        if (swiper.autoplay.running) stop();
    });
    on('_freeModeStaticRelease', ()=>{
        if (pausedByTouch || pausedByInteraction) resume();
    });
    on('_freeModeNoMomentumRelease', ()=>{
        if (!getParams().disableOnInteraction) pause(true, true);
        else stop();
    });
    on('beforeTransitionStart', (_s, _speed, internal)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (internal || !getParams().disableOnInteraction) pause(true, true);
        else stop();
    });
    on('sliderFirstMove', ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (getParams().disableOnInteraction) {
            stop();
            return;
        }
        isTouched = true;
        pausedByTouch = false;
        pausedByInteraction = false;
        touchStartTimeout = setTimeout(()=>{
            pausedByInteraction = true;
            pausedByTouch = true;
            pause(true);
        }, 200);
    });
    on('touchEnd', ()=>{
        if (swiper.destroyed || !swiper.autoplay.running || !isTouched) return;
        if (touchStartTimeout !== undefined) clearTimeout(touchStartTimeout);
        if (timeout !== undefined) clearTimeout(timeout);
        if (getParams().disableOnInteraction) {
            pausedByTouch = false;
            isTouched = false;
            return;
        }
        if (pausedByTouch && swiper.params.cssMode) resume();
        pausedByTouch = false;
        isTouched = false;
    });
    on('slideChange', ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.autoplay.paused) {
            autoplayTimeLeft = getTotalDelay();
            autoplayDelayTotal = getTotalDelay();
        }
    });
    Object.assign(swiper.autoplay, {
        start: start,
        stop: stop,
        pause: pause,
        resume: resume
    });
};



const $1664cd01e0f13904$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on })=>{
    extendParams({
        thumbs: {
            swiper: null,
            multipleActiveThumbs: true,
            autoScrollOffset: 0,
            slideThumbActiveClass: 'swiper-slide-thumb-active',
            thumbsContainerClass: 'swiper-thumbs'
        }
    });
    let initialized = false;
    let swiperCreated = false;
    swiper.thumbs = {
        swiper: null
    };
    function getParams() {
        return swiper.params.thumbs;
    }
    function isVirtualEnabled() {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return false;
        const virtual = thumbsSwiper.params.virtual;
        return !!virtual && !!virtual.enabled;
    }
    function onThumbClick() {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const clickedIndex = thumbsSwiper.clickedIndex;
        const clickedSlide = thumbsSwiper.clickedSlide;
        const thumbsParams = getParams();
        if (clickedSlide && clickedSlide.classList.contains(thumbsParams.slideThumbActiveClass)) return;
        if (typeof clickedIndex === 'undefined' || clickedIndex === null) return;
        let slideToIndex;
        if (thumbsSwiper.params.loop) {
            const attr = thumbsSwiper.clickedSlide?.getAttribute('data-swiper-slide-index');
            slideToIndex = attr == null ? clickedIndex : parseInt(attr, 10);
        } else slideToIndex = clickedIndex;
        if (swiper.params.loop) swiper.slideToLoop(slideToIndex);
        else swiper.slideTo(slideToIndex);
    }
    function init() {
        const thumbsParams = getParams();
        if (initialized) return false;
        initialized = true;
        const SwiperClass = swiper.constructor;
        if (thumbsParams.swiper instanceof SwiperClass) {
            if (thumbsParams.swiper.destroyed) {
                initialized = false;
                return false;
            }
            const thumbsSwiper = thumbsParams.swiper;
            swiper.thumbs.swiper = thumbsSwiper;
            Object.assign(thumbsSwiper.originalParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            Object.assign(thumbsSwiper.params, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            thumbsSwiper.update();
        } else if ((0, $3e0e2b092da8f124$export$43caf9889c228507)(thumbsParams.swiper)) {
            const thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
            Object.assign(thumbsSwiperParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
            swiperCreated = true;
        }
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper) return false;
        thumbsSwiper.el.classList.add(thumbsParams.thumbsContainerClass);
        thumbsSwiper.on('tap', onThumbClick);
        if (isVirtualEnabled()) thumbsSwiper.on('virtualUpdate', ()=>{
            update(false, {
                autoScroll: false
            });
        });
        return true;
    }
    function update(initial, p) {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        // Activate thumbs
        let thumbsToActivate = 1;
        const thumbsParams = getParams();
        const thumbActiveClass = thumbsParams.slideThumbActiveClass;
        const slidesPerView = swiper.params.slidesPerView;
        if (typeof slidesPerView === 'number' && slidesPerView > 1 && !swiper.params.centeredSlides) thumbsToActivate = slidesPerView;
        if (!thumbsParams.multipleActiveThumbs) thumbsToActivate = 1;
        thumbsToActivate = Math.floor(thumbsToActivate);
        thumbsSwiper.slides.forEach((slideEl)=>slideEl.classList.remove(thumbActiveClass));
        if (thumbsSwiper.params.loop || isVirtualEnabled()) for(let i = 0; i < thumbsToActivate; i += 1)(0, $3e0e2b092da8f124$export$f1e1789686576879)(thumbsSwiper.slidesEl, `[data-swiper-slide-index="${swiper.realIndex + i}"]`).forEach((slideEl)=>{
            slideEl.classList.add(thumbActiveClass);
        });
        else for(let i = 0; i < thumbsToActivate; i += 1){
            const slide = thumbsSwiper.slides[swiper.realIndex + i];
            if (slide) slide.classList.add(thumbActiveClass);
        }
        if (p?.autoScroll ?? true) autoScroll(initial ? 0 : undefined);
    }
    function autoScroll(slideSpeed) {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const thumbsSlidesPerView = thumbsSwiper.params.slidesPerView;
        const slidesPerView = thumbsSlidesPerView === 'auto' ? thumbsSwiper.slidesPerViewDynamic() : thumbsSlidesPerView ?? 1;
        const autoScrollOffset = getParams().autoScrollOffset;
        const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
        if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
            const currentThumbsIndex = thumbsSwiper.activeIndex;
            let newThumbsIndex;
            let direction;
            if (thumbsSwiper.params.loop) {
                const newThumbsSlide = thumbsSwiper.slides.find((slideEl)=>slideEl.getAttribute('data-swiper-slide-index') === `${swiper.realIndex}`);
                newThumbsIndex = newThumbsSlide ? thumbsSwiper.slides.indexOf(newThumbsSlide) : -1;
                direction = swiper.activeIndex > swiper.previousIndex ? 'next' : 'prev';
            } else {
                newThumbsIndex = swiper.realIndex;
                direction = newThumbsIndex > swiper.previousIndex ? 'next' : 'prev';
            }
            if (useOffset) newThumbsIndex += direction === 'next' ? autoScrollOffset : -1 * autoScrollOffset;
            if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
                if (thumbsSwiper.params.centeredSlides) {
                    if (newThumbsIndex > currentThumbsIndex) newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
                    else newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
                } else newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup;
                thumbsSwiper.slideTo(newThumbsIndex, slideSpeed);
            }
        }
    }
    on('beforeInit', ()=>{
        const thumbs = swiper.params.thumbs;
        if (!thumbs || !thumbs.swiper) return;
        if (typeof thumbs.swiper === 'string' || thumbs.swiper instanceof HTMLElement) {
            const getThumbsElementAndInit = ()=>{
                const thumbsElement = typeof thumbs.swiper === 'string' ? document.querySelector(thumbs.swiper) : thumbs.swiper;
                if (thumbsElement && thumbsElement.swiper) {
                    thumbs.swiper = thumbsElement.swiper;
                    init();
                    update(true);
                } else if (thumbsElement) {
                    const eventName = `${swiper.params.eventsPrefix}init`;
                    const onThumbsSwiper = (e)=>{
                        const detail = e.detail;
                        thumbs.swiper = detail[0];
                        thumbsElement.removeEventListener(eventName, onThumbsSwiper);
                        init();
                        update(true);
                        thumbs.swiper.update();
                        swiper.update();
                    };
                    thumbsElement.addEventListener(eventName, onThumbsSwiper);
                }
                return thumbsElement;
            };
            const watchForThumbsToAppear = ()=>{
                if (swiper.destroyed) return;
                const thumbsElement = getThumbsElementAndInit();
                if (!thumbsElement) requestAnimationFrame(watchForThumbsToAppear);
            };
            requestAnimationFrame(watchForThumbsToAppear);
        } else {
            init();
            update(true);
        }
    });
    on('slideChange update resize observerUpdate', ()=>{
        update();
    });
    on('setTransition', (_s, duration)=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        thumbsSwiper.setTransition(duration);
    });
    on('beforeDestroy', ()=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        if (swiperCreated) thumbsSwiper.destroy();
    });
    Object.assign(swiper.thumbs, {
        init: init,
        update: update
    });
};



const $661f7d385acf36a7$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, emit: emit, once: once })=>{
    extendParams({
        freeMode: {
            enabled: false,
            momentum: true,
            momentumRatio: 1,
            momentumBounce: true,
            momentumBounceRatio: 1,
            momentumVelocityRatio: 1,
            sticky: false,
            minimumVelocity: 0.02
        }
    });
    function getParams() {
        return swiper.params.freeMode;
    }
    function onTouchStart() {
        if (swiper.params.cssMode) return;
        const translate = swiper.getTranslate();
        swiper.setTranslate(translate);
        swiper.setTransition(0);
        swiper.touchEventsData.velocities.length = 0;
        swiper.freeMode.onTouchEnd({
            currentPos: swiper.rtl ? swiper.translate : -swiper.translate
        });
    }
    function onTouchMove() {
        if (swiper.params.cssMode) return;
        const { touchEventsData: data, touches: touches } = swiper;
        // Velocity
        if (data.velocities.length === 0) data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
            time: data.touchStartTime ?? (0, $3e0e2b092da8f124$export$3b14a55fb2447963)()
        });
        data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
            time: (0, $3e0e2b092da8f124$export$3b14a55fb2447963)()
        });
    }
    function onTouchEnd({ currentPos: currentPos }) {
        if (swiper.params.cssMode) return;
        const { wrapperEl: wrapperEl, rtlTranslate: rtl, snapGrid: snapGrid, touchEventsData: data } = swiper;
        const params = swiper.params;
        const freeModeParams = getParams();
        // Time diff
        const touchEndTime = (0, $3e0e2b092da8f124$export$3b14a55fb2447963)();
        const timeDiff = touchEndTime - (data.touchStartTime ?? touchEndTime);
        if (currentPos < -swiper.minTranslate()) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (currentPos > -swiper.maxTranslate()) {
            if (swiper.slides.length < snapGrid.length) swiper.slideTo(snapGrid.length - 1);
            else swiper.slideTo(swiper.slides.length - 1);
            return;
        }
        if (freeModeParams.momentum) {
            if (data.velocities.length > 1) {
                const lastMoveEvent = data.velocities.pop();
                const velocityEvent = data.velocities.pop();
                const distance = lastMoveEvent.position - velocityEvent.position;
                const time = lastMoveEvent.time - velocityEvent.time;
                swiper.velocity = distance / time;
                swiper.velocity /= 2;
                if (Math.abs(swiper.velocity) < freeModeParams.minimumVelocity) swiper.velocity = 0;
                // this implies that the user stopped moving a finger then released.
                // There would be no events with distance zero, so the last event is stale.
                if (time > 150 || (0, $3e0e2b092da8f124$export$3b14a55fb2447963)() - lastMoveEvent.time > 300) swiper.velocity = 0;
            } else swiper.velocity = 0;
            swiper.velocity *= freeModeParams.momentumVelocityRatio;
            data.velocities.length = 0;
            let momentumDuration = 1000 * freeModeParams.momentumRatio;
            const momentumDistance = swiper.velocity * momentumDuration;
            let newPosition = swiper.translate + momentumDistance;
            if (rtl) newPosition = -newPosition;
            let doBounce = false;
            let afterBouncePosition;
            const bounceAmount = Math.abs(swiper.velocity) * 20 * freeModeParams.momentumBounceRatio;
            let needsLoopFix = false;
            if (newPosition < swiper.maxTranslate()) {
                if (freeModeParams.momentumBounce) {
                    if (newPosition + swiper.maxTranslate() < -bounceAmount) newPosition = swiper.maxTranslate() - bounceAmount;
                    afterBouncePosition = swiper.maxTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.maxTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (newPosition > swiper.minTranslate()) {
                if (freeModeParams.momentumBounce) {
                    if (newPosition - swiper.minTranslate() > bounceAmount) newPosition = swiper.minTranslate() + bounceAmount;
                    afterBouncePosition = swiper.minTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.minTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (freeModeParams.sticky) {
                let nextSlide = 0;
                for(let j = 0; j < snapGrid.length; j += 1)if (snapGrid[j] > -newPosition) {
                    nextSlide = j;
                    break;
                }
                if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs((snapGrid[nextSlide - 1] ?? snapGrid[nextSlide]) - newPosition) || swiper.swipeDirection === 'next') newPosition = snapGrid[nextSlide];
                else newPosition = snapGrid[nextSlide - 1];
                newPosition = -newPosition;
            }
            if (needsLoopFix) once('transitionEnd', ()=>{
                swiper.loopFix();
            });
            // Fix duration
            if (swiper.velocity !== 0) {
                if (rtl) momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
                else momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
                if (freeModeParams.sticky) {
                    // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
                    // event, then durations can be 20+ seconds to slide one (or zero!) slides.
                    // It's easy to see this when simulating touch with mouse events. To fix this,
                    // limit single-slide swipes to the default slide duration. This also has the
                    // nice side effect of matching slide speed if the user stopped moving before
                    // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
                    // For faster swipes, also apply limits (albeit higher ones).
                    const moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
                    const currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
                    const speed = params.speed;
                    if (moveDistance < currentSlideSize) momentumDuration = speed;
                    else if (moveDistance < 2 * currentSlideSize) momentumDuration = speed * 1.5;
                    else momentumDuration = speed * 2.5;
                }
            } else if (freeModeParams.sticky) {
                swiper.slideToClosest();
                return;
            }
            if (freeModeParams.momentumBounce && doBounce && afterBouncePosition !== undefined) {
                swiper.updateProgress(afterBouncePosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                swiper.animating = true;
                (0, $3e0e2b092da8f124$export$953cecd6e717a553)(wrapperEl, ()=>{
                    if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
                    emit('momentumBounce');
                    swiper.setTransition(params.speed);
                    setTimeout(()=>{
                        swiper.setTranslate(afterBouncePosition);
                        (0, $3e0e2b092da8f124$export$953cecd6e717a553)(wrapperEl, ()=>{
                            if (!swiper || swiper.destroyed) return;
                            swiper.transitionEnd();
                        });
                    }, 0);
                });
            } else if (swiper.velocity) {
                emit('_freeModeNoMomentumRelease');
                swiper.updateProgress(newPosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                if (!swiper.animating) {
                    swiper.animating = true;
                    (0, $3e0e2b092da8f124$export$953cecd6e717a553)(wrapperEl, ()=>{
                        if (!swiper || swiper.destroyed) return;
                        swiper.transitionEnd();
                    });
                }
            } else swiper.updateProgress(newPosition);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        } else if (freeModeParams.sticky) {
            swiper.slideToClosest();
            return;
        } else emit('_freeModeNoMomentumRelease');
        if (!freeModeParams.momentum || timeDiff >= params.longSwipesMs) {
            emit('_freeModeStaticRelease');
            swiper.updateProgress();
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
    }
    swiper.freeMode = {
        onTouchStart: onTouchStart,
        onTouchMove: onTouchMove,
        onTouchEnd: onTouchEnd
    };
};


const $3767883c93014eb9$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on })=>{
    extendParams({
        grid: {
            rows: 1,
            fill: 'column'
        }
    });
    function getParams() {
        return swiper.params.grid;
    }
    let slidesNumberEvenToRows;
    let slidesPerRow;
    let numFullColumns;
    let wasMultiRow;
    const getSpaceBetween = ()=>{
        let spaceBetween = swiper.params.spaceBetween ?? 0;
        if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiper.size;
        else if (typeof spaceBetween === 'string') spaceBetween = parseFloat(spaceBetween);
        return spaceBetween;
    };
    const isVirtualEnabled = ()=>{
        const virtualParams = swiper.params.virtual;
        return !!swiper.virtual && typeof virtualParams === 'object' && virtualParams !== null && !!virtualParams.enabled;
    };
    const initSlides = (slides)=>{
        const { slidesPerView: slidesPerView } = swiper.params;
        const { rows: rows, fill: fill } = getParams();
        const slidesLength = isVirtualEnabled() ? swiper.virtual.slides.length : slides.length;
        numFullColumns = Math.floor(slidesLength / rows);
        if (Math.floor(slidesLength / rows) === slidesLength / rows) slidesNumberEvenToRows = slidesLength;
        else slidesNumberEvenToRows = Math.ceil(slidesLength / rows) * rows;
        if (slidesPerView !== 'auto' && fill === 'row') slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, Math.floor(slidesPerView ?? 1) * rows);
        slidesPerRow = slidesNumberEvenToRows / rows;
    };
    const unsetSlides = ()=>{
        if (swiper.slides) swiper.slides.forEach((slide)=>{
            const gridSlide = slide;
            if (gridSlide.swiperSlideGridSet) {
                slide.style.height = '';
                slide.style.setProperty(swiper.getDirectionLabel('margin-top'), '');
            }
        });
    };
    const updateSlide = (i, slide, slides)=>{
        const { slidesPerGroup: slidesPerGroup } = swiper.params;
        const spaceBetween = getSpaceBetween();
        const { rows: rows, fill: fill } = getParams();
        const slidesLength = isVirtualEnabled() ? swiper.virtual.slides.length : slides.length;
        // Set slides order
        let newSlideOrderIndex;
        let column;
        let row;
        if (fill === 'row' && (slidesPerGroup ?? 1) > 1) {
            const groupsPer = slidesPerGroup ?? 1;
            const groupIndex = Math.floor(i / (groupsPer * rows));
            const slideIndexInGroup = i - rows * groupsPer * groupIndex;
            const columnsInGroup = groupIndex === 0 ? groupsPer : Math.min(Math.ceil((slidesLength - groupIndex * rows * groupsPer) / rows), groupsPer);
            row = Math.floor(slideIndexInGroup / columnsInGroup);
            column = slideIndexInGroup - row * columnsInGroup + groupIndex * groupsPer;
            newSlideOrderIndex = column + row * slidesNumberEvenToRows / rows;
            slide.style.order = String(newSlideOrderIndex);
        } else if (fill === 'column') {
            column = Math.floor(i / rows);
            row = i - column * rows;
            if (column > numFullColumns || column === numFullColumns && row === rows - 1) {
                row += 1;
                if (row >= rows) {
                    row = 0;
                    column += 1;
                }
            }
        } else {
            row = Math.floor(i / slidesPerRow);
            column = i - row * slidesPerRow;
        }
        const gridSlide = slide;
        gridSlide.row = row;
        gridSlide.column = column;
        slide.style.height = `calc((100% - ${(rows - 1) * spaceBetween}px) / ${rows})`;
        slide.style.setProperty(swiper.getDirectionLabel('margin-top'), row !== 0 && spaceBetween ? `${spaceBetween}px` : '');
        gridSlide.swiperSlideGridSet = true;
    };
    const updateWrapperSize = (slideSize, snapGrid)=>{
        const { centeredSlides: centeredSlides, roundLengths: roundLengths } = swiper.params;
        const spaceBetween = getSpaceBetween();
        const { rows: rows } = getParams();
        swiper.virtualSize = (slideSize + spaceBetween) * slidesNumberEvenToRows;
        swiper.virtualSize = Math.ceil(swiper.virtualSize / rows) - spaceBetween;
        if (!swiper.params.cssMode) swiper.wrapperEl.style.setProperty(swiper.getDirectionLabel('width'), `${swiper.virtualSize + spaceBetween}px`);
        if (centeredSlides) {
            const newSlidesGrid = [];
            for(let i = 0; i < snapGrid.length; i += 1){
                let slidesGridItem = snapGrid[i];
                if (roundLengths) slidesGridItem = Math.floor(slidesGridItem);
                if (snapGrid[i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
            }
            snapGrid.splice(0, snapGrid.length);
            snapGrid.push(...newSlidesGrid);
        }
    };
    const onInit = ()=>{
        const gridParams = swiper.params.grid;
        wasMultiRow = !!(gridParams && (gridParams.rows ?? 1) > 1);
    };
    const onUpdate = ()=>{
        const { params: params, el: el } = swiper;
        const gridParams = params.grid;
        const isMultiRow = !!(gridParams && (gridParams.rows ?? 1) > 1);
        if (wasMultiRow && !isMultiRow) {
            el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
            numFullColumns = 1;
            swiper.emitContainerClasses();
        } else if (!wasMultiRow && isMultiRow) {
            el.classList.add(`${params.containerModifierClass}grid`);
            if (gridParams.fill === 'column') el.classList.add(`${params.containerModifierClass}grid-column`);
            swiper.emitContainerClasses();
        }
        wasMultiRow = isMultiRow;
    };
    on('init', onInit);
    on('update', onUpdate);
    swiper.grid = {
        initSlides: initSlides,
        unsetSlides: unsetSlides,
        updateSlide: updateSlide,
        updateWrapperSize: updateWrapperSize
    };
};



function $e8eb9c2e5c926b2c$var$addSlide(index, slides) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex, slidesEl: slidesEl } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides ?? 0;
        swiper.loopDestroy();
        swiper.recalcSlides();
    }
    const baseLength = swiper.slides.length;
    if (index <= 0) {
        swiper.prependSlide(slides);
        return;
    }
    if (index >= baseLength) {
        swiper.appendSlide(slides);
        return;
    }
    let newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
    const slidesBuffer = [];
    for(let i = baseLength - 1; i >= index; i -= 1){
        const currentSlide = swiper.slides[i];
        if (!currentSlide) continue;
        currentSlide.remove();
        slidesBuffer.unshift(currentSlide);
    }
    if (Array.isArray(slides)) {
        for(let i = 0; i < slides.length; i += 1){
            const slide = slides[i];
            if (slide) slidesEl.append(slide);
        }
        newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else slidesEl.append(slides);
    for(let i = 0; i < slidesBuffer.length; i += 1)slidesEl.append(slidesBuffer[i]);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + (swiper.loopedSlides ?? 0), 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}
function $e8eb9c2e5c926b2c$var$appendSlide(slides) {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (params.loop) swiper.loopDestroy();
    const appendElement = (slideEl)=>{
        if (typeof slideEl === 'string') {
            const tempDOM = document.createElement('div');
            (0, $3e0e2b092da8f124$export$efccba1c4a2ef57b)(tempDOM, slideEl);
            const child = tempDOM.children[0];
            if (child) slidesEl.append(child);
            (0, $3e0e2b092da8f124$export$efccba1c4a2ef57b)(tempDOM, '');
        } else slidesEl.append(slideEl);
    };
    if (Array.isArray(slides)) for(let i = 0; i < slides.length; i += 1){
        const slide = slides[i];
        if (slide) appendElement(slide);
    }
    else appendElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
}
function $e8eb9c2e5c926b2c$var$prependSlide(slides) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex, slidesEl: slidesEl } = swiper;
    if (params.loop) swiper.loopDestroy();
    let newActiveIndex = activeIndex + 1;
    const prependElement = (slideEl)=>{
        if (typeof slideEl === 'string') {
            const tempDOM = document.createElement('div');
            (0, $3e0e2b092da8f124$export$efccba1c4a2ef57b)(tempDOM, slideEl);
            const child = tempDOM.children[0];
            if (child) slidesEl.prepend(child);
            (0, $3e0e2b092da8f124$export$efccba1c4a2ef57b)(tempDOM, '');
        } else slidesEl.prepend(slideEl);
    };
    if (Array.isArray(slides)) {
        for(let i = 0; i < slides.length; i += 1){
            const slide = slides[i];
            if (slide) prependElement(slide);
        }
        newActiveIndex = activeIndex + slides.length;
    } else prependElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    swiper.slideTo(newActiveIndex, 0, false);
}
function $e8eb9c2e5c926b2c$var$removeAllSlides() {
    const swiper = this;
    const slidesIndexes = [];
    for(let i = 0; i < swiper.slides.length; i += 1)slidesIndexes.push(i);
    swiper.removeSlide(slidesIndexes);
}
function $e8eb9c2e5c926b2c$var$removeSlide(slidesIndexes) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides ?? 0;
        swiper.loopDestroy();
    }
    let newActiveIndex = activeIndexBuffer;
    if (Array.isArray(slidesIndexes)) {
        for(let i = 0; i < slidesIndexes.length; i += 1){
            const indexToRemove = slidesIndexes[i];
            if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
            if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        }
        newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
        const indexToRemove = slidesIndexes;
        if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
        if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        newActiveIndex = Math.max(newActiveIndex, 0);
    }
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + (swiper.loopedSlides ?? 0), 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}
const $e8eb9c2e5c926b2c$export$2e2bcd8739ae039 = ({ swiper: swiper })=>{
    Object.assign(swiper, {
        appendSlide: $e8eb9c2e5c926b2c$var$appendSlide.bind(swiper),
        prependSlide: $e8eb9c2e5c926b2c$var$prependSlide.bind(swiper),
        addSlide: $e8eb9c2e5c926b2c$var$addSlide.bind(swiper),
        removeSlide: $e8eb9c2e5c926b2c$var$removeSlide.bind(swiper),
        removeAllSlides: $e8eb9c2e5c926b2c$var$removeAllSlides.bind(swiper)
    });
};


function $ce39167a9c5549e3$export$f1e1789686576879(params) {
    const { effect: effect, swiper: swiper, on: on, setTranslate: setTranslate, setTransition: setTransition, overwriteParams: overwriteParams, perspective: perspective, recreateShadows: recreateShadows, getEffectParams: getEffectParams } = params;
    on('beforeInit', ()=>{
        if (swiper.params.effect !== effect) return;
        swiper.classNames.push(`${swiper.params.containerModifierClass}${effect}`);
        if (perspective && perspective()) swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
        const overwriteParamsResult = overwriteParams ? overwriteParams() : {};
        Object.assign(swiper.params, overwriteParamsResult);
        Object.assign(swiper.originalParams, overwriteParamsResult);
    });
    on('setTranslate _virtualUpdated', ()=>{
        if (swiper.params.effect !== effect) return;
        setTranslate();
    });
    on('setTransition', (_s, duration)=>{
        if (swiper.params.effect !== effect) return;
        setTransition(duration);
    });
    on('transitionEnd', ()=>{
        if (swiper.params.effect !== effect) return;
        if (recreateShadows) {
            const effectParams = getEffectParams ? getEffectParams() : undefined;
            if (!effectParams || !effectParams.slideShadows) return;
            swiper.slides.forEach((slideEl)=>{
                slideEl.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((shadowEl)=>shadowEl.remove());
            });
            recreateShadows();
        }
    });
    let requireUpdateOnVirtual = false;
    on('virtualUpdate', ()=>{
        if (swiper.params.effect !== effect) return;
        if (!swiper.slides.length) requireUpdateOnVirtual = true;
        requestAnimationFrame(()=>{
            if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
                setTranslate();
                requireUpdateOnVirtual = false;
            }
        });
    });
}



function $1edc75782959477e$export$f1e1789686576879(_effectParams, slideEl) {
    const transformEl = (0, $3e0e2b092da8f124$export$ffb5f4729a158638)(slideEl);
    if (transformEl !== slideEl) {
        transformEl.style.backfaceVisibility = 'hidden';
        transformEl.style.setProperty('-webkit-backface-visibility', 'hidden');
    }
    return transformEl;
}



function $3ea27eb365069d23$export$f1e1789686576879({ swiper: swiper, duration: duration, transformElements: transformElements, allSlides: allSlides }) {
    const { activeIndex: activeIndex } = swiper;
    const getSlide = (el)=>{
        if (!el.parentElement) // assume shadow root
        return swiper.slides.find((slideEl)=>slideEl.shadowRoot && slideEl.shadowRoot === el.parentNode);
        if (el.parentElement instanceof HTMLElement) return el.parentElement;
        return undefined;
    };
    if (swiper.params.virtualTranslate && duration !== 0) {
        let eventTriggered = false;
        let transitionEndTarget;
        if (allSlides) transitionEndTarget = transformElements;
        else transitionEndTarget = transformElements.filter((transformEl)=>{
            const el = transformEl.classList.contains('swiper-slide-transform') ? getSlide(transformEl) : transformEl;
            return !!el && swiper.getSlideIndex(el) === activeIndex;
        });
        transitionEndTarget.forEach((el)=>{
            (0, $3e0e2b092da8f124$export$953cecd6e717a553)(el, ()=>{
                if (eventTriggered) return;
                if (!swiper || swiper.destroyed) return;
                eventTriggered = true;
                swiper.animating = false;
                const evt = new CustomEvent('transitionend', {
                    bubbles: true,
                    cancelable: true
                });
                swiper.wrapperEl.dispatchEvent(evt);
            });
        });
    }
}



const $ed89a1cd6005d986$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on })=>{
    extendParams({
        fadeEffect: {
            crossFade: false
        }
    });
    function getParams() {
        return swiper.params.fadeEffect;
    }
    const setTranslate = ()=>{
        const { slides: slides } = swiper;
        const params = getParams();
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            const offset = slideEl.swiperSlideOffset ?? 0;
            let tx = -offset;
            if (!swiper.params.virtualTranslate) tx -= swiper.translate;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
            }
            const slideProgress = slideEl.progress ?? 0;
            const slideOpacity = params.crossFade ? Math.max(1 - Math.abs(slideProgress), 0) : 1 + Math.min(Math.max(slideProgress, -1), 0);
            const targetEl = (0, $1edc75782959477e$export$f1e1789686576879)(params, slideEl);
            targetEl.style.opacity = String(slideOpacity);
            targetEl.style.transform = `translate3d(${tx}px, ${ty}px, 0px)`;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $3e0e2b092da8f124$export$ffb5f4729a158638)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
        });
        (0, $3ea27eb365069d23$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements,
            allSlides: true
        });
    };
    (0, $ce39167a9c5549e3$export$f1e1789686576879)({
        effect: 'fade',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
};




const $75984ef6f5fe27b6$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on })=>{
    extendParams({
        cubeEffect: {
            slideShadows: true,
            shadow: true,
            shadowOffset: 20,
            shadowScale: 0.94
        }
    });
    function getParams() {
        return swiper.params.cubeEffect;
    }
    const createSlideShadows = (slideEl, progress, isHorizontal)=>{
        let shadowBefore = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
        let shadowAfter = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
        if (!shadowBefore) {
            shadowBefore = (0, $3e0e2b092da8f124$export$407448d2b89b1813)('div', `swiper-slide-shadow-cube swiper-slide-shadow-${isHorizontal ? 'left' : 'top'}`.split(' '));
            slideEl.append(shadowBefore);
        }
        if (!shadowAfter) {
            shadowAfter = (0, $3e0e2b092da8f124$export$407448d2b89b1813)('div', `swiper-slide-shadow-cube swiper-slide-shadow-${isHorizontal ? 'right' : 'bottom'}`.split(' '));
            slideEl.append(shadowAfter);
        }
        if (shadowBefore) shadowBefore.style.opacity = String(Math.max(-progress, 0));
        if (shadowAfter) shadowAfter.style.opacity = String(Math.max(progress, 0));
    };
    const recreateShadows = ()=>{
        // create new ones
        const isHorizontal = swiper.isHorizontal();
        swiper.slides.forEach((slideEl)=>{
            const progress = Math.max(Math.min(slideEl.progress ?? 0, 1), -1);
            createSlideShadows(slideEl, progress, isHorizontal);
        });
    };
    const setTranslate = ()=>{
        const { el: el, wrapperEl: wrapperEl, slides: slides, width: swiperWidth, height: swiperHeight, rtlTranslate: rtl, size: swiperSize } = swiper;
        const r = (0, $3e0e2b092da8f124$export$ae1af26003f05816)(swiper);
        const params = getParams();
        const isHorizontal = swiper.isHorizontal();
        const isVirtual = !!(swiper.virtual && swiper.params.virtual?.enabled);
        let wrapperRotate = 0;
        let cubeShadowEl = null;
        if (params.shadow) {
            if (isHorizontal) {
                cubeShadowEl = swiper.wrapperEl.querySelector('.swiper-cube-shadow');
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, $3e0e2b092da8f124$export$407448d2b89b1813)('div', 'swiper-cube-shadow');
                    swiper.wrapperEl.append(cubeShadowEl);
                }
                cubeShadowEl.style.height = `${swiperWidth}px`;
            } else {
                cubeShadowEl = el.querySelector('.swiper-cube-shadow');
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, $3e0e2b092da8f124$export$407448d2b89b1813)('div', 'swiper-cube-shadow');
                    el.append(cubeShadowEl);
                }
            }
        }
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            let slideIndex = i;
            if (isVirtual) slideIndex = parseInt(slideEl.getAttribute('data-swiper-slide-index') ?? '0', 10);
            let slideAngle = slideIndex * 90;
            let round = Math.floor(slideAngle / 360);
            if (rtl) {
                slideAngle = -slideAngle;
                round = Math.floor(-slideAngle / 360);
            }
            const progress = Math.max(Math.min(slideEl.progress ?? 0, 1), -1);
            let tx = 0;
            let ty = 0;
            let tz = 0;
            if (slideIndex % 4 === 0) {
                tx = -round * 4 * swiperSize;
                tz = 0;
            } else if ((slideIndex - 1) % 4 === 0) {
                tx = 0;
                tz = -round * 4 * swiperSize;
            } else if ((slideIndex - 2) % 4 === 0) {
                tx = swiperSize + round * 4 * swiperSize;
                tz = swiperSize;
            } else if ((slideIndex - 3) % 4 === 0) {
                tx = -swiperSize;
                tz = 3 * swiperSize + swiperSize * 4 * round;
            }
            if (rtl) tx = -tx;
            if (!isHorizontal) {
                ty = tx;
                tx = 0;
            }
            const transform = `rotateX(${r(isHorizontal ? 0 : -slideAngle)}deg) rotateY(${r(isHorizontal ? slideAngle : 0)}deg) translate3d(${tx}px, ${ty}px, ${tz}px)`;
            if (progress <= 1 && progress > -1) {
                wrapperRotate = slideIndex * 90 + progress * 90;
                if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
            }
            slideEl.style.transform = transform;
            if (params.slideShadows) createSlideShadows(slideEl, progress, isHorizontal);
        }
        wrapperEl.style.transformOrigin = `50% 50% -${swiperSize / 2}px`;
        wrapperEl.style.setProperty('-webkit-transform-origin', `50% 50% -${swiperSize / 2}px`);
        if (params.shadow && cubeShadowEl) {
            if (isHorizontal) cubeShadowEl.style.transform = `translate3d(0px, ${swiperWidth / 2 + params.shadowOffset}px, ${-swiperWidth / 2}px) rotateX(89.99deg) rotateZ(0deg) scale(${params.shadowScale})`;
            else {
                const shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
                const multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
                const scale1 = params.shadowScale;
                const scale2 = params.shadowScale / multiplier;
                const offset = params.shadowOffset;
                cubeShadowEl.style.transform = `scale3d(${scale1}, 1, ${scale2}) translate3d(0px, ${swiperHeight / 2 + offset}px, ${-swiperHeight / 2 / scale2}px) rotateX(-89.99deg)`;
            }
        }
        wrapperEl.style.transform = `translate3d(0px,0,0px) rotateX(${r(swiper.isHorizontal() ? 0 : wrapperRotate)}deg) rotateY(${r(swiper.isHorizontal() ? -wrapperRotate : 0)}deg)`;
        wrapperEl.style.setProperty('--swiper-cube-translate-z', '0px');
    };
    const setTransition = (duration)=>{
        const { el: el, slides: slides } = swiper;
        slides.forEach((slideEl)=>{
            slideEl.style.transitionDuration = `${duration}ms`;
            slideEl.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((subEl)=>{
                subEl.style.transitionDuration = `${duration}ms`;
            });
        });
        if (swiper.params.cubeEffect?.shadow && !swiper.isHorizontal()) {
            const shadowEl = el.querySelector('.swiper-cube-shadow');
            if (shadowEl) shadowEl.style.transitionDuration = `${duration}ms`;
        }
    };
    (0, $ce39167a9c5549e3$export$f1e1789686576879)({
        effect: 'cube',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.cubeEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                resistanceRatio: 0,
                spaceBetween: 0,
                centeredSlides: false,
                virtualTranslate: true
            })
    });
};



function $4dfb92d69cb8a433$export$db3b6bfb95261072(suffix, slideEl, side) {
    const shadowClass = `swiper-slide-shadow${side ? `-${side}` : ''}${suffix ? ` swiper-slide-shadow-${suffix}` : ''}`;
    const shadowContainer = (0, $3e0e2b092da8f124$export$ffb5f4729a158638)(slideEl);
    const selector = `.${shadowClass.split(' ').join('.')}`;
    const existing = shadowContainer.querySelector(selector);
    if (existing) return existing;
    const created = (0, $3e0e2b092da8f124$export$407448d2b89b1813)('div', shadowClass.split(' '));
    shadowContainer.append(created);
    return created;
}






const $7a3c30fafac582ff$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on })=>{
    extendParams({
        flipEffect: {
            slideShadows: true,
            limitRotation: true
        }
    });
    function getParams() {
        return swiper.params.flipEffect;
    }
    const createSlideShadows = (slideEl, progress)=>{
        let shadowBefore = swiper.isHorizontal() ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
        let shadowAfter = swiper.isHorizontal() ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
        if (!shadowBefore) shadowBefore = (0, $4dfb92d69cb8a433$export$db3b6bfb95261072)('flip', slideEl, swiper.isHorizontal() ? 'left' : 'top');
        if (!shadowAfter) shadowAfter = (0, $4dfb92d69cb8a433$export$db3b6bfb95261072)('flip', slideEl, swiper.isHorizontal() ? 'right' : 'bottom');
        if (shadowBefore) shadowBefore.style.opacity = String(Math.max(-progress, 0));
        if (shadowAfter) shadowAfter.style.opacity = String(Math.max(progress, 0));
    };
    const recreateShadows = ()=>{
        // Set shadows
        const params = getParams();
        swiper.slides.forEach((slideEl)=>{
            let progress = slideEl.progress ?? 0;
            if (params.limitRotation) progress = Math.max(Math.min(progress, 1), -1);
            createSlideShadows(slideEl, progress);
        });
    };
    const setTranslate = ()=>{
        const { slides: slides, rtlTranslate: rtl } = swiper;
        const params = getParams();
        const rotateFix = (0, $3e0e2b092da8f124$export$ae1af26003f05816)(swiper);
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            let progress = slideEl.progress ?? 0;
            if (params.limitRotation) progress = Math.max(Math.min(progress, 1), -1);
            const offset = slideEl.swiperSlideOffset ?? 0;
            const rotate = -180 * progress;
            let rotateY = rotate;
            let rotateX = 0;
            let tx = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
                rotateX = -rotateY;
                rotateY = 0;
            } else if (rtl) rotateY = -rotateY;
            slideEl.style.zIndex = String(-Math.abs(Math.round(progress)) + slides.length);
            if (params.slideShadows) createSlideShadows(slideEl, progress);
            const transform = `translate3d(${tx}px, ${ty}px, 0px) rotateX(${rotateFix(rotateX)}deg) rotateY(${rotateFix(rotateY)}deg)`;
            const targetEl = (0, $1edc75782959477e$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $3e0e2b092da8f124$export$ffb5f4729a158638)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $3ea27eb365069d23$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements
        });
    };
    (0, $ce39167a9c5549e3$export$f1e1789686576879)({
        effect: 'flip',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.flipEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
};






const $8b7378894c192c44$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on })=>{
    extendParams({
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            scale: 1,
            modifier: 1,
            slideShadows: true
        }
    });
    function getParams() {
        return swiper.params.coverflowEffect;
    }
    const setTranslate = ()=>{
        const { width: swiperWidth, height: swiperHeight, slides: slides, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = getParams();
        const isHorizontal = swiper.isHorizontal();
        const transform = swiper.translate;
        const center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
        const rotate = isHorizontal ? params.rotate : -params.rotate;
        const translate = params.depth;
        const r = (0, $3e0e2b092da8f124$export$ae1af26003f05816)(swiper);
        // Each slide offset from center
        for(let i = 0, length = slides.length; i < length; i += 1){
            const slideEl = slides[i];
            const slideSize = slidesSizesGrid[i];
            const slideOffset = slideEl.swiperSlideOffset ?? 0;
            const centerOffset = (center - slideOffset - slideSize / 2) / slideSize;
            const offsetMultiplier = typeof params.modifier === 'function' ? params.modifier(centerOffset) : centerOffset * params.modifier;
            let rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
            let rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
            // var rotateZ = 0
            let translateZ = -translate * Math.abs(offsetMultiplier);
            let stretch = typeof params.stretch === 'string' && params.stretch.indexOf('%') !== -1 ? parseFloat(params.stretch) / 100 * slideSize : params.stretch;
            let translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
            let translateX = isHorizontal ? stretch * offsetMultiplier : 0;
            let scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier);
            // Fix for ultra small values
            if (Math.abs(translateX) < 0.001) translateX = 0;
            if (Math.abs(translateY) < 0.001) translateY = 0;
            if (Math.abs(translateZ) < 0.001) translateZ = 0;
            if (Math.abs(rotateY) < 0.001) rotateY = 0;
            if (Math.abs(rotateX) < 0.001) rotateX = 0;
            if (Math.abs(scale) < 0.001) scale = 0;
            const slideTransform = `translate3d(${translateX}px,${translateY}px,${translateZ}px)  rotateX(${r(rotateX)}deg) rotateY(${r(rotateY)}deg) scale(${scale})`;
            const targetEl = (0, $1edc75782959477e$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = slideTransform;
            slideEl.style.zIndex = String(-Math.abs(Math.round(offsetMultiplier)) + 1);
            if (params.slideShadows) {
                // Set shadows
                let shadowBeforeEl = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
                let shadowAfterEl = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
                if (!shadowBeforeEl) shadowBeforeEl = (0, $4dfb92d69cb8a433$export$db3b6bfb95261072)('coverflow', slideEl, isHorizontal ? 'left' : 'top');
                if (!shadowAfterEl) shadowAfterEl = (0, $4dfb92d69cb8a433$export$db3b6bfb95261072)('coverflow', slideEl, isHorizontal ? 'right' : 'bottom');
                if (shadowBeforeEl) shadowBeforeEl.style.opacity = String(offsetMultiplier > 0 ? offsetMultiplier : 0);
                if (shadowAfterEl) shadowAfterEl.style.opacity = String(-offsetMultiplier > 0 ? -offsetMultiplier : 0);
            }
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $3e0e2b092da8f124$export$ffb5f4729a158638)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
    };
    (0, $ce39167a9c5549e3$export$f1e1789686576879)({
        effect: 'coverflow',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true
            })
    });
};







const $9406c03f7fbaac7d$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on })=>{
    extendParams({
        creativeEffect: {
            limitProgress: 1,
            shadowPerProgress: false,
            progressMultiplier: 1,
            perspective: true,
            prev: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            },
            next: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            }
        }
    });
    function getParams() {
        return swiper.params.creativeEffect;
    }
    const getTranslateValue = (value)=>{
        if (typeof value === 'string') return value;
        return `${value}px`;
    };
    const setTranslate = ()=>{
        const { slides: slides, wrapperEl: wrapperEl, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = getParams();
        const { progressMultiplier: multiplier } = params;
        const isCenteredSlides = swiper.params.centeredSlides;
        const rotateFix = (0, $3e0e2b092da8f124$export$ae1af26003f05816)(swiper);
        if (isCenteredSlides) {
            const margin = slidesSizesGrid[0] / 2 - (swiper.params.slidesOffsetBefore ?? 0);
            wrapperEl.style.transform = `translateX(calc(50% - ${margin}px))`;
        }
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            const slideProgress = slideEl.progress ?? 0;
            const progress = Math.min(Math.max(slideProgress, -params.limitProgress), params.limitProgress);
            let originalProgress = progress;
            if (!isCenteredSlides) originalProgress = Math.min(Math.max(slideEl.originalProgress ?? 0, -params.limitProgress), params.limitProgress);
            const offset = slideEl.swiperSlideOffset ?? 0;
            const t = [
                swiper.params.cssMode ? -offset - swiper.translate : -offset,
                0,
                0
            ];
            const r = [
                0,
                0,
                0
            ];
            let custom = false;
            if (!swiper.isHorizontal()) {
                t[1] = t[0];
                t[0] = 0;
            }
            let data = {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                scale: 1,
                opacity: 1
            };
            if (progress < 0) {
                data = params.next;
                custom = true;
            } else if (progress > 0) {
                data = params.prev;
                custom = true;
            }
            // set translate
            t.forEach((value, index)=>{
                t[index] = `calc(${value}px + (${getTranslateValue(data.translate[index])} * ${Math.abs(progress * multiplier)}))`;
            });
            // set rotates
            r.forEach((_value, index)=>{
                r[index] = data.rotate[index] * Math.abs(progress * multiplier);
            });
            slideEl.style.zIndex = String(-Math.abs(Math.round(slideProgress)) + slides.length);
            const translateString = t.join(', ');
            const rotateString = `rotateX(${rotateFix(r[0])}deg) rotateY(${rotateFix(r[1])}deg) rotateZ(${rotateFix(r[2])}deg)`;
            const scaleString = originalProgress < 0 ? `scale(${1 + (1 - data.scale) * originalProgress * multiplier})` : `scale(${1 - (1 - data.scale) * originalProgress * multiplier})`;
            const opacityString = originalProgress < 0 ? 1 + (1 - data.opacity) * originalProgress * multiplier : 1 - (1 - data.opacity) * originalProgress * multiplier;
            const transform = `translate3d(${translateString}) ${rotateString} ${scaleString}`;
            // Set shadows
            if (custom && data.shadow || !custom) {
                let shadowEl = slideEl.querySelector('.swiper-slide-shadow');
                if (!shadowEl && data.shadow) shadowEl = (0, $4dfb92d69cb8a433$export$db3b6bfb95261072)('creative', slideEl);
                if (shadowEl) {
                    const shadowOpacity = params.shadowPerProgress ? progress * (1 / params.limitProgress) : progress;
                    shadowEl.style.opacity = String(Math.min(Math.max(Math.abs(shadowOpacity), 0), 1));
                }
            }
            const targetEl = (0, $1edc75782959477e$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
            targetEl.style.opacity = String(opacityString);
            if (data.origin) targetEl.style.transformOrigin = data.origin;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $3e0e2b092da8f124$export$ffb5f4729a158638)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow').forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $3ea27eb365069d23$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements,
            allSlides: true
        });
    };
    (0, $ce39167a9c5549e3$export$f1e1789686576879)({
        effect: 'creative',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>getParams().perspective,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
};







const $ccd0a7134d1e48e4$export$2e2bcd8739ae039 = ({ swiper: swiper, extendParams: extendParams, on: on })=>{
    extendParams({
        cardsEffect: {
            slideShadows: true,
            rotate: true,
            perSlideRotate: 2,
            perSlideOffset: 8
        }
    });
    function getParams() {
        return swiper.params.cardsEffect;
    }
    const setTranslate = ()=>{
        const { slides: slides, activeIndex: activeIndex, rtlTranslate: rtl } = swiper;
        const params = getParams();
        const { startTranslate: startTranslate, isTouched: isTouched } = swiper.touchEventsData;
        const currentTranslate = rtl ? -swiper.translate : swiper.translate;
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            const slideProgress = slideEl.progress ?? 0;
            const progress = Math.min(Math.max(slideProgress, -4), 4);
            let offset = slideEl.swiperSlideOffset ?? 0;
            if (swiper.params.centeredSlides && !swiper.params.cssMode) swiper.wrapperEl.style.transform = `translateX(${swiper.minTranslate()}px)`;
            if (swiper.params.centeredSlides && swiper.params.cssMode) offset -= slides[0].swiperSlideOffset ?? 0;
            let tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let tY = 0;
            const tZ = -100 * Math.abs(progress);
            let scale = 1;
            let rotate = -params.perSlideRotate * progress;
            let tXAdd = params.perSlideOffset - Math.abs(progress) * 0.75;
            const slideIndex = swiper.virtual && swiper.params.virtual?.enabled ? swiper.virtual.from + i : i;
            const isSwipeToNext = (slideIndex === activeIndex || slideIndex === activeIndex - 1) && progress > 0 && progress < 1 && (isTouched || swiper.params.cssMode) && (currentTranslate ?? 0) < (startTranslate ?? 0);
            const isSwipeToPrev = (slideIndex === activeIndex || slideIndex === activeIndex + 1) && progress < 0 && progress > -1 && (isTouched || swiper.params.cssMode) && (currentTranslate ?? 0) > (startTranslate ?? 0);
            if (isSwipeToNext || isSwipeToPrev) {
                const subProgress = (1 - Math.abs((Math.abs(progress) - 0.5) / 0.5)) ** 0.5;
                rotate += -28 * progress * subProgress;
                scale += -0.5 * subProgress;
                tXAdd += 96 * subProgress;
                tY = `${(params.rotate || swiper.isHorizontal() ? -25 : 0) * subProgress * Math.abs(progress)}%`;
            }
            if (progress < 0) // next
            tX = `calc(${tX}px ${rtl ? '-' : '+'} (${tXAdd * Math.abs(progress)}%))`;
            else if (progress > 0) // prev
            tX = `calc(${tX}px ${rtl ? '-' : '+'} (-${tXAdd * Math.abs(progress)}%))`;
            else tX = `${tX}px`;
            if (!swiper.isHorizontal()) {
                const prevY = tY;
                tY = tX;
                tX = prevY;
            }
            const scaleString = progress < 0 ? `${1 + (1 - scale) * progress}` : `${1 - (1 - scale) * progress}`;
            const transform = `
        translate3d(${tX}, ${tY}, ${tZ}px)
        rotateZ(${params.rotate ? rtl ? -rotate : rotate : 0}deg)
        scale(${scaleString})
      `;
            if (params.slideShadows) {
                // Set shadows
                let shadowEl = slideEl.querySelector('.swiper-slide-shadow');
                if (!shadowEl) shadowEl = (0, $4dfb92d69cb8a433$export$db3b6bfb95261072)('cards', slideEl);
                if (shadowEl) shadowEl.style.opacity = String(Math.min(Math.max((Math.abs(progress) - 0.5) / 0.5, 0), 1));
            }
            slideEl.style.zIndex = String(-Math.abs(Math.round(slideProgress)) + slides.length);
            const targetEl = (0, $1edc75782959477e$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $3e0e2b092da8f124$export$ffb5f4729a158638)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow').forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $3ea27eb365069d23$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements
        });
    };
    (0, $ce39167a9c5549e3$export$f1e1789686576879)({
        effect: 'cards',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                _loopSwapReset: false,
                watchSlidesProgress: true,
                loopAdditionalSlides: getParams().rotate ? 3 : 2,
                centeredSlides: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
};




const $876e203e931a550d$var$HINT_DELAY_MS = 2800;
const $876e203e931a550d$var$HINT_DELAY_REDUCED_MS = 1200;
function $876e203e931a550d$var$prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}
function $876e203e931a550d$var$getHeroSlideIndex(swiper) {
    return Array.from(swiper.slides).findIndex((slide)=>slide.classList.contains('fullpage-slide--hero'));
}
function $876e203e931a550d$var$isHeroSlideActive(swiper) {
    const heroIndex = $876e203e931a550d$var$getHeroSlideIndex(swiper);
    return heroIndex >= 0 && swiper.activeIndex === heroIndex;
}
function $876e203e931a550d$export$df1f69cd1ac336bd(swiper) {
    const hint = document.querySelector('[data-hero-scroll-hint]');
    if (!hint || !swiper) return;
    let showTimer = null;
    let dismissed = false;
    const clearShowTimer = ()=>{
        if (showTimer) {
            window.clearTimeout(showTimer);
            showTimer = null;
        }
    };
    const hideHint = ()=>{
        clearShowTimer();
        hint.classList.remove('is-visible');
        hint.setAttribute('aria-hidden', 'true');
    };
    const showHint = ()=>{
        if (dismissed || !$876e203e931a550d$var$isHeroSlideActive(swiper)) return;
        hint.classList.add('is-visible');
        hint.setAttribute('aria-hidden', 'false');
    };
    const scheduleShow = ()=>{
        hideHint();
        if (dismissed || !$876e203e931a550d$var$isHeroSlideActive(swiper)) return;
        const delay = $876e203e931a550d$var$prefersReducedMotion() ? $876e203e931a550d$var$HINT_DELAY_REDUCED_MS : $876e203e931a550d$var$HINT_DELAY_MS;
        showTimer = window.setTimeout(showHint, delay);
    };
    const dismissHint = ()=>{
        dismissed = true;
        hideHint();
    };
    swiper.on('slideChange', ()=>{
        if ($876e203e931a550d$var$isHeroSlideActive(swiper)) {
            scheduleShow();
            return;
        }
        dismissHint();
    });
    swiper.on('sliderFirstMove', dismissHint);
    scheduleShow();
}


/**
 * Mobile: each swipe is either inline scroll or slide change (never both).
 * Decision is made once per gesture from scroll position + swipe direction.
 * At bottom + new swipe up -> next slide. At top + new swipe down -> prev slide.
 */ const $f018449bb0787dea$var$SCROLL_EDGE_TOLERANCE = 2;
const $f018449bb0787dea$var$GESTURE_LOCK_THRESHOLD = 8;
const $f018449bb0787dea$var$NESTED_SCROLL_SKIP_SELECTOR = [
    '[data-mobile-days-scroll]',
    'a',
    'button',
    'input',
    'textarea',
    'select',
    'label',
    '[role="button"]',
    '.swiper-no-swiping'
].join(', ');
const $f018449bb0787dea$var$getOverflowScrollParent = (root, target)=>{
    let el = target;
    while(el && el !== root){
        if (el.scrollHeight > el.clientHeight + $f018449bb0787dea$var$SCROLL_EDGE_TOLERANCE) {
            const { overflowY: overflowY } = window.getComputedStyle(el);
            if (overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'overlay') return el;
        }
        el = el.parentElement;
    }
    if (root.scrollHeight > root.clientHeight + $f018449bb0787dea$var$SCROLL_EDGE_TOLERANCE) return root;
    return null;
};
/**
 * Decide once per gesture: inline scroll or slide swipe.
 * @param {number} deltaY Finger movement since gesture start.
 *   Positive = down, negative = up.
 */ const $f018449bb0787dea$var$shouldUseInnerScroll = (scrollEl, deltaY)=>{
    const maxScroll = scrollEl.scrollHeight - scrollEl.clientHeight;
    if (maxScroll <= $f018449bb0787dea$var$SCROLL_EDGE_TOLERANCE) return false;
    const scrollTop = scrollEl.scrollTop;
    const atTop = scrollTop <= $f018449bb0787dea$var$SCROLL_EDGE_TOLERANCE;
    const atBottom = scrollTop >= maxScroll - $f018449bb0787dea$var$SCROLL_EDGE_TOLERANCE;
    const inMiddle = scrollTop > $f018449bb0787dea$var$SCROLL_EDGE_TOLERANCE && scrollTop < maxScroll - $f018449bb0787dea$var$SCROLL_EDGE_TOLERANCE;
    if (inMiddle) return true;
    if (atTop && deltaY < 0) return true;
    if (atBottom && deltaY > 0) return true;
    return false;
};
const $f018449bb0787dea$var$resetSwiperGesture = (swiper)=>{
    const data = swiper.touchEventsData;
    if (!data) return;
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = undefined;
    data.isScrolling = undefined;
};
const $f018449bb0787dea$var$primeSwiperGesture = (swiper, pageX, pageY)=>{
    const data = swiper.touchEventsData;
    const touches = swiper.touches;
    if (!data || !touches) return;
    touches.startX = pageX;
    touches.startY = pageY;
    touches.currentX = pageX;
    touches.currentY = pageY;
    touches.previousX = pageX;
    touches.previousY = pageY;
    data.isTouched = true;
    data.isMoved = false;
    data.startMoving = undefined;
    data.isScrolling = undefined;
    data.touchStartTime = Date.now();
};
function $f018449bb0787dea$export$bbecfdef02dcc54d(getSwiper, getActiveSlideInner) {
    let touchStartY = 0;
    let touchStartX = 0;
    let activeScrollEl = null;
    let defaultAllowTouchMove = true;
    /** @type {null | 'pending' | 'inner' | 'slide'} */ let gestureMode = null;
    let activeTouchId = null;
    const reset = ()=>{
        activeScrollEl = null;
        gestureMode = null;
        activeTouchId = null;
        const swiper = getSwiper();
        if (swiper) swiper.allowTouchMove = defaultAllowTouchMove;
    };
    const beginGesture = (target, pageX, pageY)=>{
        const swiper = getSwiper();
        if (!swiper) return;
        if (target.closest?.($f018449bb0787dea$var$NESTED_SCROLL_SKIP_SELECTOR)) return;
        const slideInner = target.closest?.('.fullpage-slide__inner');
        const activeInner = getActiveSlideInner();
        if (!slideInner || slideInner !== activeInner) return;
        activeScrollEl = $f018449bb0787dea$var$getOverflowScrollParent(slideInner, target);
        if (!activeScrollEl) return;
        defaultAllowTouchMove = swiper.params.allowTouchMove;
        touchStartX = pageX;
        touchStartY = pageY;
        gestureMode = 'pending';
        swiper.allowTouchMove = false;
        $f018449bb0787dea$var$resetSwiperGesture(swiper);
    };
    const handleMove = (event, pageX, pageY)=>{
        if (!activeScrollEl) return;
        const swiper = getSwiper();
        if (!swiper) return;
        const deltaX = pageX - touchStartX;
        const deltaY = pageY - touchStartY;
        if (gestureMode === 'pending') {
            if (Math.abs(deltaX) < $f018449bb0787dea$var$GESTURE_LOCK_THRESHOLD && Math.abs(deltaY) < $f018449bb0787dea$var$GESTURE_LOCK_THRESHOLD) {
                swiper.allowTouchMove = false;
                event.stopImmediatePropagation();
                return;
            }
            gestureMode = $f018449bb0787dea$var$shouldUseInnerScroll(activeScrollEl, deltaY) ? 'inner' : 'slide';
            if (gestureMode === 'slide') {
                swiper.allowTouchMove = true;
                $f018449bb0787dea$var$primeSwiperGesture(swiper, pageX, pageY);
                return;
            }
        }
        if (gestureMode === 'inner') {
            swiper.allowTouchMove = false;
            $f018449bb0787dea$var$resetSwiperGesture(swiper);
            event.stopImmediatePropagation();
            return;
        }
        swiper.allowTouchMove = true;
    };
    const onPointerDown = (event)=>{
        if (event.pointerType === 'mouse' || activeTouchId !== null) return;
        beginGesture(event.target, event.pageX, event.pageY);
    };
    const onPointerMove = (event)=>{
        if (event.pointerType === 'mouse' || !activeScrollEl || activeTouchId !== null) return;
        handleMove(event, event.pageX, event.pageY);
    };
    const onTouchStart = (event)=>{
        if (!event.touches?.length || activeTouchId !== null) return;
        activeTouchId = event.touches[0].identifier;
        const touch = event.touches[0];
        beginGesture(event.target, touch.pageX, touch.pageY);
    };
    const onTouchMove = (event)=>{
        if (!activeScrollEl || !event.touches?.length) return;
        const touch = event.touches[0];
        if (touch.identifier !== activeTouchId) return;
        handleMove(event, touch.pageX, touch.pageY);
    };
    const captureOpts = {
        capture: true,
        passive: true
    };
    document.addEventListener('pointerdown', onPointerDown, captureOpts);
    document.addEventListener('pointermove', onPointerMove, captureOpts);
    document.addEventListener('pointerup', reset, captureOpts);
    document.addEventListener('pointercancel', reset, captureOpts);
    document.addEventListener('touchstart', onTouchStart, captureOpts);
    document.addEventListener('touchmove', onTouchMove, captureOpts);
    document.addEventListener('touchend', reset, captureOpts);
    document.addEventListener('touchcancel', reset, captureOpts);
}


const $4d818be9d2a947c9$export$d2bceb3c11396000 = 'events';
const $4d818be9d2a947c9$export$ccf5cae033ed6aca = 'locations';
const $4d818be9d2a947c9$var$EVENT_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;
function $4d818be9d2a947c9$export$250201d51136ff97(id) {
    if (!id) return '';
    if (id.startsWith('section-')) return id.slice(8);
    return id;
}
function $4d818be9d2a947c9$export$96e86055fa3f5d5e(value) {
    return $4d818be9d2a947c9$var$EVENT_DATE_PATTERN.test(value);
}
function $4d818be9d2a947c9$export$1e599d6a6868163a(hash = window.location.hash) {
    const raw = (hash || '').replace(/^#/, '');
    if (!raw) return {
        section: '',
        eventDate: null,
        locationId: null
    };
    const slash = raw.indexOf('/');
    if (slash === -1) return {
        section: $4d818be9d2a947c9$export$250201d51136ff97(raw),
        eventDate: null,
        locationId: null
    };
    const section = $4d818be9d2a947c9$export$250201d51136ff97(raw.slice(0, slash));
    const subpath = raw.slice(slash + 1).trim();
    if (section === $4d818be9d2a947c9$export$d2bceb3c11396000) return {
        section: section,
        eventDate: $4d818be9d2a947c9$export$96e86055fa3f5d5e(subpath) ? subpath : null,
        locationId: null
    };
    if (section === $4d818be9d2a947c9$export$ccf5cae033ed6aca && subpath !== '') return {
        section: section,
        eventDate: null,
        locationId: subpath
    };
    return {
        section: section,
        eventDate: null,
        locationId: null
    };
}
function $4d818be9d2a947c9$export$fe60e32bfb6ffcac(eventDate) {
    if (!eventDate || !$4d818be9d2a947c9$export$96e86055fa3f5d5e(eventDate)) return `#${$4d818be9d2a947c9$export$d2bceb3c11396000}`;
    return `#${$4d818be9d2a947c9$export$d2bceb3c11396000}/${eventDate}`;
}
function $4d818be9d2a947c9$export$b873b49e887c870f(locationId) {
    if (!locationId) return `#${$4d818be9d2a947c9$export$ccf5cae033ed6aca}`;
    return `#${$4d818be9d2a947c9$export$ccf5cae033ed6aca}/${encodeURIComponent(locationId)}`;
}
function $4d818be9d2a947c9$export$ca711c785b7c4274(eventDate, { push: push = false } = {}) {
    if (!$4d818be9d2a947c9$export$96e86055fa3f5d5e(eventDate)) return;
    const base = `${window.location.pathname}${window.location.search}`;
    const hash = $4d818be9d2a947c9$export$fe60e32bfb6ffcac(eventDate);
    const nextUrl = `${base}${hash}`;
    const currentUrl = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    if (currentUrl === nextUrl) return;
    const state = {
        fullpage: hash,
        eventDate: eventDate
    };
    if (push) history.pushState(state, '', nextUrl);
    else history.replaceState(state, '', nextUrl);
}
function $4d818be9d2a947c9$export$a89e6d7987f5b72(locationId, { push: push = false } = {}) {
    if (!locationId) return;
    const base = `${window.location.pathname}${window.location.search}`;
    const hash = $4d818be9d2a947c9$export$b873b49e887c870f(locationId);
    const nextUrl = `${base}${hash}`;
    const currentUrl = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    if (currentUrl === nextUrl) return;
    const state = {
        fullpage: hash,
        locationId: locationId
    };
    if (push) history.pushState(state, '', nextUrl);
    else history.replaceState(state, '', nextUrl);
}
function $4d818be9d2a947c9$export$c4b15044a3a84c83() {
    const slide = document.querySelector('.fullpage-slide--events');
    return slide?.classList.contains('swiper-slide-active') ?? false;
}
function $4d818be9d2a947c9$export$e82457802ace98a7() {
    const slide = document.querySelector('.fullpage-slide--locations');
    return slide?.classList.contains('swiper-slide-active') ?? false;
}


function $9dca141bdfb65599$var$getNavSections(root) {
    const nav = root.querySelector(".fullpage__side-nav");
    if (!nav) return [];
    return Array.from(nav.querySelectorAll("[data-fullpage-tab]")).map((tab)=>tab.getAttribute("data-fullpage-tab")).filter(Boolean);
}
const $9dca141bdfb65599$var$NAV_EDGE_FALLBACK_PX = 24;
const $9dca141bdfb65599$var$NAV_GAP_PX = 8;
const $9dca141bdfb65599$var$MOBILE_NAV_GAP_PX = 20;
const $9dca141bdfb65599$var$MOBILE_LAYOUT_MQ = "(max-width: 599px)";
// Locations switch to the stacked (photo on top) layout below this width.
// Keep in sync with $bp-locations-split in _variables.scss.
const $9dca141bdfb65599$var$LOCATIONS_STACKED_MQ = "(max-width: 899px)";
function $9dca141bdfb65599$var$getGridMarginPx() {
    const raw = getComputedStyle(document.documentElement).getPropertyValue("--paaadel-grid-margin").trim();
    const px = parseFloat(raw);
    return Number.isFinite(px) && px > 0 ? px : $9dca141bdfb65599$var$NAV_EDGE_FALLBACK_PX;
}
function $9dca141bdfb65599$var$getAdminBarOffsetPx() {
    if (!document.body.classList.contains("admin-bar")) return 0;
    const bar = document.getElementById("wpadminbar");
    return bar ? Math.round(bar.getBoundingClientRect().height) : 0;
}
function $9dca141bdfb65599$var$getViewportHeight() {
    // iOS Safari: layout viewport lets browser chrome collapse; visualViewport
    // letterboxes and leaves theme background visible at top/bottom.
    if ($9dca141bdfb65599$var$isMobileLayout()) return Math.round(window.innerHeight);
    const visual = window.visualViewport;
    return Math.round(visual && visual.height ? visual.height : window.innerHeight);
}
function $9dca141bdfb65599$var$applySlideHeights(swiperEl, height) {
    const px = `${height}px`;
    if (swiperEl) swiperEl.style.height = px;
    const slides = swiperEl?.querySelectorAll(".swiper-slide");
    if (!slides) return;
    slides.forEach((slide)=>{
        slide.style.height = px;
        slide.style.minHeight = px;
        slide.style.maxHeight = px;
    });
}
function $9dca141bdfb65599$var$snapSwiperToIndex(swiper, index, speed = 0) {
    const height = $9dca141bdfb65599$var$getViewportHeight();
    $9dca141bdfb65599$var$applySlideHeights(swiper.el, height);
    swiper.params.height = height;
    swiper.update();
    swiper.slideTo(index, speed);
    if (speed === 0) {
        swiper.setTranslate(-index * height);
        swiper.updateProgress();
        swiper.updateActiveIndex();
    }
}
function $9dca141bdfb65599$var$syncFullpageViewport(root, swiperEl, swiper) {
    const height = $9dca141bdfb65599$var$getViewportHeight();
    const px = `${height}px`;
    root.style.setProperty("--fullpage-vh", px);
    document.documentElement.style.setProperty("--fullpage-vh", px);
    $9dca141bdfb65599$var$applySlideHeights(swiperEl, height);
    if (swiper && !swiper.destroyed) {
        swiper.params.height = height;
        swiper.update();
        $9dca141bdfb65599$var$snapSwiperToIndex(swiper, swiper.activeIndex, 0);
    }
}
function $9dca141bdfb65599$var$slideIndexForSection(root, swiper, section) {
    const target = root.querySelector(`[data-fullpage-section="${section}"], #${section}, #section-${section}`);
    if (!target) return -1;
    const slides = Array.from(swiper.slides);
    return slides.indexOf(target);
}
/** Hero + media slides use plain page URL (no hash). */ function $9dca141bdfb65599$var$slideUsesCleanUrl(slide) {
    if (!slide) return false;
    return slide.classList.contains("fullpage-slide--hero") || slide.classList.contains("fullpage-slide--media");
}
function $9dca141bdfb65599$var$findSlideIndexByHashId(slides, hash, { fallback: fallback = -1 } = {}) {
    const { section: section } = (0, $4d818be9d2a947c9$export$1e599d6a6868163a)(hash);
    if (!section) return slides.length > 0 ? 0 : fallback;
    const normalized = section;
    if (normalized === "hero") return 0;
    if (normalized === "media") {
        const mediaIndex = slides.findIndex((slide)=>slide.classList.contains("fullpage-slide--media"));
        return mediaIndex >= 0 ? mediaIndex : fallback;
    }
    const index = slides.findIndex((slide)=>{
        if (slide.id === normalized) return true;
        const slideSection = slide.getAttribute("data-fullpage-section");
        return slideSection === normalized;
    });
    return index >= 0 ? index : fallback;
}
function $9dca141bdfb65599$var$hashForSlide(slide) {
    if (!slide || $9dca141bdfb65599$var$slideUsesCleanUrl(slide)) return "";
    const section = slide.getAttribute("data-fullpage-section");
    if (section) return `#${section}`;
    if (slide.id) return `#${slide.id}`;
    return "";
}
function $9dca141bdfb65599$var$indexForHash(swiper, hash) {
    return $9dca141bdfb65599$var$findSlideIndexByHashId(Array.from(swiper.slides), hash, {
        fallback: -1
    });
}
function $9dca141bdfb65599$var$initialSlideIndex(swiperEl, hash) {
    const wrapper = swiperEl.querySelector(".swiper-wrapper");
    if (!wrapper) return 0;
    return $9dca141bdfb65599$var$findSlideIndexByHashId(Array.from(wrapper.children), hash, {
        fallback: 0
    });
}
function $9dca141bdfb65599$var$isMobileLayout() {
    return window.matchMedia($9dca141bdfb65599$var$MOBILE_LAYOUT_MQ).matches;
}
function $9dca141bdfb65599$var$prefersFinePointer() {
    return window.matchMedia("(hover: hover) and (pointer: fine)").matches;
}
const $9dca141bdfb65599$var$SCROLL_NO_SWIPE_SELECTOR = [
    ".fullpage-slide__text-body",
    ".fullpage-slide__locations-textbox",
    "[data-events-calendar] .fullpage-events-calendar__panels",
    "[data-events-calendar] .fullpage-events-calendar__nav",
    "[data-events-calendar] .fullpage-events-calendar__mobile-nav",
    "[data-events-calendar] [data-mobile-strip-scroll]",
    "[data-events-calendar] [data-mobile-days-scroll]"
].join(", ");
function $9dca141bdfb65599$var$syncSlideInnerSwiping(root) {
    const lockInnerSwipe = $9dca141bdfb65599$var$prefersFinePointer();
    const mobile = $9dca141bdfb65599$var$isMobileLayout();
    root.querySelectorAll(".fullpage-slide__inner").forEach((el)=>{
        el.classList.toggle("swiper-no-swiping", lockInnerSwipe && !mobile);
    });
    // Clear stale no-swipe flags before re-applying.
    root.querySelectorAll(`${$9dca141bdfb65599$var$SCROLL_NO_SWIPE_SELECTOR}, [data-mobile-days-scroll]`).forEach((el)=>{
        el.classList.remove("swiper-no-swiping");
    });
    if (mobile) {
        // Mobile: only horizontal day strips block Swiper (native pan-x scroll).
        root.querySelectorAll("[data-mobile-days-scroll]").forEach((el)=>{
            el.classList.add("swiper-no-swiping");
        });
        return;
    }
    root.querySelectorAll($9dca141bdfb65599$var$SCROLL_NO_SWIPE_SELECTOR).forEach((el)=>{
        el.classList.add("swiper-no-swiping");
    });
}
function $9dca141bdfb65599$var$getMobileMenuEl(root) {
    return root.querySelector("[data-fullpage-mobile-menu]");
}
function $9dca141bdfb65599$var$isHeroSlideActive(swiper) {
    const slide = swiper.slides[swiper.activeIndex];
    return Boolean(slide?.classList.contains("fullpage-slide--hero"));
}
function $9dca141bdfb65599$var$usesMobileMenuLogo(swiper) {
    const slide = swiper.slides[swiper.activeIndex];
    return Boolean(slide?.classList.contains("fullpage-slide--hero"));
}
function $9dca141bdfb65599$var$usesMobileMenuCenteredPill(swiper) {
    const slide = swiper.slides[swiper.activeIndex];
    return Boolean(slide?.classList.contains("fullpage-slide--media") || slide?.classList.contains("fullpage-slide--footer"));
}
function $9dca141bdfb65599$var$getCachedMobileNavReserve(root) {
    const raw = root.dataset.mobileNavReserveClosed;
    const px = parseInt(raw || "", 10);
    return Number.isFinite(px) && px > 0 ? px : null;
}
function $9dca141bdfb65599$var$applyMobileNavReserve(root, px) {
    if (!Number.isFinite(px) || px <= 0) return;
    root.style.setProperty("--paaadel-mobile-nav-reserve", `${Math.ceil(px)}px`);
    root.dataset.mobileNavReserveClosed = String(Math.ceil(px));
}
function $9dca141bdfb65599$var$isMobileMenuPanelCollapsed(menu) {
    const panel = menu.querySelector("[data-fullpage-mobile-menu-panel]");
    if (!panel) return true;
    return panel.getBoundingClientRect().height <= 4;
}
function $9dca141bdfb65599$var$scheduleMobileNavReserveRemeasure(root) {
    const menu = $9dca141bdfb65599$var$getMobileMenuEl(root);
    const panel = menu?.querySelector("[data-fullpage-mobile-menu-panel]");
    if (!panel) {
        $9dca141bdfb65599$var$updateMobileNavReserve(root);
        return;
    }
    const onEnd = (event)=>{
        if (event.propertyName !== "max-height" && event.propertyName !== "padding") return;
        panel.removeEventListener("transitionend", onEnd);
        $9dca141bdfb65599$var$updateMobileNavReserve(root);
    };
    panel.addEventListener("transitionend", onEnd);
}
function $9dca141bdfb65599$var$setMobileMenuOpen(root, open) {
    const menu = $9dca141bdfb65599$var$getMobileMenuEl(root);
    if (!menu) return;
    const toggle = menu.querySelector("[data-fullpage-mobile-menu-toggle]");
    const panel = menu.querySelector("[data-fullpage-mobile-menu-panel]");
    menu.classList.toggle("is-open", open);
    if (toggle) {
        toggle.setAttribute("aria-expanded", open ? "true" : "false");
        toggle.setAttribute("aria-hidden", open ? "true" : "false");
        toggle.tabIndex = open ? -1 : 0;
    }
    if (panel) {
        panel.setAttribute("aria-hidden", open ? "false" : "true");
        panel.querySelectorAll("a, button").forEach((el)=>{
            el.tabIndex = open ? 0 : -1;
        });
    }
    if (!open) {
        const cached = $9dca141bdfb65599$var$getCachedMobileNavReserve(root);
        if (cached !== null) $9dca141bdfb65599$var$applyMobileNavReserve(root, cached);
        $9dca141bdfb65599$var$scheduleMobileNavReserveRemeasure(root);
    }
}
function $9dca141bdfb65599$var$closeMobileMenu(root) {
    $9dca141bdfb65599$var$setMobileMenuOpen(root, false);
}
function $9dca141bdfb65599$var$getActiveSlideSection(slide) {
    if (!slide) return "";
    if (slide.classList.contains("fullpage-slide--hero")) return "hero";
    const section = slide.getAttribute("data-fullpage-section");
    if (section) return section;
    return (0, $4d818be9d2a947c9$export$250201d51136ff97)(slide.id || "");
}
function $9dca141bdfb65599$var$getMobileBarLabels(root) {
    const menu = $9dca141bdfb65599$var$getMobileMenuEl(root);
    const raw = menu?.dataset.mobileBarLabels;
    if (!raw) return {};
    try {
        return JSON.parse(raw);
    } catch  {
        return {};
    }
}
function $9dca141bdfb65599$var$updateMobileMenuBar(root, swiper) {
    const menu = $9dca141bdfb65599$var$getMobileMenuEl(root);
    if (!menu) return;
    const centeredPill = $9dca141bdfb65599$var$usesMobileMenuCenteredPill(swiper);
    const showLogo = $9dca141bdfb65599$var$usesMobileMenuLogo(swiper) && !centeredPill;
    const sectionEl = menu.querySelector("[data-fullpage-mobile-section]");
    menu.classList.toggle("fullpage__mobile-menu--hero", showLogo);
    menu.classList.toggle("fullpage__mobile-menu--centered", centeredPill);
    if (!sectionEl) return;
    if (showLogo || centeredPill) {
        menu.classList.remove("fullpage__mobile-menu--has-section");
        sectionEl.textContent = "";
        sectionEl.setAttribute("aria-hidden", "true");
        return;
    }
    const section = $9dca141bdfb65599$var$getActiveSlideSection(swiper.slides[swiper.activeIndex]);
    const labels = $9dca141bdfb65599$var$getMobileBarLabels(root);
    const linkLabel = menu.querySelector(`.fullpage__mobile-menu-link[data-fullpage-tab="${section}"]`)?.textContent?.trim();
    const label = linkLabel || labels[section] || section;
    const hasSection = Boolean(label);
    menu.classList.toggle("fullpage__mobile-menu--has-section", hasSection);
    sectionEl.textContent = label;
    sectionEl.setAttribute("aria-hidden", hasSection ? "false" : "true");
}
function $9dca141bdfb65599$var$updateMobileNavReserve(root) {
    requestAnimationFrame(()=>{
        if (!$9dca141bdfb65599$var$isMobileLayout()) {
            root.style.removeProperty("--paaadel-mobile-nav-reserve");
            delete root.dataset.mobileNavReserveClosed;
            return;
        }
        const menu = $9dca141bdfb65599$var$getMobileMenuEl(root);
        if (!menu) {
            root.style.removeProperty("--paaadel-mobile-nav-reserve");
            delete root.dataset.mobileNavReserveClosed;
            return;
        }
        // Open panel overlays — keep the last closed-pill reserve.
        if (menu.classList.contains("is-open")) return;
        if (!$9dca141bdfb65599$var$isMobileMenuPanelCollapsed(menu)) {
            const cached = $9dca141bdfb65599$var$getCachedMobileNavReserve(root);
            if (cached !== null) $9dca141bdfb65599$var$applyMobileNavReserve(root, cached);
            return;
        }
        const bar = menu.querySelector(".fullpage__mobile-menu-bar");
        const shell = menu.querySelector(".fullpage__mobile-menu-shell");
        const measureEl = bar || shell;
        if (!measureEl) {
            root.style.removeProperty("--paaadel-mobile-nav-reserve");
            delete root.dataset.mobileNavReserveClosed;
            return;
        }
        $9dca141bdfb65599$var$applyMobileNavReserve(root, measureEl.getBoundingClientRect().bottom + $9dca141bdfb65599$var$MOBILE_NAV_GAP_PX);
    });
}
function $9dca141bdfb65599$var$bindMobileMenu(root, swiper, goToHash) {
    const menu = $9dca141bdfb65599$var$getMobileMenuEl(root);
    if (!menu) return;
    const toggle = menu.querySelector("[data-fullpage-mobile-menu-toggle]");
    const closeBtn = menu.querySelector("[data-fullpage-mobile-menu-close]");
    const panel = menu.querySelector("[data-fullpage-mobile-menu-panel]");
    panel?.querySelectorAll("a, button").forEach((el)=>{
        el.tabIndex = -1;
    });
    menu.querySelector(".fullpage__mobile-menu-shell")?.addEventListener("transitionend", (event)=>{
        if (event.propertyName === "max-width") $9dca141bdfb65599$var$updateMobileNavReserve(root);
    });
    toggle?.addEventListener("click", ()=>{
        $9dca141bdfb65599$var$setMobileMenuOpen(root, true);
    });
    closeBtn?.addEventListener("click", ()=>{
        $9dca141bdfb65599$var$closeMobileMenu(root);
    });
    menu.querySelectorAll(".fullpage__mobile-menu-link").forEach((link)=>{
        link.addEventListener("click", ()=>{
            $9dca141bdfb65599$var$closeMobileMenu(root);
        });
    });
    document.addEventListener("keydown", (event)=>{
        if (event.key !== "Escape" || !menu.classList.contains("is-open")) return;
        $9dca141bdfb65599$var$closeMobileMenu(root);
        toggle?.focus();
    });
}
function $9dca141bdfb65599$var$getNavStackTopPx() {
    const raw = getComputedStyle(document.documentElement).getPropertyValue("--paaadel-nav-stack-top").trim();
    const px = parseFloat(raw);
    if (Number.isFinite(px) && px >= 0) return Math.round(px);
    return $9dca141bdfb65599$var$getGridMarginPx() + $9dca141bdfb65599$var$getAdminBarOffsetPx();
}
function $9dca141bdfb65599$var$navTopPx(atTop, stackIndex, btnHeight) {
    const viewport = window.innerHeight;
    const step = btnHeight + $9dca141bdfb65599$var$NAV_GAP_PX;
    if (atTop) return $9dca141bdfb65599$var$getNavStackTopPx() + stackIndex * step;
    return viewport - $9dca141bdfb65599$var$getGridMarginPx() - btnHeight - stackIndex * step;
}
function $9dca141bdfb65599$var$getEventsCalendarScrollTargets(slide) {
    const calendar = slide?.querySelector("[data-events-calendar]");
    if (!calendar) return [];
    if ($9dca141bdfb65599$var$isMobileLayout()) return [];
    const targets = [
        calendar.querySelector(".fullpage-events-calendar__panels")
    ];
    const nav = calendar.querySelector(".fullpage-events-calendar__nav");
    if (nav && getComputedStyle(nav).display !== "none") targets.unshift(nav);
    return targets.filter(Boolean);
}
function $9dca141bdfb65599$var$getEventsCalendarScrollEl(slide, event) {
    const targets = $9dca141bdfb65599$var$getEventsCalendarScrollTargets(slide);
    if (targets.length === 0) return null;
    if (event && Number.isFinite(event.clientX) && Number.isFinite(event.clientY)) for (const el of targets){
        const rect = el.getBoundingClientRect();
        if (event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom && $9dca141bdfb65599$var$slideContentScrolls(el)) return el;
    }
    return targets.find((el)=>$9dca141bdfb65599$var$slideContentScrolls(el)) ?? null;
}
function $9dca141bdfb65599$var$getLocationsTextboxScrollEl(slide, event) {
    if (!slide?.classList.contains("fullpage-slide--locations")) return null;
    const textbox = slide.querySelector(".fullpage-slide__locations-textbox");
    if (!textbox || !$9dca141bdfb65599$var$slideContentScrolls(textbox)) return null;
    if (event && Number.isFinite(event.clientX) && Number.isFinite(event.clientY)) {
        const rect = textbox.getBoundingClientRect();
        if (event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom) return textbox;
        return null;
    }
    return textbox;
}
function $9dca141bdfb65599$var$getTextSlideScrollEl(slide) {
    if ($9dca141bdfb65599$var$isMobileLayout()) return slide?.querySelector(".fullpage-slide__inner") ?? null;
    const textBody = slide?.querySelector(".fullpage-slide__text-body");
    if (textBody) return textBody;
    return slide?.querySelector(".fullpage-slide__inner") ?? null;
}
function $9dca141bdfb65599$var$getSlideScrollEl(slide, event) {
    const eventsScroll = $9dca141bdfb65599$var$getEventsCalendarScrollEl(slide, event);
    if (eventsScroll) return eventsScroll;
    const locationsScroll = $9dca141bdfb65599$var$getLocationsTextboxScrollEl(slide, event);
    if (locationsScroll) return locationsScroll;
    const inner = slide?.querySelector(".fullpage-slide__inner");
    if (inner?.classList.contains("fullpage-slide__inner--locations")) return null;
    if (slide?.classList.contains("fullpage-slide--text") || slide?.classList.contains("fullpage-slide--about")) return $9dca141bdfb65599$var$getTextSlideScrollEl(slide);
    return inner ?? null;
}
function $9dca141bdfb65599$var$slideContentScrolls(scrollEl) {
    if (!scrollEl) return false;
    return scrollEl.scrollHeight > scrollEl.clientHeight + 1;
}
function $9dca141bdfb65599$var$shouldScrollSlideContent(scrollEl, deltaY) {
    if (!$9dca141bdfb65599$var$slideContentScrolls(scrollEl)) return false;
    const atTop = scrollEl.scrollTop <= 0;
    const atBottom = scrollEl.scrollTop + scrollEl.clientHeight >= scrollEl.scrollHeight - 1;
    if (deltaY > 0 && !atBottom) return true;
    if (deltaY < 0 && !atTop) return true;
    return false;
}
function $9dca141bdfb65599$var$bindSlideInnerWheelScroll(swiperEl, swiper) {
    swiperEl.addEventListener("wheel", (event)=>{
        const scrollEl = $9dca141bdfb65599$var$getSlideScrollEl(swiper.slides[swiper.activeIndex], event);
        if (!$9dca141bdfb65599$var$shouldScrollSlideContent(scrollEl, event.deltaY)) return;
        event.preventDefault();
        event.stopPropagation();
        scrollEl.scrollTop += event.deltaY;
    }, {
        passive: false,
        capture: true
    });
}
function $9dca141bdfb65599$var$getNavSectionSlide(root, section) {
    return root.querySelector(`[data-fullpage-section="${section}"]`) || root.querySelector(`#${section}`) || root.querySelector(`#section-${section}`);
}
/** Resolved page background for active nav label (matches slide). */ function $9dca141bdfb65599$var$getSlidePageBackgroundColor(slide) {
    if (!slide) return "";
    const { backgroundColor: backgroundColor } = getComputedStyle(slide);
    if (!backgroundColor || backgroundColor === "transparent" || backgroundColor === "rgba(0, 0, 0, 0)") return "";
    return backgroundColor;
}
function $9dca141bdfb65599$var$syncActiveNavButtonTextColor(btn, section, root, isActive) {
    if (!isActive) {
        btn.style.removeProperty("--paaadel-btn-color");
        return;
    }
    if (document.documentElement.classList.contains("is-high-contrast")) {
        btn.style.setProperty("--paaadel-btn-color", "#000000");
        return;
    }
    const pageBg = $9dca141bdfb65599$var$getSlidePageBackgroundColor($9dca141bdfb65599$var$getNavSectionSlide(root, section));
    if (pageBg) btn.style.setProperty("--paaadel-btn-color", pageBg);
    else btn.style.removeProperty("--paaadel-btn-color");
}
function $9dca141bdfb65599$var$getFooterBarHeightPx(root) {
    const bar = root.querySelector(".fullpage-slide--footer .fullpage-slide__footer-bar");
    if (!bar) return 0;
    return Math.round(bar.getBoundingClientRect().height);
}
function $9dca141bdfb65599$var$isFooterSlideActive(swiper) {
    const slide = swiper.slides[swiper.activeIndex];
    return Boolean(slide?.classList.contains("fullpage-slide--footer"));
}
function $9dca141bdfb65599$var$isLocationsSlideActive(swiper) {
    const slide = swiper.slides[swiper.activeIndex];
    return Boolean(slide?.classList.contains("fullpage-slide--locations"));
}
function $9dca141bdfb65599$var$isLocationsStackedLayout() {
    return window.matchMedia($9dca141bdfb65599$var$LOCATIONS_STACKED_MQ).matches;
}
// Stacked layout: lift Book Now to float a grid-margin above the green area
// (the textbox's top edge), like the footer floats above the footer bar. The
// green box overlaps up onto the photo, so its top — not the photo bottom — is
// the visible green edge. Measured relative to the slide top so the value stays
// correct while the slide is still translating during a swipe.
function $9dca141bdfb65599$var$getLocationsBookNowOffsetPx(root, swiper) {
    const slide = swiper.slides[swiper.activeIndex];
    const textbox = slide?.querySelector(".fullpage-slide__locations-textbox");
    if (!slide || !textbox) return null;
    const slideRect = slide.getBoundingClientRect();
    const boxRect = textbox.getBoundingClientRect();
    if (boxRect.height <= 0) return null;
    const margin = $9dca141bdfb65599$var$getGridMarginPx();
    const greenTopFromSlideTop = boxRect.top - slideRect.top;
    const offset = $9dca141bdfb65599$var$getViewportHeight() - greenTopFromSlideTop + margin;
    return Math.max(Math.round(offset), margin);
}
function $9dca141bdfb65599$var$activeSlideHasBgPhoto(swiper) {
    const slide = swiper.slides[swiper.activeIndex];
    return Boolean(slide?.classList.contains("has-slide-image"));
}
function $9dca141bdfb65599$var$activeSlideIsMediaSlide(swiper) {
    const slide = swiper.slides[swiper.activeIndex];
    return Boolean(slide?.classList.contains("fullpage-slide--media"));
}
function $9dca141bdfb65599$var$activeSlideUsesBlackBookNowText(swiper) {
    return $9dca141bdfb65599$var$activeSlideIsMediaSlide(swiper) || $9dca141bdfb65599$var$isFooterSlideActive(swiper);
}
function $9dca141bdfb65599$var$updateBgPhotoGlass(root, swiper) {
    root.classList.toggle("fullpage--bg-photo", $9dca141bdfb65599$var$activeSlideHasBgPhoto(swiper));
}
function $9dca141bdfb65599$var$updateBookNowButton(root, swiper) {
    const btn = root.querySelector("[data-fullpage-book-now]");
    if (!btn) return;
    const margin = $9dca141bdfb65599$var$getGridMarginPx();
    let offset = margin;
    if ($9dca141bdfb65599$var$isLocationsStackedLayout() && $9dca141bdfb65599$var$isLocationsSlideActive(swiper)) {
        const locationsOffset = $9dca141bdfb65599$var$getLocationsBookNowOffsetPx(root, swiper);
        offset = locationsOffset != null ? locationsOffset : margin;
    } else if ($9dca141bdfb65599$var$isFooterSlideActive(swiper)) offset = margin + $9dca141bdfb65599$var$getFooterBarHeightPx(root);
    btn.style.top = "auto";
    btn.style.setProperty("--paaadel-book-now-offset", `${offset}px`);
    if (document.documentElement.classList.contains("is-high-contrast")) {
        btn.style.setProperty("--paaadel-btn-color", "#000000");
        btn.style.setProperty("--paaadel-btn-color-hover", "#000000");
        btn.style.setProperty("--paaadel-btn-focus-color", "#000000");
        return;
    }
    if ($9dca141bdfb65599$var$activeSlideUsesBlackBookNowText(swiper)) {
        btn.style.setProperty("--paaadel-btn-color", "#000000");
        btn.style.setProperty("--paaadel-btn-color-hover", "#000000");
        btn.style.setProperty("--paaadel-btn-focus-color", "#000000");
        return;
    }
    const pageBg = $9dca141bdfb65599$var$getSlidePageBackgroundColor(swiper.slides[swiper.activeIndex]);
    if (pageBg) {
        btn.style.setProperty("--paaadel-btn-color", pageBg);
        btn.style.setProperty("--paaadel-btn-color-hover", pageBg);
        btn.style.setProperty("--paaadel-btn-focus-color", pageBg);
    } else {
        btn.style.removeProperty("--paaadel-btn-color");
        btn.style.removeProperty("--paaadel-btn-color-hover");
        btn.style.removeProperty("--paaadel-btn-focus-color");
    }
}
function $9dca141bdfb65599$var$updateSideNav(root, swiper) {
    const activeIndex = swiper.activeIndex;
    const mobile = $9dca141bdfb65599$var$isMobileLayout();
    const navSections = $9dca141bdfb65599$var$getNavSections(root);
    const bottomOrder = [
        ...navSections
    ].reverse();
    let topSlot = 0;
    navSections.forEach((section)=>{
        const btn = root.querySelector(`.fullpage__side-nav [data-fullpage-tab="${section}"]`);
        if (!btn) return;
        const slideIndex = $9dca141bdfb65599$var$slideIndexForSection(root, swiper, section);
        const isActive = slideIndex === activeIndex;
        if (mobile) {
            btn.dataset.navPosition = "top";
            btn.style.removeProperty("top");
            btn.style.removeProperty("bottom");
        } else {
            const atTop = slideIndex >= 0 && activeIndex >= slideIndex;
            const btnHeight = btn.offsetHeight || 36;
            if (atTop) {
                btn.dataset.navPosition = "top";
                btn.style.top = `${$9dca141bdfb65599$var$navTopPx(true, topSlot, btnHeight)}px`;
                topSlot += 1;
            } else {
                btn.dataset.navPosition = "bottom";
                const bottomSlot = bottomOrder.indexOf(section);
                btn.style.top = `${$9dca141bdfb65599$var$navTopPx(false, bottomSlot, btnHeight)}px`;
            }
            btn.style.bottom = "auto";
        }
        btn.classList.toggle("is-active", isActive);
        btn.setAttribute("aria-current", isActive ? "true" : "false");
        $9dca141bdfb65599$var$syncActiveNavButtonTextColor(btn, section, root, isActive);
    });
    root.querySelectorAll(".fullpage__mobile-menu-link").forEach((link)=>{
        const section = link.getAttribute("data-fullpage-tab");
        if (!section) return;
        const slideIndex = $9dca141bdfb65599$var$slideIndexForSection(root, swiper, section);
        const isActive = slideIndex === activeIndex;
        link.classList.toggle("is-active", isActive);
        link.setAttribute("aria-current", isActive ? "true" : "false");
    });
    $9dca141bdfb65599$var$updateMobileMenuBar(root, swiper);
    $9dca141bdfb65599$var$updateMobileNavReserve(root);
    $9dca141bdfb65599$var$updateBookNowButton(root, swiper);
    $9dca141bdfb65599$var$updateBgPhotoGlass(root, swiper);
}
function $9dca141bdfb65599$var$setPageUrl(hash, { push: push = false } = {}) {
    const base = `${window.location.pathname}${window.location.search}`;
    const nextUrl = hash ? `${base}${hash}` : base;
    const currentUrl = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    if (currentUrl === nextUrl) return;
    const state = {
        fullpage: hash || null
    };
    if (push) history.pushState(state, "", nextUrl);
    else history.replaceState(state, "", nextUrl);
}
function $9dca141bdfb65599$export$f3669b2164ce2daf() {
    const root = document.querySelector("[data-fullpage]");
    if (!root) return;
    const swiperEl = root.querySelector(".fullpage__swiper");
    if (!swiperEl) return;
    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const motionSpeed = prefersReducedMotion ? 0 : 700;
    const navMoveDuration = prefersReducedMotion ? "0ms" : `${motionSpeed}ms`;
    root.style.setProperty("--paaadel-nav-move-duration", navMoveDuration);
    let syncingFromHash = false;
    const initialHash = window.location.hash;
    const initialParsed = (0, $4d818be9d2a947c9$export$1e599d6a6868163a)(initialHash);
    const initialIndex = $9dca141bdfb65599$var$initialSlideIndex(swiperEl, initialHash);
    const viewportHeight = $9dca141bdfb65599$var$getViewportHeight();
    $9dca141bdfb65599$var$applySlideHeights(swiperEl, viewportHeight);
    let swiper;
    (0, $f018449bb0787dea$export$bbecfdef02dcc54d)(()=>swiper, ()=>{
        const slide = swiper?.slides?.[swiper.activeIndex];
        return slide?.querySelector(".fullpage-slide__inner") ?? null;
    });
    const desktopWheel = $9dca141bdfb65599$var$prefersFinePointer();
    swiper = new (0, $6946bfb4689eabba$export$25ce5a424b770e84)(swiperEl, {
        modules: [
            (0, $343d866400a2e3c2$export$2e2bcd8739ae039),
            (0, $4b9f6507912f3e92$export$2e2bcd8739ae039),
            (0, $398e6017151607ad$export$2e2bcd8739ae039),
            (0, $f036f37c54b3aa6f$export$2e2bcd8739ae039)
        ],
        direction: "vertical",
        slidesPerView: 1,
        spaceBetween: 0,
        height: viewportHeight,
        roundLengths: false,
        nested: true,
        noSwipingClass: "swiper-no-swiping",
        touchStartPreventDefault: false,
        touchStartForcePreventDefault: false,
        resizeObserver: true,
        observer: true,
        observeParents: true,
        initialSlide: initialIndex,
        speed: motionSpeed,
        mousewheel: {
            forceToWheel: false,
            releaseOnEdges: true,
            sensitivity: desktopWheel ? 1.4 : 1.15,
            thresholdDelta: desktopWheel ? 7 : 14,
            thresholdTime: desktopWheel ? 160 : 280
        },
        pagination: {
            el: root.querySelector(".swiper-pagination"),
            clickable: true
        },
        keyboard: {
            enabled: true,
            onlyInViewport: true
        },
        a11y: {
            enabled: true
        }
    });
    $9dca141bdfb65599$var$bindSlideInnerWheelScroll(swiperEl, swiper);
    (0, $876e203e931a550d$export$df1f69cd1ac336bd)(swiper);
    $9dca141bdfb65599$var$syncSlideInnerSwiping(root);
    $9dca141bdfb65599$var$snapSwiperToIndex(swiper, initialIndex, 0);
    requestAnimationFrame(()=>$9dca141bdfb65599$var$snapSwiperToIndex(swiper, swiper.activeIndex, 0));
    const goToHash = (hash, { push: push = false } = {})=>{
        const index = $9dca141bdfb65599$var$indexForHash(swiper, hash);
        if (index < 0) return;
        syncingFromHash = true;
        $9dca141bdfb65599$var$snapSwiperToIndex(swiper, index, motionSpeed);
        $9dca141bdfb65599$var$setPageUrl($9dca141bdfb65599$var$hashForSlide(swiper.slides[index]), {
            push: push
        });
        syncingFromHash = false;
        $9dca141bdfb65599$var$updateSideNav(root, swiper);
    };
    const syncUrlFromActiveSlide = ({ push: push = false } = {})=>{
        if (syncingFromHash) return;
        const slide = swiper.slides[swiper.activeIndex];
        $9dca141bdfb65599$var$setPageUrl($9dca141bdfb65599$var$hashForSlide(slide), {
            push: push
        });
    };
    const onSlideChange = ()=>{
        const slide = swiper.slides[swiper.activeIndex];
        const section = (0, $4d818be9d2a947c9$export$250201d51136ff97)(slide?.getAttribute("data-fullpage-section") || slide?.id || "");
        slide?.querySelector(".fullpage-slide__inner")?.scrollTo?.(0, 0);
        // Events + locations slide URLs are managed by their inner widgets.
        if (section !== (0, $4d818be9d2a947c9$export$d2bceb3c11396000) && section !== (0, $4d818be9d2a947c9$export$ccf5cae033ed6aca)) syncUrlFromActiveSlide();
        $9dca141bdfb65599$var$updateSideNav(root, swiper);
    };
    if (!initialParsed.eventDate && !initialParsed.locationId) syncUrlFromActiveSlide();
    $9dca141bdfb65599$var$updateSideNav(root, swiper);
    swiper.on("slideChange", onSlideChange);
    swiper.on("slideChangeTransitionStart", ()=>{
        const slide = swiper.slides[swiper.activeIndex];
        const previousSlide = swiper.slides[swiper.previousIndex];
        const section = (0, $4d818be9d2a947c9$export$250201d51136ff97)(slide?.getAttribute("data-fullpage-section") || slide?.id || "");
        const previousSection = (0, $4d818be9d2a947c9$export$250201d51136ff97)(previousSlide?.getAttribute("data-fullpage-section") || previousSlide?.id || "");
        document.dispatchEvent(new CustomEvent("paaadel:fullpage-slide-change", {
            detail: {
                section: section,
                previousSection: previousSection
            }
        }));
    });
    swiper.on("slideChangeTransitionEnd", ()=>{
        $9dca141bdfb65599$var$snapSwiperToIndex(swiper, swiper.activeIndex, 0);
    });
    const onViewportChange = ()=>{
        $9dca141bdfb65599$var$syncFullpageViewport(root, swiperEl, swiper);
        $9dca141bdfb65599$var$syncSlideInnerSwiping(root);
        $9dca141bdfb65599$var$updateSideNav(root, swiper);
    };
    window.addEventListener("resize", onViewportChange);
    window.visualViewport?.addEventListener("resize", onViewportChange);
    swiper.on("resize", ()=>$9dca141bdfb65599$var$syncFullpageViewport(root, swiperEl, swiper));
    window.addEventListener("hashchange", ()=>{
        if (syncingFromHash) return;
        goToHash(window.location.hash);
    });
    window.addEventListener("popstate", ()=>{
        goToHash(window.location.hash);
    });
    root.querySelectorAll("[data-fullpage-tab]").forEach((tab)=>{
        tab.addEventListener("click", (event)=>{
            event.preventDefault();
            const href = tab.getAttribute("href");
            if (href && href.startsWith("#")) {
                goToHash(href, {
                    push: true
                });
                return;
            }
            const section = tab.getAttribute("data-fullpage-tab");
            const index = $9dca141bdfb65599$var$slideIndexForSection(root, swiper, section);
            if (index >= 0) {
                const slide = swiper.slides[index];
                syncingFromHash = true;
                $9dca141bdfb65599$var$snapSwiperToIndex(swiper, index, motionSpeed);
                $9dca141bdfb65599$var$setPageUrl($9dca141bdfb65599$var$hashForSlide(slide), {
                    push: true
                });
                syncingFromHash = false;
                $9dca141bdfb65599$var$updateSideNav(root, swiper);
            }
        });
    });
    $9dca141bdfb65599$var$bindMobileMenu(root, swiper, goToHash);
}



function $36ca57d25bbd719c$var$prefersReducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}
function $36ca57d25bbd719c$var$getEventMoveDurationMs(root) {
    const raw = getComputedStyle(root).getPropertyValue("--paaadel-nav-move-duration").trim();
    if (!raw || raw === "0ms") return 0;
    if (raw.endsWith("ms")) return Number.parseFloat(raw) || 650;
    if (raw.endsWith("s")) return (Number.parseFloat(raw) || 0.65) * 1000;
    return 650;
}
function $36ca57d25bbd719c$var$updateDayButtons(root, eventDate) {
    const date = String(eventDate);
    root.querySelectorAll(".fullpage-events-calendar__day-btn, .fullpage-events-calendar__mobile-day-btn").forEach((btn)=>{
        const active = btn.dataset.eventDate === date;
        btn.classList.toggle("is-selected", active);
        btn.setAttribute("aria-pressed", active ? "true" : "false");
    });
}
function $36ca57d25bbd719c$var$syncMobileNavMonth(root, monthKey) {
    const month = String(monthKey);
    root.querySelectorAll(".fullpage-events-calendar__mobile-days-viewport").forEach((viewport)=>{
        const active = viewport.dataset.month === month;
        viewport.hidden = !active;
    });
    root.querySelectorAll(".fullpage-events-calendar__mobile-days").forEach((days)=>{
        const active = days.dataset.month === month;
        days.classList.toggle("is-active", active);
    });
    $36ca57d25bbd719c$var$updateMobileMonthLabel(root, month);
    $36ca57d25bbd719c$var$updateMobileMonthSteps(root);
    const selected = root.querySelector(".fullpage-events-calendar__mobile-day-btn.is-selected");
    if (selected?.dataset.eventDate) $36ca57d25bbd719c$var$scrollMobileDayIntoView(root, selected.dataset.eventDate);
}
function $36ca57d25bbd719c$var$getMobileMonthsWithEvents(root) {
    return [
        ...root.querySelectorAll(".fullpage-events-calendar__mobile-days-viewport")
    ].filter((viewport)=>viewport.querySelector(".fullpage-events-calendar__mobile-day-btn")).map((viewport)=>viewport.dataset.month).filter(Boolean);
}
function $36ca57d25bbd719c$var$getCurrentMobileMonth(root) {
    const selected = root.querySelector(".fullpage-events-calendar__mobile-day-btn.is-selected");
    if (selected?.dataset.month) return String(selected.dataset.month);
    const activeViewport = root.querySelector(".fullpage-events-calendar__mobile-days-viewport:not([hidden])");
    return activeViewport?.dataset.month ? String(activeViewport.dataset.month) : "";
}
function $36ca57d25bbd719c$var$formatMonthLabel(monthKey) {
    const parts = String(monthKey).split("-");
    if (parts.length !== 2) return monthKey;
    const [year, month] = parts.map(Number);
    const lang = document.documentElement.lang || "de-DE";
    return new Intl.DateTimeFormat(lang, {
        month: "long",
        year: "numeric"
    }).format(new Date(year, month - 1, 1));
}
function $36ca57d25bbd719c$var$updateMobileMonthLabel(root, monthKey) {
    const label = root.querySelector("[data-mobile-month-label]");
    if (!label || !monthKey) return;
    label.textContent = $36ca57d25bbd719c$var$formatMonthLabel(monthKey);
}
function $36ca57d25bbd719c$var$updateMobileMonthSteps(root) {
    const months = $36ca57d25bbd719c$var$getMobileMonthsWithEvents(root);
    const current = $36ca57d25bbd719c$var$getCurrentMobileMonth(root);
    const index = months.indexOf(current);
    root.querySelectorAll(".fullpage-events-calendar__mobile-month-step").forEach((btn)=>{
        const isPrev = btn.dataset.direction === "prev";
        const disabled = isPrev ? index <= 0 : index < 0 || index >= months.length - 1;
        btn.disabled = disabled;
        btn.setAttribute("aria-disabled", disabled ? "true" : "false");
    });
}
function $36ca57d25bbd719c$var$scrollStripItemIntoView(strip, item) {
    if (!strip || !item) return;
    const maxScroll = strip.scrollWidth - strip.clientWidth;
    if (maxScroll <= 0) return;
    const stripRect = strip.getBoundingClientRect();
    const itemRect = item.getBoundingClientRect();
    const delta = itemRect.left - stripRect.left - (stripRect.width - itemRect.width) / 2;
    strip.scrollTo({
        left: Math.max(0, Math.min(maxScroll, strip.scrollLeft + delta)),
        behavior: $36ca57d25bbd719c$var$prefersReducedMotion() ? "auto" : "smooth"
    });
}
function $36ca57d25bbd719c$var$scrollMobileDayIntoView(root, eventDate) {
    const btn = root.querySelector(`.fullpage-events-calendar__mobile-day-btn[data-event-date="${eventDate}"]`);
    const strip = btn?.closest("[data-mobile-days-scroll]");
    if (!btn || !strip) return;
    $36ca57d25bbd719c$var$scrollStripItemIntoView(strip, btn.closest(".fullpage-events-calendar__mobile-day-item") || btn);
}
function $36ca57d25bbd719c$var$activateMobileMonth(root, timeline, monthKey, { pushUrl: pushUrl = false } = {}) {
    const month = String(monthKey);
    if (!month) return;
    $36ca57d25bbd719c$var$expandMonth(root, month, {
        animate: false
    });
    const days = root.querySelector(`.fullpage-events-calendar__mobile-days[data-month="${month}"]`);
    const selected = days?.querySelector(".fullpage-events-calendar__mobile-day-btn.is-selected");
    const target = selected || days?.querySelector(".fullpage-events-calendar__mobile-day-btn");
    if (!target?.dataset.eventDate) {
        $36ca57d25bbd719c$var$updateMobileMonthSteps(root);
        return;
    }
    const direction = $36ca57d25bbd719c$var$getTransitionDirection(root, timeline, target.dataset.eventDate);
    $36ca57d25bbd719c$var$selectEvent(root, target.dataset.eventDate, direction);
    $36ca57d25bbd719c$var$updateTimelineSteps(root, timeline, $36ca57d25bbd719c$var$getSelectedTimelineIndex(root, timeline));
    $36ca57d25bbd719c$var$syncEventUrl(target.dataset.eventDate, {
        push: pushUrl
    });
    $36ca57d25bbd719c$var$updateMobileMonthSteps(root);
}
function $36ca57d25bbd719c$var$stepMobileMonth(root, timeline, direction) {
    const months = $36ca57d25bbd719c$var$getMobileMonthsWithEvents(root);
    const current = $36ca57d25bbd719c$var$getCurrentMobileMonth(root);
    const index = months.indexOf(current);
    const delta = direction === "prev" ? -1 : 1;
    const nextIndex = index + delta;
    if (nextIndex < 0 || nextIndex >= months.length) return;
    $36ca57d25bbd719c$var$activateMobileMonth(root, timeline, months[nextIndex], {
        pushUrl: true
    });
}
function $36ca57d25bbd719c$var$getTransitionDirection(root, timeline, nextEventDate) {
    const currentIndex = $36ca57d25bbd719c$var$getSelectedTimelineIndex(root, timeline);
    const nextIndex = timeline.indexOf(String(nextEventDate));
    if (currentIndex < 0 || nextIndex < 0 || currentIndex === nextIndex) return "none";
    return nextIndex > currentIndex ? "next" : "prev";
}
const $36ca57d25bbd719c$var$LEAVE_CLASSES = [
    "is-event-leaving--next",
    "is-event-leaving--prev"
];
const $36ca57d25bbd719c$var$ENTER_CLASSES = [
    "is-event-entering--next",
    "is-event-entering--prev"
];
const $36ca57d25bbd719c$var$eventTransitionTimers = new WeakMap();
const $36ca57d25bbd719c$var$stageHeightUnlockers = new WeakMap();
function $36ca57d25bbd719c$var$resetPanelsScroll(panelsRoot) {
    if (!panelsRoot) return;
    const active = panelsRoot.querySelector(".fullpage-events-calendar__panel.is-event-active");
    if (active) {
        active.scrollTop = 0;
        return;
    }
    panelsRoot.scrollTop = 0;
}
function $36ca57d25bbd719c$var$lockPanelsStageHeight(stage, ...panels) {
    if (!stage) return ()=>{};
    const heights = panels.filter(Boolean).map((panel)=>panel.offsetHeight);
    heights.push(stage.offsetHeight);
    const height = Math.max(...heights, 0);
    if (height <= 0) return ()=>{};
    stage.style.minHeight = `${height}px`;
    return ()=>{
        stage.style.minHeight = "";
    };
}
function $36ca57d25bbd719c$var$clearPanelMotionClasses(panel) {
    panel.classList.remove(...$36ca57d25bbd719c$var$LEAVE_CLASSES, ...$36ca57d25bbd719c$var$ENTER_CLASSES);
}
function $36ca57d25bbd719c$var$applyInstantEvent(root, eventDate) {
    const stage = root.querySelector(".fullpage-events-calendar__panels-stage");
    if (!stage) return;
    const date = String(eventDate);
    stage.querySelectorAll(".fullpage-events-calendar__panel").forEach((panel)=>{
        const active = panel.dataset.eventDate === date;
        $36ca57d25bbd719c$var$clearPanelMotionClasses(panel);
        panel.classList.toggle("is-event-active", active);
        panel.hidden = !active;
    });
    $36ca57d25bbd719c$var$updateDayButtons(root, date);
    $36ca57d25bbd719c$var$scrollMobileDayIntoView(root, date);
    $36ca57d25bbd719c$var$resetPanelsScroll(root.querySelector(".fullpage-events-calendar__panels"));
}
function $36ca57d25bbd719c$var$cancelEventTransition(panelsRoot, stage) {
    const timer = $36ca57d25bbd719c$var$eventTransitionTimers.get(panelsRoot);
    if (timer) {
        window.clearTimeout(timer);
        $36ca57d25bbd719c$var$eventTransitionTimers.delete(panelsRoot);
    }
    panelsRoot.classList.remove("is-event-transitioning");
    delete panelsRoot.dataset.eventTransitioning;
    const unlockHeight = $36ca57d25bbd719c$var$stageHeightUnlockers.get(panelsRoot);
    if (unlockHeight) {
        unlockHeight();
        $36ca57d25bbd719c$var$stageHeightUnlockers.delete(panelsRoot);
    }
    stage?.querySelectorAll(".fullpage-events-calendar__panel").forEach((panel)=>{
        $36ca57d25bbd719c$var$clearPanelMotionClasses(panel);
    });
}
function $36ca57d25bbd719c$var$selectEvent(root, eventDate, direction = "none") {
    const date = String(eventDate);
    const stage = root.querySelector(".fullpage-events-calendar__panels-stage");
    const panelsRoot = root.querySelector(".fullpage-events-calendar__panels");
    if (panelsRoot?.dataset.eventTransitioning === "true") {
        $36ca57d25bbd719c$var$cancelEventTransition(panelsRoot, stage);
        $36ca57d25bbd719c$var$applyInstantEvent(root, date);
        return;
    }
    const current = stage?.querySelector(".fullpage-events-calendar__panel.is-event-active");
    const next = stage?.querySelector(`.fullpage-events-calendar__panel[data-event-date="${date}"]`);
    if (!stage || !next || current === next) {
        $36ca57d25bbd719c$var$applyInstantEvent(root, date);
        return;
    }
    const duration = $36ca57d25bbd719c$var$getEventMoveDurationMs(root);
    if ($36ca57d25bbd719c$var$prefersReducedMotion() || duration <= 0 || direction === "none") {
        $36ca57d25bbd719c$var$applyInstantEvent(root, date);
        return;
    }
    const leaveClass = direction === "next" ? "is-event-leaving--next" : "is-event-leaving--prev";
    const enterClass = direction === "next" ? "is-event-entering--next" : "is-event-entering--prev";
    $36ca57d25bbd719c$var$updateDayButtons(root, date);
    $36ca57d25bbd719c$var$scrollMobileDayIntoView(root, date);
    panelsRoot.dataset.eventTransitioning = "true";
    panelsRoot.classList.add("is-event-transitioning");
    const unlockHeight = $36ca57d25bbd719c$var$lockPanelsStageHeight(stage, current, next);
    $36ca57d25bbd719c$var$stageHeightUnlockers.set(panelsRoot, unlockHeight);
    $36ca57d25bbd719c$var$clearPanelMotionClasses(next);
    $36ca57d25bbd719c$var$clearPanelMotionClasses(current);
    next.hidden = false;
    next.classList.add(enterClass);
    requestAnimationFrame(()=>{
        current.classList.add(leaveClass);
        next.classList.add("is-event-active");
        next.classList.remove(enterClass);
        current.classList.remove("is-event-active");
    });
    const finish = ()=>{
        $36ca57d25bbd719c$var$eventTransitionTimers.delete(panelsRoot);
        $36ca57d25bbd719c$var$clearPanelMotionClasses(current);
        current.hidden = true;
        panelsRoot.classList.remove("is-event-transitioning");
        delete panelsRoot.dataset.eventTransitioning;
        const releaseHeight = $36ca57d25bbd719c$var$stageHeightUnlockers.get(panelsRoot);
        if (releaseHeight) {
            releaseHeight();
            $36ca57d25bbd719c$var$stageHeightUnlockers.delete(panelsRoot);
        }
        $36ca57d25bbd719c$var$resetPanelsScroll(panelsRoot);
    };
    $36ca57d25bbd719c$var$eventTransitionTimers.set(panelsRoot, window.setTimeout(finish, duration + 50));
}
const $36ca57d25bbd719c$var$monthDaysTimers = new WeakMap();
const $36ca57d25bbd719c$var$yearMonthsTimers = new WeakMap();
function $36ca57d25bbd719c$var$getYearForMonth(monthKey) {
    return String(monthKey).slice(0, 4);
}
function $36ca57d25bbd719c$var$setYearExpandedState(block, expanded) {
    const btn = block.querySelector(".fullpage-events-calendar__year-btn");
    const months = block.querySelector(".fullpage-events-calendar__year-months");
    block.classList.toggle("is-expanded", expanded);
    if (btn) btn.setAttribute("aria-expanded", expanded ? "true" : "false");
    if (months) months.setAttribute("aria-hidden", expanded ? "false" : "true");
}
function $36ca57d25bbd719c$var$clearYearMonthsInlineStyles(months) {
    months.style.removeProperty("max-height");
    months.style.removeProperty("overflow");
}
function $36ca57d25bbd719c$var$animateYearMonths(block, expand, root) {
    const months = block.querySelector(".fullpage-events-calendar__year-months");
    const btn = block.querySelector(".fullpage-events-calendar__year-btn");
    if (!months || !btn) return;
    const pending = $36ca57d25bbd719c$var$yearMonthsTimers.get(months);
    if (pending) {
        window.clearTimeout(pending);
        $36ca57d25bbd719c$var$yearMonthsTimers.delete(months);
    }
    const duration = $36ca57d25bbd719c$var$getEventMoveDurationMs(root);
    if ($36ca57d25bbd719c$var$prefersReducedMotion() || duration <= 0) {
        $36ca57d25bbd719c$var$clearYearMonthsInlineStyles(months);
        $36ca57d25bbd719c$var$setYearExpandedState(block, expand);
        return;
    }
    months.style.overflow = "hidden";
    if (expand) {
        $36ca57d25bbd719c$var$setYearExpandedState(block, true);
        months.style.maxHeight = "0";
        months.offsetHeight;
        months.style.maxHeight = `${months.scrollHeight}px`;
        $36ca57d25bbd719c$var$yearMonthsTimers.set(months, window.setTimeout(()=>{
            if (block.classList.contains("is-expanded")) $36ca57d25bbd719c$var$clearYearMonthsInlineStyles(months);
            $36ca57d25bbd719c$var$yearMonthsTimers.delete(months);
        }, duration + 50));
        return;
    }
    months.style.maxHeight = `${months.scrollHeight}px`;
    months.offsetHeight;
    $36ca57d25bbd719c$var$setYearExpandedState(block, false);
    months.style.maxHeight = "0";
    $36ca57d25bbd719c$var$yearMonthsTimers.set(months, window.setTimeout(()=>{
        $36ca57d25bbd719c$var$clearYearMonthsInlineStyles(months);
        $36ca57d25bbd719c$var$yearMonthsTimers.delete(months);
    }, duration + 50));
}
function $36ca57d25bbd719c$var$expandYear(root, year, { animate: animate = true } = {}) {
    const yearKey = String(year);
    root.querySelectorAll(".fullpage-events-calendar__year-block").forEach((block)=>{
        const btn = block.querySelector(".fullpage-events-calendar__year-btn");
        const isTarget = btn?.dataset.year === yearKey;
        const isExpanded = block.classList.contains("is-expanded");
        if (!animate) {
            const months = block.querySelector(".fullpage-events-calendar__year-months");
            if (months) $36ca57d25bbd719c$var$clearYearMonthsInlineStyles(months);
            $36ca57d25bbd719c$var$setYearExpandedState(block, isTarget);
            return;
        }
        if (isTarget && !isExpanded) $36ca57d25bbd719c$var$animateYearMonths(block, true, root);
        else if (!isTarget && isExpanded) $36ca57d25bbd719c$var$animateYearMonths(block, false, root);
    });
}
function $36ca57d25bbd719c$var$toggleYear(root, year, { animate: animate = true } = {}) {
    const yearKey = String(year);
    const block = root.querySelector(`.fullpage-events-calendar__year-btn[data-year="${yearKey}"]`)?.closest(".fullpage-events-calendar__year-block");
    if (!block) return;
    if (block.classList.contains("is-expanded")) {
        $36ca57d25bbd719c$var$animateYearMonths(block, false, root);
        return;
    }
    $36ca57d25bbd719c$var$expandYear(root, yearKey, {
        animate: animate
    });
}
function $36ca57d25bbd719c$var$setMonthExpandedState(block, expanded) {
    const btn = block.querySelector(".fullpage-events-calendar__month-btn");
    const days = block.querySelector(".fullpage-events-calendar__days");
    block.classList.toggle("is-expanded", expanded);
    if (btn) btn.setAttribute("aria-expanded", expanded ? "true" : "false");
    if (days) days.setAttribute("aria-hidden", expanded ? "false" : "true");
}
function $36ca57d25bbd719c$var$clearMonthDaysInlineStyles(days) {
    days.style.removeProperty("max-height");
    days.style.removeProperty("overflow");
}
function $36ca57d25bbd719c$var$animateMonthDays(block, expand, root) {
    const days = block.querySelector(".fullpage-events-calendar__days");
    const btn = block.querySelector(".fullpage-events-calendar__month-btn");
    if (!days || !btn || btn.getAttribute("aria-disabled") === "true") return;
    const pending = $36ca57d25bbd719c$var$monthDaysTimers.get(days);
    if (pending) {
        window.clearTimeout(pending);
        $36ca57d25bbd719c$var$monthDaysTimers.delete(days);
    }
    const duration = $36ca57d25bbd719c$var$getEventMoveDurationMs(root);
    if ($36ca57d25bbd719c$var$prefersReducedMotion() || duration <= 0) {
        $36ca57d25bbd719c$var$clearMonthDaysInlineStyles(days);
        $36ca57d25bbd719c$var$setMonthExpandedState(block, expand);
        return;
    }
    days.style.overflow = "hidden";
    if (expand) {
        $36ca57d25bbd719c$var$setMonthExpandedState(block, true);
        days.style.maxHeight = "0";
        // Force reflow so the browser picks up the collapsed height.
        days.offsetHeight;
        days.style.maxHeight = `${days.scrollHeight}px`;
        $36ca57d25bbd719c$var$monthDaysTimers.set(days, window.setTimeout(()=>{
            if (block.classList.contains("is-expanded")) $36ca57d25bbd719c$var$clearMonthDaysInlineStyles(days);
            $36ca57d25bbd719c$var$monthDaysTimers.delete(days);
        }, duration + 50));
        return;
    }
    days.style.maxHeight = `${days.scrollHeight}px`;
    days.offsetHeight;
    $36ca57d25bbd719c$var$setMonthExpandedState(block, false);
    days.style.maxHeight = "0";
    $36ca57d25bbd719c$var$monthDaysTimers.set(days, window.setTimeout(()=>{
        $36ca57d25bbd719c$var$clearMonthDaysInlineStyles(days);
        $36ca57d25bbd719c$var$monthDaysTimers.delete(days);
    }, duration + 50));
}
function $36ca57d25bbd719c$var$expandMonth(root, month, { animate: animate = true } = {}) {
    const monthKey = String(month);
    $36ca57d25bbd719c$var$expandYear(root, $36ca57d25bbd719c$var$getYearForMonth(monthKey), {
        animate: animate
    });
    $36ca57d25bbd719c$var$syncMobileNavMonth(root, monthKey);
    root.querySelectorAll(".fullpage-events-calendar__month-block").forEach((block)=>{
        const btn = block.querySelector(".fullpage-events-calendar__month-btn");
        const isTarget = btn?.dataset.month === monthKey && btn.getAttribute("aria-disabled") !== "true";
        const isExpanded = block.classList.contains("is-expanded");
        if (!animate) {
            const days = block.querySelector(".fullpage-events-calendar__days");
            if (days) $36ca57d25bbd719c$var$clearMonthDaysInlineStyles(days);
            $36ca57d25bbd719c$var$setMonthExpandedState(block, isTarget);
            return;
        }
        if (isTarget && !isExpanded) $36ca57d25bbd719c$var$animateMonthDays(block, true, root);
        else if (!isTarget && isExpanded) $36ca57d25bbd719c$var$animateMonthDays(block, false, root);
    });
}
function $36ca57d25bbd719c$var$getTimeline(root) {
    const idsAttr = root.dataset.timelineIds;
    if (idsAttr) return idsAttr.split(",").filter(Boolean);
    return [
        ...root.querySelectorAll(".fullpage-events-calendar__day-btn")
    ].map((btn)=>btn.dataset.eventDate).filter(Boolean);
}
function $36ca57d25bbd719c$var$getSelectedTimelineIndex(root, timeline) {
    const selected = root.querySelector(".fullpage-events-calendar__day-btn.is-selected, .fullpage-events-calendar__mobile-day-btn.is-selected");
    if (!selected?.dataset.eventDate) return -1;
    return timeline.indexOf(String(selected.dataset.eventDate));
}
function $36ca57d25bbd719c$var$updateTimelineSteps(root, timeline, index) {
    const atStart = index <= 0;
    const atEnd = index < 0 || index >= timeline.length - 1;
    root.querySelectorAll(".fullpage-events-calendar__timeline-step").forEach((btn)=>{
        const isPrev = btn.dataset.direction === "prev";
        const disabled = isPrev ? atStart : atEnd;
        btn.disabled = disabled;
        btn.setAttribute("aria-disabled", disabled ? "true" : "false");
    });
}
function $36ca57d25bbd719c$var$activateTimelineIndex(root, timeline, index, direction, { pushUrl: pushUrl = false } = {}) {
    if (index < 0 || index >= timeline.length) return;
    const eventDate = timeline[index];
    const dayBtn = root.querySelector(`.fullpage-events-calendar__day-btn[data-event-date="${eventDate}"], .fullpage-events-calendar__mobile-day-btn[data-event-date="${eventDate}"]`);
    if (!dayBtn) return;
    if (dayBtn.dataset.month) $36ca57d25bbd719c$var$expandMonth(root, dayBtn.dataset.month);
    $36ca57d25bbd719c$var$selectEvent(root, eventDate, direction);
    $36ca57d25bbd719c$var$updateTimelineSteps(root, timeline, index);
    $36ca57d25bbd719c$var$syncEventUrl(eventDate, {
        push: pushUrl
    });
    dayBtn.scrollIntoView({
        block: "nearest",
        behavior: $36ca57d25bbd719c$var$prefersReducedMotion() ? "auto" : "smooth"
    });
    $36ca57d25bbd719c$var$scrollMobileDayIntoView(root, eventDate);
}
function $36ca57d25bbd719c$var$stepTimeline(root, timeline, direction) {
    const currentIndex = $36ca57d25bbd719c$var$getSelectedTimelineIndex(root, timeline);
    const startIndex = currentIndex < 0 ? 0 : currentIndex;
    const delta = direction === "prev" ? -1 : 1;
    const nextIndex = startIndex + delta;
    if (nextIndex < 0 || nextIndex >= timeline.length) return;
    $36ca57d25bbd719c$var$activateTimelineIndex(root, timeline, nextIndex, direction === "prev" ? "prev" : "next", {
        pushUrl: true
    });
}
const $36ca57d25bbd719c$var$SWIPE_MIN_DISTANCE = 48;
const $36ca57d25bbd719c$var$SWIPE_AXIS_RATIO = 1.25;
const $36ca57d25bbd719c$var$MOBILE_LAYOUT_MQ = "(max-width: 599px)";
function $36ca57d25bbd719c$var$bindEventsCalendarSwipe(root, timeline) {
    if (window.matchMedia($36ca57d25bbd719c$var$MOBILE_LAYOUT_MQ).matches) return;
    const swipeEl = root.querySelector(".fullpage-events-calendar__detail");
    if (!swipeEl) return;
    let startX = 0;
    let startY = 0;
    let tracking = false;
    let horizontalSwipe = false;
    const resetSwipe = ()=>{
        tracking = false;
        horizontalSwipe = false;
        swipeEl.classList.remove("is-swipe-tracking");
    };
    const onPointerDown = (event)=>{
        if (event.pointerType === "mouse" && event.button !== 0) return;
        if (event.target.closest("a, button")) return;
        startX = event.clientX;
        startY = event.clientY;
        tracking = true;
        horizontalSwipe = false;
    };
    const onPointerMove = (event)=>{
        if (!tracking || horizontalSwipe) return;
        const deltaX = event.clientX - startX;
        const deltaY = event.clientY - startY;
        if (Math.abs(deltaX) < 8 && Math.abs(deltaY) < 8) return;
        if (Math.abs(deltaY) > Math.abs(deltaX) * $36ca57d25bbd719c$var$SWIPE_AXIS_RATIO) {
            resetSwipe();
            return;
        }
        if (Math.abs(deltaX) > Math.abs(deltaY) * $36ca57d25bbd719c$var$SWIPE_AXIS_RATIO) {
            horizontalSwipe = true;
            swipeEl.classList.add("is-swipe-tracking");
        }
    };
    const onPointerUp = (event)=>{
        if (!tracking) return;
        const deltaX = event.clientX - startX;
        const deltaY = event.clientY - startY;
        const shouldSwipe = horizontalSwipe && Math.abs(deltaX) >= $36ca57d25bbd719c$var$SWIPE_MIN_DISTANCE && Math.abs(deltaX) > Math.abs(deltaY);
        resetSwipe();
        if (!shouldSwipe) return;
        $36ca57d25bbd719c$var$stepTimeline(root, timeline, deltaX < 0 ? "next" : "prev");
    };
    swipeEl.addEventListener("pointerdown", onPointerDown, {
        passive: true
    });
    swipeEl.addEventListener("pointermove", onPointerMove, {
        passive: true
    });
    swipeEl.addEventListener("pointerup", onPointerUp, {
        passive: true
    });
    swipeEl.addEventListener("pointercancel", onPointerUp, {
        passive: true
    });
}
function $36ca57d25bbd719c$var$resolveEventFromUrl(root) {
    const { section: section, eventDate: eventDate } = (0, $4d818be9d2a947c9$export$1e599d6a6868163a)();
    if (section !== (0, $4d818be9d2a947c9$export$d2bceb3c11396000) || !eventDate) return null;
    const timeline = $36ca57d25bbd719c$var$getTimeline(root);
    if (!timeline.includes(eventDate)) return null;
    const dayBtn = root.querySelector(`.fullpage-events-calendar__day-btn[data-event-date="${eventDate}"], .fullpage-events-calendar__mobile-day-btn[data-event-date="${eventDate}"]`);
    return {
        eventDate: eventDate,
        month: dayBtn?.dataset.month || root.dataset.initialMonth
    };
}
function $36ca57d25bbd719c$var$resolveDefaultSelection(root) {
    const today = root.dataset.calendarToday;
    const todayBtn = today ? root.querySelector(`.fullpage-events-calendar__day-btn[data-event-date="${today}"], .fullpage-events-calendar__mobile-day-btn[data-event-date="${today}"]`) : null;
    if (todayBtn?.dataset.eventDate) return {
        eventDate: todayBtn.dataset.eventDate,
        month: todayBtn.dataset.month || root.dataset.initialMonth
    };
    return {
        eventDate: root.dataset.initialEventDate,
        month: root.dataset.initialMonth
    };
}
function $36ca57d25bbd719c$var$resolveInitialSelection(root) {
    const fromUrl = $36ca57d25bbd719c$var$resolveEventFromUrl(root);
    if (fromUrl) return fromUrl;
    return $36ca57d25bbd719c$var$resolveDefaultSelection(root);
}
function $36ca57d25bbd719c$var$resetCalendarToDefault(root, { forceUrl: forceUrl = false } = {}) {
    const timeline = $36ca57d25bbd719c$var$getTimeline(root);
    const { eventDate: eventDate, month: month } = $36ca57d25bbd719c$var$resolveDefaultSelection(root);
    if (month) $36ca57d25bbd719c$var$expandMonth(root, month, {
        animate: false
    });
    if (!eventDate) return;
    $36ca57d25bbd719c$var$applyInstantEvent(root, eventDate);
    const index = timeline.indexOf(String(eventDate));
    $36ca57d25bbd719c$var$updateTimelineSteps(root, timeline, index >= 0 ? index : 0);
    $36ca57d25bbd719c$var$syncEventUrl(eventDate, {
        force: forceUrl
    });
}
function $36ca57d25bbd719c$var$activateEventDateInstant(root, timeline, eventDate) {
    const dayBtn = root.querySelector(`.fullpage-events-calendar__day-btn[data-event-date="${eventDate}"], .fullpage-events-calendar__mobile-day-btn[data-event-date="${eventDate}"]`);
    if (dayBtn?.dataset.month) $36ca57d25bbd719c$var$expandMonth(root, dayBtn.dataset.month, {
        animate: false
    });
    $36ca57d25bbd719c$var$applyInstantEvent(root, eventDate);
    $36ca57d25bbd719c$var$updateTimelineSteps(root, timeline, timeline.indexOf(String(eventDate)));
}
function $36ca57d25bbd719c$var$handleEventsSlideEnter() {
    document.querySelectorAll("[data-events-calendar]").forEach((root)=>{
        const { eventDate: eventDate } = (0, $4d818be9d2a947c9$export$1e599d6a6868163a)();
        const timeline = $36ca57d25bbd719c$var$getTimeline(root);
        if (eventDate && timeline.includes(eventDate)) {
            $36ca57d25bbd719c$var$activateEventDateInstant(root, timeline, eventDate);
            $36ca57d25bbd719c$var$syncEventUrl(eventDate, {
                force: true
            });
            return;
        }
        $36ca57d25bbd719c$var$resetCalendarToDefault(root, {
            forceUrl: true
        });
    });
}
function $36ca57d25bbd719c$var$syncEventUrl(eventDate, { push: push = false, force: force = false } = {}) {
    if (!eventDate || !force && !(0, $4d818be9d2a947c9$export$c4b15044a3a84c83)()) return;
    (0, $4d818be9d2a947c9$export$ca711c785b7c4274)(eventDate, {
        push: push
    });
}
function $36ca57d25bbd719c$var$initCalendarRoot(root) {
    const timeline = $36ca57d25bbd719c$var$getTimeline(root);
    const { eventDate: eventDate, month: month } = $36ca57d25bbd719c$var$resolveInitialSelection(root);
    if (month) $36ca57d25bbd719c$var$expandMonth(root, month, {
        animate: false
    });
    if (eventDate) {
        $36ca57d25bbd719c$var$applyInstantEvent(root, eventDate);
        $36ca57d25bbd719c$var$syncEventUrl(eventDate);
    }
    const initialIndex = $36ca57d25bbd719c$var$getSelectedTimelineIndex(root, timeline);
    $36ca57d25bbd719c$var$updateTimelineSteps(root, timeline, initialIndex < 0 ? 0 : initialIndex);
    $36ca57d25bbd719c$var$updateMobileMonthSteps(root);
    const bindTimelineStep = (btn)=>{
        btn.addEventListener("click", ()=>{
            if (btn.disabled) return;
            $36ca57d25bbd719c$var$stepTimeline(root, timeline, btn.dataset.direction);
        });
    };
    root.querySelectorAll(".fullpage-events-calendar__timeline-step").forEach(bindTimelineStep);
    root.querySelectorAll(".fullpage-events-calendar__mobile-month-step").forEach((btn)=>{
        btn.addEventListener("click", ()=>{
            if (btn.disabled) return;
            $36ca57d25bbd719c$var$stepMobileMonth(root, timeline, btn.dataset.direction);
        });
    });
    root.querySelectorAll(".fullpage-events-calendar__mobile-day-btn").forEach((btn)=>{
        btn.addEventListener("click", ()=>{
            const { month: monthKey, eventDate: date } = btn.dataset;
            if (monthKey) $36ca57d25bbd719c$var$expandMonth(root, monthKey);
            const direction = $36ca57d25bbd719c$var$getTransitionDirection(root, timeline, date);
            $36ca57d25bbd719c$var$selectEvent(root, date, direction);
            $36ca57d25bbd719c$var$updateTimelineSteps(root, timeline, $36ca57d25bbd719c$var$getSelectedTimelineIndex(root, timeline));
            $36ca57d25bbd719c$var$syncEventUrl(date, {
                push: true
            });
        });
    });
    root.querySelectorAll(".fullpage-events-calendar__year-btn").forEach((btn)=>{
        btn.addEventListener("click", ()=>{
            const { year: year } = btn.dataset;
            if (year) $36ca57d25bbd719c$var$toggleYear(root, year);
        });
    });
    root.querySelectorAll(".fullpage-events-calendar__month-btn").forEach((btn)=>{
        btn.addEventListener("click", ()=>{
            if (btn.getAttribute("aria-disabled") === "true") return;
            const { month: monthKey } = btn.dataset;
            $36ca57d25bbd719c$var$expandMonth(root, monthKey);
            const days = btn.parentElement?.querySelector(".fullpage-events-calendar__days");
            const selected = days?.querySelector(".fullpage-events-calendar__day-btn.is-selected");
            const target = selected || days?.querySelector(".fullpage-events-calendar__day-btn");
            if (target) {
                const direction = $36ca57d25bbd719c$var$getTransitionDirection(root, timeline, target.dataset.eventDate);
                $36ca57d25bbd719c$var$selectEvent(root, target.dataset.eventDate, direction);
                $36ca57d25bbd719c$var$updateTimelineSteps(root, timeline, $36ca57d25bbd719c$var$getSelectedTimelineIndex(root, timeline));
                $36ca57d25bbd719c$var$syncEventUrl(target.dataset.eventDate, {
                    push: true
                });
            }
        });
    });
    root.querySelectorAll(".fullpage-events-calendar__day-btn").forEach((btn)=>{
        btn.addEventListener("click", ()=>{
            const { month: monthKey, eventDate: eventDate } = btn.dataset;
            if (monthKey) $36ca57d25bbd719c$var$expandMonth(root, monthKey);
            const direction = $36ca57d25bbd719c$var$getTransitionDirection(root, timeline, eventDate);
            $36ca57d25bbd719c$var$selectEvent(root, eventDate, direction);
            $36ca57d25bbd719c$var$updateTimelineSteps(root, timeline, $36ca57d25bbd719c$var$getSelectedTimelineIndex(root, timeline));
            $36ca57d25bbd719c$var$syncEventUrl(eventDate, {
                push: true
            });
        });
    });
    $36ca57d25bbd719c$var$bindEventsCalendarSwipe(root, timeline);
}
function $36ca57d25bbd719c$var$bindEventsCalendarUrlSync() {
    window.addEventListener("popstate", ()=>{
        const { section: section, eventDate: eventDate } = (0, $4d818be9d2a947c9$export$1e599d6a6868163a)();
        if (section !== (0, $4d818be9d2a947c9$export$d2bceb3c11396000) || !eventDate) return;
        document.querySelectorAll("[data-events-calendar]").forEach((root)=>{
            const timeline = $36ca57d25bbd719c$var$getTimeline(root);
            if (timeline.includes(eventDate)) $36ca57d25bbd719c$var$activateEventDateInstant(root, timeline, eventDate);
        });
    });
}
function $36ca57d25bbd719c$var$bindEventsCalendarSlideReset() {
    document.addEventListener("paaadel:fullpage-slide-change", (event)=>{
        const section = event.detail?.section || "";
        const previousSection = event.detail?.previousSection || "";
        if (section === (0, $4d818be9d2a947c9$export$d2bceb3c11396000) && previousSection !== "" && previousSection !== (0, $4d818be9d2a947c9$export$d2bceb3c11396000)) $36ca57d25bbd719c$var$handleEventsSlideEnter();
    });
}
function $36ca57d25bbd719c$export$af137d648998e40a() {
    document.querySelectorAll("[data-events-calendar]").forEach($36ca57d25bbd719c$var$initCalendarRoot);
    $36ca57d25bbd719c$var$bindEventsCalendarUrlSync();
    $36ca57d25bbd719c$var$bindEventsCalendarSlideReset();
}


const $dab25f6bffbf3aff$var$STORAGE_KEY = 'paaadel-high-contrast';
function $dab25f6bffbf3aff$var$readStoredPreference() {
    try {
        return localStorage.getItem($dab25f6bffbf3aff$var$STORAGE_KEY) === '1';
    } catch  {
        return false;
    }
}
function $dab25f6bffbf3aff$var$storePreference(active) {
    try {
        localStorage.setItem($dab25f6bffbf3aff$var$STORAGE_KEY, active ? '1' : '0');
    } catch  {
    // Ignore private browsing / blocked storage.
    }
}
function $dab25f6bffbf3aff$var$applyHighContrast(active) {
    document.documentElement.classList.toggle('is-high-contrast', active);
}
function $dab25f6bffbf3aff$var$updateToggleButton(btn, active) {
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    btn.classList.toggle('is-active', active);
}
function $dab25f6bffbf3aff$export$1e012be753e24e27() {
    const btn = document.querySelector('[data-high-contrast-toggle]');
    if (!btn) return;
    const initial = $dab25f6bffbf3aff$var$readStoredPreference();
    $dab25f6bffbf3aff$var$applyHighContrast(initial);
    $dab25f6bffbf3aff$var$updateToggleButton(btn, initial);
    btn.addEventListener('click', ()=>{
        const next = !document.documentElement.classList.contains('is-high-contrast');
        $dab25f6bffbf3aff$var$applyHighContrast(next);
        $dab25f6bffbf3aff$var$updateToggleButton(btn, next);
        $dab25f6bffbf3aff$var$storePreference(next);
    });
}



const $d0a03c0d86ca61f0$var$LOCATIONS_NAV_REVEAL_DELAY_MS = 380;
let $d0a03c0d86ca61f0$var$locationsNavRevealTimer = null;
function $d0a03c0d86ca61f0$var$prefersReducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}
function $d0a03c0d86ca61f0$var$clearLocationsNavRevealTimer() {
    if ($d0a03c0d86ca61f0$var$locationsNavRevealTimer) {
        window.clearTimeout($d0a03c0d86ca61f0$var$locationsNavRevealTimer);
        $d0a03c0d86ca61f0$var$locationsNavRevealTimer = null;
    }
}
function $d0a03c0d86ca61f0$var$resetLocationsNavReveal() {
    $d0a03c0d86ca61f0$var$clearLocationsNavRevealTimer();
    document.querySelectorAll(".fullpage-slide__locations-nav").forEach((nav)=>{
        nav.classList.remove("is-revealed", "is-hint-dismissed");
    });
}
function $d0a03c0d86ca61f0$var$dismissLocationsNavHint() {
    const nav = document.querySelector(".fullpage-slide--locations .fullpage-slide__locations-nav");
    nav?.classList.add("is-hint-dismissed");
}
function $d0a03c0d86ca61f0$var$revealLocationsNav() {
    const nav = document.querySelector(".fullpage-slide--locations .fullpage-slide__locations-nav");
    if (!nav || nav.classList.contains("is-revealed")) return;
    $d0a03c0d86ca61f0$var$clearLocationsNavRevealTimer();
    nav.classList.remove("is-revealed");
    // Force the off-screen start state before revealing.
    nav.offsetWidth;
    const delay = $d0a03c0d86ca61f0$var$prefersReducedMotion() ? 0 : $d0a03c0d86ca61f0$var$LOCATIONS_NAV_REVEAL_DELAY_MS;
    $d0a03c0d86ca61f0$var$locationsNavRevealTimer = window.setTimeout(()=>{
        $d0a03c0d86ca61f0$var$locationsNavRevealTimer = null;
        if ((0, $4d818be9d2a947c9$export$e82457802ace98a7)()) nav.classList.add("is-revealed");
    }, delay);
}
function $d0a03c0d86ca61f0$var$bindLocationsNavReveal() {
    document.addEventListener("paaadel:fullpage-slide-change", (event)=>{
        const section = event.detail?.section || "";
        const previousSection = event.detail?.previousSection || "";
        if (section !== (0, $4d818be9d2a947c9$export$ccf5cae033ed6aca)) {
            $d0a03c0d86ca61f0$var$resetLocationsNavReveal();
            return;
        }
        if (previousSection !== "" && previousSection !== (0, $4d818be9d2a947c9$export$ccf5cae033ed6aca)) $d0a03c0d86ca61f0$var$revealLocationsNav();
    });
    if ((0, $4d818be9d2a947c9$export$e82457802ace98a7)()) $d0a03c0d86ca61f0$var$revealLocationsNav();
}
function $d0a03c0d86ca61f0$var$getVisualPanels(root) {
    return Array.from(root.querySelectorAll("[data-locations-visual-panel]"));
}
function $d0a03c0d86ca61f0$var$getNamePanels(root) {
    return Array.from(root.querySelectorAll("[data-locations-name-panel]"));
}
function $d0a03c0d86ca61f0$var$getLocationIdForIndex(root, index) {
    const panels = $d0a03c0d86ca61f0$var$getNamePanels(root);
    const panel = panels[index];
    return panel?.dataset.locationId || String(index);
}
function $d0a03c0d86ca61f0$var$resolveLocationIndex(root, locationId) {
    if (!locationId) return 0;
    const panels = $d0a03c0d86ca61f0$var$getNamePanels(root);
    const decoded = decodeURIComponent(locationId);
    const bySlug = panels.findIndex((panel)=>panel.dataset.locationId === decoded);
    if (bySlug >= 0) return bySlug;
    const asIndex = Number.parseInt(decoded, 10);
    if (Number.isFinite(asIndex) && asIndex >= 0 && asIndex < panels.length) return asIndex;
    return 0;
}
function $d0a03c0d86ca61f0$var$resolveLocationIndexFromUrl(root) {
    const { section: section, locationId: locationId } = (0, $4d818be9d2a947c9$export$1e599d6a6868163a)();
    if (section !== (0, $4d818be9d2a947c9$export$ccf5cae033ed6aca) || !locationId) return null;
    return $d0a03c0d86ca61f0$var$resolveLocationIndex(root, locationId);
}
function $d0a03c0d86ca61f0$var$setPanelState(panel, active) {
    panel.classList.toggle("is-active", active);
    panel.hidden = !active;
}
function $d0a03c0d86ca61f0$var$syncLocationsUrl(root, { push: push = false, force: force = false } = {}) {
    if (!force && !(0, $4d818be9d2a947c9$export$e82457802ace98a7)()) return;
    const index = Number.parseInt(root.dataset.locationsIndex || "0", 10);
    const locationId = $d0a03c0d86ca61f0$var$getLocationIdForIndex(root, index);
    (0, $4d818be9d2a947c9$export$a89e6d7987f5b72)(locationId, {
        push: push
    });
}
function $d0a03c0d86ca61f0$var$setCarouselIndex(root, nextIndex, { updateUrl: updateUrl = true, push: push = false, forceUrl: forceUrl = false } = {}) {
    const visualPanels = $d0a03c0d86ca61f0$var$getVisualPanels(root);
    const namePanels = $d0a03c0d86ca61f0$var$getNamePanels(root);
    const count = visualPanels.length;
    if (count <= 0) return;
    const normalized = (nextIndex % count + count) % count;
    visualPanels.forEach((panel, index)=>{
        $d0a03c0d86ca61f0$var$setPanelState(panel, index === normalized);
    });
    namePanels.forEach((panel, index)=>{
        $d0a03c0d86ca61f0$var$setPanelState(panel, index === normalized);
    });
    root.dataset.locationsIndex = String(normalized);
    if (updateUrl) $d0a03c0d86ca61f0$var$syncLocationsUrl(root, {
        push: push,
        force: forceUrl || (0, $4d818be9d2a947c9$export$e82457802ace98a7)()
    });
}
function $d0a03c0d86ca61f0$var$stepCarousel(root, direction) {
    const count = $d0a03c0d86ca61f0$var$getVisualPanels(root).length;
    if (count <= 1) return;
    const current = Number.parseInt(root.dataset.locationsIndex || "0", 10);
    const delta = direction === "prev" ? -1 : 1;
    $d0a03c0d86ca61f0$var$setCarouselIndex(root, current + delta, {
        push: true,
        forceUrl: true
    });
}
function $d0a03c0d86ca61f0$var$bindCarousel(root) {
    if (root.dataset.locationsCarouselBound === "true") return;
    const count = $d0a03c0d86ca61f0$var$getVisualPanels(root).length;
    if (count <= 1) return;
    root.dataset.locationsCarouselBound = "true";
    root.addEventListener("click", (event)=>{
        const button = event.target.closest("[data-locations-direction]");
        if (!button || !root.contains(button)) return;
        event.preventDefault();
        $d0a03c0d86ca61f0$var$dismissLocationsNavHint();
        $d0a03c0d86ca61f0$var$stepCarousel(root, button.dataset.locationsDirection);
    });
}
function $d0a03c0d86ca61f0$var$handleLocationsSlideEnter() {
    document.querySelectorAll("[data-locations-carousel]").forEach((root)=>{
        const fromUrl = $d0a03c0d86ca61f0$var$resolveLocationIndexFromUrl(root);
        if (fromUrl !== null) {
            $d0a03c0d86ca61f0$var$setCarouselIndex(root, fromUrl, {
                updateUrl: true,
                forceUrl: true
            });
            return;
        }
        const index = Number.parseInt(root.dataset.locationsIndex || "0", 10);
        $d0a03c0d86ca61f0$var$setCarouselIndex(root, index, {
            updateUrl: true,
            forceUrl: true
        });
    });
}
function $d0a03c0d86ca61f0$var$applyLocationFromHash() {
    const { section: section, locationId: locationId } = (0, $4d818be9d2a947c9$export$1e599d6a6868163a)();
    if (section !== (0, $4d818be9d2a947c9$export$ccf5cae033ed6aca) || !locationId || !(0, $4d818be9d2a947c9$export$e82457802ace98a7)()) return;
    document.querySelectorAll("[data-locations-carousel]").forEach((root)=>{
        const index = $d0a03c0d86ca61f0$var$resolveLocationIndex(root, locationId);
        $d0a03c0d86ca61f0$var$setCarouselIndex(root, index, {
            updateUrl: false
        });
    });
}
function $d0a03c0d86ca61f0$var$bindLocationsUrlSync() {
    window.addEventListener("popstate", $d0a03c0d86ca61f0$var$applyLocationFromHash);
    window.addEventListener("hashchange", $d0a03c0d86ca61f0$var$applyLocationFromHash);
}
function $d0a03c0d86ca61f0$var$bindLocationsSlideEnter() {
    document.addEventListener("paaadel:fullpage-slide-change", (event)=>{
        const section = event.detail?.section || "";
        const previousSection = event.detail?.previousSection || "";
        if (section === (0, $4d818be9d2a947c9$export$ccf5cae033ed6aca) && previousSection !== "" && previousSection !== (0, $4d818be9d2a947c9$export$ccf5cae033ed6aca)) $d0a03c0d86ca61f0$var$handleLocationsSlideEnter();
    });
}
function $d0a03c0d86ca61f0$var$initLocationsRoot(root) {
    $d0a03c0d86ca61f0$var$bindCarousel(root);
    const fromUrl = $d0a03c0d86ca61f0$var$resolveLocationIndexFromUrl(root);
    const fallback = Number.parseInt(root.dataset.locationsIndex || "0", 10);
    const initialIndex = fromUrl !== null ? fromUrl : fallback;
    $d0a03c0d86ca61f0$var$setCarouselIndex(root, initialIndex, {
        updateUrl: fromUrl !== null || (0, $4d818be9d2a947c9$export$e82457802ace98a7)(),
        forceUrl: fromUrl !== null
    });
}
function $d0a03c0d86ca61f0$export$e2d348f2c7f2de5() {
    document.querySelectorAll("[data-locations-carousel]").forEach($d0a03c0d86ca61f0$var$initLocationsRoot);
    $d0a03c0d86ca61f0$var$bindLocationsUrlSync();
    $d0a03c0d86ca61f0$var$bindLocationsSlideEnter();
    $d0a03c0d86ca61f0$var$bindLocationsNavReveal();
}


document.addEventListener('DOMContentLoaded', ()=>{
    (0, $dab25f6bffbf3aff$export$1e012be753e24e27)();
    (0, $9dca141bdfb65599$export$f3669b2164ce2daf)();
    (0, $36ca57d25bbd719c$export$af137d648998e40a)();
    (0, $d0a03c0d86ca61f0$export$e2d348f2c7f2de5)();
});

})();
//# sourceMappingURL=index.6b44c656.js.map
